(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[503],{

/***/ 88055:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swap",
      function () {
        return __webpack_require__(66679);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Widget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/functions/index.ts + 3 modules
var functions = __webpack_require__(83554);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Container/index.tsx



const TailwindMapper = {
    full: "max-w-full",
    "7xl": "max-w-7xl",
    "6xl": "max-w-6xl",
    "5xl": "max-w-5xl",
    "4xl": "max-w-4xl",
    "3xl": "max-w-3xl",
    "2xl": "max-w-2xl",
    xl: "max-w-xl",
    lg: "max-w-lg",
    md: "max-w-md",
    sm: "max-w-sm",
    xs: "max-w-xs"
};
const Container = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { as , children , maxWidth ="2xl" , className ="" , id , ...rest } = param;
    const Component = as || "div";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        ref: ref,
        className: (0,functions/* classNames */.AK)(className, typeof maxWidth === "number" ? "" : TailwindMapper[maxWidth], "w-full"),
        id: id,
        ...(typeof maxWidth === "number" || rest.style) && {
            style: {
                ...rest.style,
                maxWidth
            }
        },
        ...rest,
        children: children
    });
});
/* harmony default export */ var components_Container = ((/* unused pure expression or super */ null && (Container)));

;// CONCATENATED MODULE: ./src/components/Widget/WidgetContent.tsx

const WidgetContent = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Widget/WidgetHeader.tsx


const WidgetHeader = (param)=>{
    let { title , children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,functions/* classNames */.AK)(className, "p-3 mx-0.5 grid grid-cols-2 items-center pb-4 font-medium"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "flex items-center gap-2 font-medium text-slate-100 hover:text-slate-200",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-end",
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Widget/Widget.tsx





const WidgetRoot = (param)=>{
    let { id , className ="" , maxWidth , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        as: "article",
        id: id,
        ...typeof maxWidth === "string" && {
            maxWidth
        },
        style: {
            ...typeof maxWidth === "number" && {
                maxWidth
            }
        },
        className: (0,functions/* classNames */.AK)(className, "flex flex-col mx-auto rounded-2xl relative overflow-hidden "),
        children: children
    });
};
const Widget = Object.assign(WidgetRoot, {
    Header: WidgetHeader,
    Content: WidgetContent
});

;// CONCATENATED MODULE: ./src/components/Widget/index.ts



/***/ }),

/***/ 63378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gw": function() { return /* binding */ SUPPORTED_CHAINS; },
/* harmony export */   "dK": function() { return /* binding */ EXCHANGE; },
/* harmony export */   "qf": function() { return /* binding */ GRAPH_HOST; }
/* harmony export */ });
/* harmony import */ var _emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38489);

const EXCHANGE = {
    [_emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.SMARTBCH */ .a_.SMARTBCH]: "emberswap/subgraphv2"
};
const GRAPH_HOST = {
    [_emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.SMARTBCH */ .a_.SMARTBCH]: "http://localhost:8000"
};
const SUPPORTED_CHAINS = [
    _emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.SMARTBCH */ .a_.SMARTBCH
] // supported chains
;


/***/ }),

/***/ 66679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Swap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/constants/index.mjs
var constants = __webpack_require__(34534);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/entities/index.mjs
var entities = __webpack_require__(79334);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/enums/index.mjs
var enums = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/functions/index.mjs + 3 modules
var functions = __webpack_require__(88610);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/address/isAddress.js
var isAddress = __webpack_require__(97451);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 7 modules
var useTranslation = __webpack_require__(26524);
// EXTERNAL MODULE: ./src/constants/graphql/index.ts
var graphql = __webpack_require__(63378);
// EXTERNAL MODULE: ./src/functions/index.ts + 3 modules
var src_functions = __webpack_require__(83554);
// EXTERNAL MODULE: ./src/hooks/index.ts + 1 modules
var hooks = __webpack_require__(87808);
// EXTERNAL MODULE: ./src/state/chart/hooks.ts
var chart_hooks = __webpack_require__(91136);
// EXTERNAL MODULE: ./src/components/Icons/index.tsx + 54 modules
var Icons = __webpack_require__(66739);
// EXTERNAL MODULE: ./src/components/Loader/index.tsx + 2 modules
var Loader = __webpack_require__(62817);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/components/Resizable/resizer.tsx


const rowSizeBase = {
    width: "100%",
    height: "10px",
    top: "0px",
    left: "0px",
    cursor: "row-resize"
};
const colSizeBase = {
    width: "10px",
    height: "100%",
    top: "0px",
    left: "0px",
    cursor: "col-resize"
};
const edgeBase = {
    width: "20px",
    height: "20px",
    position: "absolute"
};
const styles = {
    top: {
        ...rowSizeBase,
        top: "-5px"
    },
    right: {
        ...colSizeBase,
        left: undefined,
        right: "-5px"
    },
    bottom: {
        ...rowSizeBase,
        top: undefined,
        bottom: "-5px"
    },
    left: {
        ...colSizeBase,
        left: "-5px"
    },
    topRight: {
        ...edgeBase,
        right: "-10px",
        top: "-10px",
        cursor: "ne-resize"
    },
    bottomRight: {
        ...edgeBase,
        right: "-10px",
        bottom: "-10px",
        cursor: "se-resize"
    },
    bottomLeft: {
        ...edgeBase,
        left: "-10px",
        bottom: "-10px",
        cursor: "sw-resize"
    },
    topLeft: {
        ...edgeBase,
        left: "-10px",
        top: "-10px",
        cursor: "nw-resize"
    }
};
/**
 * @param { React.MouseEvent<HTMLDivElement>} e
 */ class Resizer extends react.PureComponent {
    /**
   * @return {JSX.Element}
   */ render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: this.props.className || "",
            style: {
                position: "absolute",
                userSelect: "none",
                ...styles[this.props.direction],
                ...this.props.replaceStyles || {}
            },
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.onMouseDown = (e)=>{
            this.props.onResizeStart(e, this.props.direction);
        };
        this.onTouchStart = (e)=>{
            this.props.onResizeStart(e, this.props.direction);
        };
    }
}

;// CONCATENATED MODULE: ./src/components/Resizable/index.tsx




const clamp = (n, min, max)=>Math.max(Math.min(n, max), min);
const snap = (n, size)=>Math.round(n / size) * size;
const hasDirection = (dir, target)=>new RegExp(dir, "i").test(target);
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
const isTouchEvent = (event)=>{
    return Boolean(event.touches && event.touches.length);
};
const isMouseEvent = (event)=>{
    return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
const findClosestSnap = function(n, snapArray) {
    let snapGap = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    const closestGapIndex = snapArray.reduce((prev, curr, index)=>Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev, 0);
    const gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
};
const getStringSize = (n)=>{
    n = n.toString();
    if (n === "auto") {
        return n;
    }
    if (n.endsWith("px")) {
        return n;
    }
    if (n.endsWith("%")) {
        return n;
    }
    if (n.endsWith("vh")) {
        return n;
    }
    if (n.endsWith("vw")) {
        return n;
    }
    if (n.endsWith("vmax")) {
        return n;
    }
    if (n.endsWith("vmin")) {
        return n;
    }
    return "".concat(n, "px");
};
const getPixelSize = (size, parentSize, innerWidth, innerHeight)=>{
    if (size && typeof size === "string") {
        if (size.endsWith("px")) {
            return Number(size.replace("px", ""));
        }
        if (size.endsWith("%")) {
            const ratio = Number(size.replace("%", "")) / 100;
            return parentSize * ratio;
        }
        if (size.endsWith("vw")) {
            const ratio1 = Number(size.replace("vw", "")) / 100;
            return innerWidth * ratio1;
        }
        if (size.endsWith("vh")) {
            const ratio2 = Number(size.replace("vh", "")) / 100;
            return innerHeight * ratio2;
        }
    }
    return size;
};
const calculateNewMax = (parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight)=>{
    maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === "undefined" ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === "undefined" ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === "undefined" ? undefined : Number(minWidth),
        minHeight: typeof minHeight === "undefined" ? undefined : Number(minHeight)
    };
};
const definedProps = [
    "as",
    "style",
    "className",
    "grid",
    "snap",
    "bounds",
    "boundsByDirection",
    "size",
    "defaultSize",
    "minWidth",
    "minHeight",
    "maxWidth",
    "maxHeight",
    "lockAspectRatio",
    "lockAspectRatioExtraWidth",
    "lockAspectRatioExtraHeight",
    "enable",
    "handleStyles",
    "handleClasses",
    "handleWrapperStyle",
    "handleWrapperClass",
    "children",
    "onResizeStart",
    "onResize",
    "onResizeStop",
    "handleComponent",
    "scale",
    "resizeRatio",
    "snapGap"
];
// HACK: This class is used to calculate % size.
const baseClassName = "__resizable_base__";
var _PureComponent;
// eslint-disable-next-line valid-jsdoc
/** ResizableProps */ class Resizable extends (_PureComponent = react.PureComponent) {
    /**
   *
   */ get parentNode() {
        if (!this.resizable) {
            return null;
        }
        return this.resizable.parentNode;
    }
    /**
   *
   */ get window() {
        if (!this.resizable) {
            return null;
        }
        if (!this.resizable.ownerDocument) {
            return null;
        }
        return this.resizable.ownerDocument.defaultView;
    }
    /**
   * @return {Size}
   */ get propsSize() {
        return this.props.size || this.props.defaultSize;
    }
    /**
   *
   */ get size() {
        let width = 0;
        let height = 0;
        if (this.resizable && this.window) {
            const orgWidth = this.resizable.offsetWidth;
            const orgHeight = this.resizable.offsetHeight;
            // HACK: Set position `relative` to get parent size.
            //       This is because when re-resizable set `absolute`, I can not get base width correctly.
            const orgPosition = this.resizable.style.position;
            if (orgPosition !== "relative") {
                this.resizable.style.position = "relative";
            }
            // INFO: Use original width or height if set auto.
            width = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : orgWidth;
            height = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : orgHeight;
            // Restore original position
            this.resizable.style.position = orgPosition;
        }
        return {
            width,
            height
        };
    }
    /**
   *
   */ get sizeStyle() {
        const { size  } = this.props;
        const getSize = (key)=>{
            var ref, ref1;
            if (this.state[key] === "auto") {
                return "auto";
            }
            if (typeof this.state[key] === "undefined") {
                return "undefined";
            }
            if (this.propsSize && this.propsSize[key] && ((ref = this.propsSize) === null || ref === void 0 ? void 0 : (ref1 = ref[key]) === null || ref1 === void 0 ? void 0 : ref1.toString().endsWith("%"))) {
                var ref2;
                if (this.state[key].toString().endsWith("%")) {
                    return this.state[key].toString();
                }
                const parentSize = this.getParentSize();
                const value = Number((ref2 = this.state[key]) === null || ref2 === void 0 ? void 0 : ref2.toString().replace("px", ""));
                const percent = value / parentSize[key] * 100;
                return "".concat(percent, "%");
            }
            return getStringSize(this.state[key]);
        };
        const width = size && typeof size.width !== "undefined" && !this.state.isResizing ? getStringSize(size.width) : getSize("width");
        const height = size && typeof size.height !== "undefined" && !this.state.isResizing ? getStringSize(size.height) : getSize("height");
        return {
            width,
            height
        };
    }
    /**
   * @return {{number,number}}
   */ getParentSize() {
        if (!this.parentNode) {
            if (!this.window) {
                return {
                    width: 0,
                    height: 0
                };
            }
            return {
                width: this.window.innerWidth,
                height: this.window.innerHeight
            };
        }
        const base = this.appendBase();
        if (!base) {
            return {
                width: 0,
                height: 0
            };
        }
        // INFO: To calculate parent width with flex layout
        let wrapChanged = false;
        const wrap = this.parentNode.style.flexWrap;
        if (wrap !== "wrap") {
            wrapChanged = true;
            this.parentNode.style.flexWrap = "wrap";
        // HACK: Use relative to get parent padding size
        }
        base.style.position = "relative";
        base.style.minWidth = "100%";
        base.style.minHeight = "100%";
        const size = {
            width: base.offsetWidth,
            height: base.offsetHeight
        };
        if (wrapChanged) {
            this.parentNode.style.flexWrap = wrap;
        }
        this.removeBase(base);
        return size;
    }
    /**
   *
   */ bindEvents() {
        if (this.window) {
            this.window.addEventListener("mouseup", this.onMouseUp);
            this.window.addEventListener("mousemove", this.onMouseMove);
            this.window.addEventListener("mouseleave", this.onMouseUp);
            this.window.addEventListener("touchmove", this.onMouseMove, {
                capture: true,
                passive: false
            });
            this.window.addEventListener("touchend", this.onMouseUp);
        }
    }
    /**
   *
   */ unbindEvents() {
        if (this.window) {
            this.window.removeEventListener("mouseup", this.onMouseUp);
            this.window.removeEventListener("mousemove", this.onMouseMove);
            this.window.removeEventListener("mouseleave", this.onMouseUp);
            this.window.removeEventListener("touchmove", this.onMouseMove, true);
            this.window.removeEventListener("touchend", this.onMouseUp);
        }
    }
    /**
   *
   */ componentDidMount() {
        if (!this.resizable || !this.window) {
            return;
        }
        const computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== "auto" ? computedStyle.flexBasis : undefined
        });
    }
    /**
   *
   */ componentWillUnmount() {
        if (this.window) {
            this.unbindEvents();
        }
    }
    /**
   * @param {string | number} newSize
   * @param {string} kind
   * @return {number | string}
   */ createSizeForCssProperty(newSize, kind) {
        const propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === "auto" && this.state.original[kind] === newSize && propsSize === "auto" ? "auto" : newSize;
    }
    /**
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @return {{number, number}}
   */ calculateNewMaxFromBoundary(maxWidth, maxHeight) {
        const { boundsByDirection  } = this.props;
        const { direction  } = this.state;
        const widthByDirection = boundsByDirection && hasDirection("left", direction);
        const heightByDirection = boundsByDirection && hasDirection("top", direction);
        let boundWidth;
        let boundHeight;
        if (this.props.bounds === "parent") {
            const parent = this.parentNode;
            if (parent) {
                boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent.offsetHeight + (this.parentTop - this.resizableTop);
            }
        } else if (this.props.bounds === "window") {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        } else if (this.props.bounds) {
            boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) {
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        }
        if (boundHeight && Number.isFinite(boundHeight)) {
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth,
            maxHeight
        };
    }
    /**
   * @param {number}clientX
   * @param {number}clientY
   * @return {{number, number}}
   */ calculateNewSizeFromDirection(clientX, clientY) {
        const scale = this.props.scale || 1;
        const resizeRatio = this.props.resizeRatio || 1;
        const { direction , original  } = this.state;
        const { lockAspectRatio , lockAspectRatioExtraHeight , lockAspectRatioExtraWidth  } = this.props;
        let newWidth = original.width;
        let newHeight = original.height;
        const extraHeight = lockAspectRatioExtraHeight || 0;
        const extraWidth = lockAspectRatioExtraWidth || 0;
        if (hasDirection("right", direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection("left", direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection("bottom", direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        if (hasDirection("top", direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        return {
            newWidth,
            newHeight
        };
    }
    /**
   * @param {number} newWidth
   * @param {number} newHeight
   * @param {{number, number}} max
   * @param {{number, number}} min
   * @return {{number, number}}
   */ calculateNewSizeFromAspectRatio(newWidth, newHeight, max, min) {
        const { lockAspectRatio , lockAspectRatioExtraHeight , lockAspectRatioExtraWidth  } = this.props;
        const computedMinWidth = typeof min.width === "undefined" ? 10 : min.width;
        const computedMaxWidth = typeof max.width === "undefined" || max.width < 0 ? newWidth : max.width;
        const computedMinHeight = typeof min.height === "undefined" ? 10 : min.height;
        const computedMaxHeight = typeof max.height === "undefined" || max.height < 0 ? newHeight : max.height;
        const extraHeight = lockAspectRatioExtraHeight || 0;
        const extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            const extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            const extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            const extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            const extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            const lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            const lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            const lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            const lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth,
            newHeight
        };
    }
    /**
   *
   */ setBoundingClientRect() {
        // For parent boundary
        if (this.props.bounds === "parent") {
            const parent = this.parentNode;
            if (parent) {
                const parentRect = parent.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== "string") {
            const targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            const { left , top , right , bottom  } = this.resizable.getBoundingClientRect();
            this.resizableLeft = left;
            this.resizableRight = right;
            this.resizableTop = top;
            this.resizableBottom = bottom;
        }
    }
    /**
   * @param {React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>} event
   * @param {Direction} direction
   * @return {void}
   */ onResizeStart(event, direction) {
        if (!this.resizable || !this.window) {
            return;
        }
        let clientX = 0;
        let clientY = 0;
        if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        } else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                const startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) {
                    return;
                }
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== "undefined" && this.props.size.height !== this.state.height) {
                this.setState({
                    height: this.props.size.height
                });
            }
            if (typeof this.props.size.width !== "undefined" && this.props.size.width !== this.state.width) {
                this.setState({
                    width: this.props.size.width
                });
            }
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        let flexBasis;
        const computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== "auto") {
            const parent = this.parentNode;
            if (parent) {
                const dir = this.window.getComputedStyle(parent).flexDirection;
                this.flexDir = dir.startsWith("row") ? "row" : "column";
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        const state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            backgroundStyle: {
                ...this.state.backgroundStyle,
                cursor: this.window.getComputedStyle(event.target).cursor || "auto"
            },
            direction,
            flexBasis
        };
        this.setState(state);
    }
    /**
   * @param { MouseEvent | TouchEvent} event
   * @return {void}
   */ onMouseMove(event) {
        if (!this.state.isResizing || !this.resizable || !this.window) {
            return;
        }
        if (this.window.TouchEvent && isTouchEvent(event)) {
            try {
                event.preventDefault();
                event.stopPropagation();
            } catch (e) {
            // Ignore on fail
            }
        }
        let { maxWidth , maxHeight , minWidth , minHeight  } = this.props;
        const clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        const clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        const { direction , original , width , height  } = this.state;
        const parentSize = this.getParentSize();
        const max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        let { newHeight , newWidth  } = this.calculateNewSizeFromDirection(clientX, clientY);
        // Calculate max size from boundary settings
        const boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) {
            newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        }
        if (this.props.snap && this.props.snap.y) {
            newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        }
        // Calculate new size from aspect ratio
        const newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            const newGridWidth = snap(newWidth, this.props.grid[0]);
            const newGridHeight = snap(newHeight, this.props.grid[1]);
            const gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        const delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === "string") {
            if (width.endsWith("%")) {
                const percent = newWidth / parentSize.width * 100;
                newWidth = "".concat(percent, "%");
            } else if (width.endsWith("vw")) {
                const vw = newWidth / this.window.innerWidth * 100;
                newWidth = "".concat(vw, "vw");
            } else if (width.endsWith("vh")) {
                const vh = newWidth / this.window.innerHeight * 100;
                newWidth = "".concat(vh, "vh");
            }
        }
        if (height && typeof height === "string") {
            if (height.endsWith("%")) {
                const percent1 = newHeight / parentSize.height * 100;
                newHeight = "".concat(percent1, "%");
            } else if (height.endsWith("vw")) {
                const vw1 = newHeight / this.window.innerWidth * 100;
                newHeight = "".concat(vw1, "vw");
            } else if (height.endsWith("vh")) {
                const vh1 = newHeight / this.window.innerHeight * 100;
                newHeight = "".concat(vh1, "vh");
            }
        }
        const newState = {
            width: this.createSizeForCssProperty(newWidth, "width"),
            height: this.createSizeForCssProperty(newHeight, "height")
        };
        if (this.flexDir === "row") {
            newState.flexBasis = newState.width;
        } else if (this.flexDir === "column") {
            newState.flexBasis = newState.height;
        }
        // For v18, update state sync
        (0,react_dom.flushSync)(()=>{
            this.setState(newState);
        });
        if (this.props.onResize) {
            this.props.onResize(event, direction, this.resizable, delta);
        }
    }
    /**
   * @param {MouseEvent | TouchEvent}event
   * @return {void}
   */ onMouseUp(event) {
        const { isResizing , direction , original  } = this.state;
        if (!isResizing || !this.resizable) {
            return;
        }
        const delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) {
            this.props.onResizeStop(event, direction, this.resizable, delta);
        }
        if (this.props.size) {
            this.setState(this.props.size);
        }
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: {
                ...this.state.backgroundStyle,
                cursor: "auto"
            }
        });
    }
    /**
   * @param {Size}size
   */ updateSize(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    }
    /**
   * @return {JSX.Element | null}
   */ renderResizer() {
        const { enable , handleStyles , handleClasses , handleWrapperStyle , handleWrapperClass , handleComponent  } = this.props;
        if (!enable) {
            return null;
        }
        const resizers = Object.keys(enable).map((dir)=>{
            if (enable[dir] !== false) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Resizer, {
                    direction: dir,
                    onResizeStart: this.onResizeStart,
                    replaceStyles: handleStyles && handleStyles[dir],
                    className: handleClasses && handleClasses[dir],
                    children: handleComponent && handleComponent[dir] ? handleComponent[dir] : null
                }, dir);
            }
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: handleWrapperClass,
            style: handleWrapperStyle,
            children: resizers
        });
    }
    /**
   * @return {JSX.Element}
   */ render() {
        const extendsProps = Object.keys(this.props).reduce((acc, key)=>{
            if (definedProps.indexOf(key) !== -1) {
                return acc;
            }
            acc[key] = this.props[key];
            return acc;
        }, {});
        const style = {
            position: "relative",
            userSelect: this.state.isResizing ? "none" : "auto",
            ...this.props.style,
            ...this.sizeStyle,
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: "border-box",
            flexShrink: 0
        };
        if (this.state.flexBasis) {
            style.flexBasis = this.state.flexBasis;
        }
        const Wrapper = this.props.as || "div";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            ref: this.ref,
            style: style,
            className: this.props.className,
            ...extendsProps,
            children: [
                this.state.isResizing && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: this.state.backgroundStyle
                }),
                this.props.children,
                this.renderResizer()
            ]
        });
    }
    /**
   * @param {ResizableProps}props
   */ constructor(props){
        super(props);
        this.ratio = 1;
        this.resizable = null;
        // For parent boundary
        this.parentLeft = 0;
        this.parentTop = 0;
        // For boundary
        this.resizableLeft = 0;
        this.resizableRight = 0;
        this.resizableTop = 0;
        this.resizableBottom = 0;
        // For target boundary
        this.targetLeft = 0;
        this.targetTop = 0;
        this.appendBase = ()=>{
            if (!this.resizable || !this.window) {
                return null;
            }
            const parent = this.parentNode;
            if (!parent) {
                return null;
            }
            const element = this.window.document.createElement("div");
            element.style.width = "100%";
            element.style.height = "100%";
            element.style.position = "absolute";
            element.style.transform = "scale(0, 0)";
            element.style.left = "0";
            element.style.flex = "0 0 100%";
            if (element.classList) {
                element.classList.add(baseClassName);
            } else {
                element.className += baseClassName;
            }
            parent.appendChild(element);
            return element;
        };
        this.removeBase = (base)=>{
            const parent = this.parentNode;
            if (!parent) {
                return;
            }
            parent.removeChild(base);
        };
        this.ref = (c)=>{
            if (c) {
                this.resizable = c;
            }
        };
        this.state = {
            isResizing: false,
            width: typeof (this.propsSize && this.propsSize.width) === "undefined" ? "undefined" : this.propsSize && this.propsSize.width,
            height: typeof (this.propsSize && this.propsSize.height) === "undefined" ? "undefined" : this.propsSize && this.propsSize.height,
            direction: "right",
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            backgroundStyle: {
                height: "100%",
                width: "100%",
                backgroundColor: "rgba(0,0,0,0)",
                cursor: "auto",
                opacity: 0,
                position: "fixed",
                zIndex: 9999,
                top: "0",
                left: "0",
                bottom: "0",
                right: "0"
            },
            flexBasis: undefined
        };
        this.onResizeStart = this.onResizeStart.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
    }
}
Resizable.defaultProps = {
    as: "div",
    onResizeStart: ()=>{},
    onResize: ()=>{},
    onResizeStop: ()=>{},
    enable: {
        top: true,
        right: true,
        bottom: true,
        left: true,
        topRight: true,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true
    },
    style: {},
    grid: [
        1,
        1
    ],
    lockAspectRatio: false,
    lockAspectRatioExtraWidth: 0,
    lockAspectRatioExtraHeight: 0,
    scale: 1,
    resizeRatio: 1,
    snapGap: 0
};

;// CONCATENATED MODULE: ./src/components/Chart/index.tsx











const ChartComponent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(819), __webpack_require__.e(585)]).then(__webpack_require__.bind(__webpack_require__, 45585)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45585)
            ]
    },
    ssr: false
});
const Chart = (param)=>{
    let { token , chainId  } = param;
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const [resizable, setResizable] = (0,react.useState)(null);
    const [height, setHeight] = (0,react.useState)(undefined);
    const [width, setWidth] = (0,react.useState)(undefined);
    const [color, setColor] = (0,react.useState)(false);
    const [active, chartSize, , { chartActive , updateChartSize  }] = (0,chart_hooks/* useActivateChart */.B)();
    const onResizeStop = (0,react.useCallback)(()=>{
        var ref, ref1;
        setColor(!color);
        if (resizable) updateChartSize({
            width: Number((ref = resizable.state) === null || ref === void 0 ? void 0 : ref.width),
            height: Number((ref1 = resizable.state) === null || ref1 === void 0 ? void 0 : ref1.height)
        });
    }, [
        color,
        resizable,
        updateChartSize
    ]);
    const onResize = (0,react.useCallback)(()=>{
        if (resizable) {
            var ref, ref1;
            setWidth((ref = resizable.state) === null || ref === void 0 ? void 0 : ref.width);
            setHeight((ref1 = resizable.state) === null || ref1 === void 0 ? void 0 : ref1.height);
        }
    }, [
        resizable
    ]);
    (0,react.useEffect)(()=>{
        if (resizable) {
            if (chartSize.height !== 0 && chartSize.width !== 0) {
                resizable.setState({
                    height: chartSize.height,
                    width: chartSize.width
                });
                setWidth(chartSize.width);
                setHeight(chartSize.height);
            } else {
                updateChartSize({
                    width: resizable.size.width,
                    height: resizable.size.height
                });
            }
        }
    }, [
        chartSize,
        resizable,
        updateChartSize
    ]);
    return (0,react.useMemo)(()=>{
        if (!isMounted) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (active) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Resizable, {
            className: (0,src_functions/* classNames */.AK)(chartSize.width !== 0 ? "w-[".concat(chartSize.width, "px]") : "w-[50%]", chartSize.height !== 0 ? "h-[".concat(chartSize.height, "px]") : "h-[300px]", "p-0 animate-movein rounded-xl mx-auto! flex-[0_0_auto]  bg-gray-200/20 flex-wrap min-h-[300px] min-w-full select-none border-2 border-transparent flex-shrink-0 !max-w-[calc(100vw-80px)] !max-h-[calc(100vh-40px)]"),
            ref: setResizable,
            minHeight: 330,
            minWidth: 327,
            enable: {
                right: true,
                bottom: true,
                bottomRight: true
            },
            onResize: onResize,
            onResizeStart: onResizeStop,
            onResizeStop: onResizeStop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* MinimizeIcon */.dO, {
                    width: 24,
                    height: 24,
                    className: "z-[100] relative flex m-1.5 float-right cursor-pointer text-slate-400 hover:text-slate-600",
                    onClick: ()=>chartActive(false)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightIcon */.XC, {
                    className: (0,src_functions/* classNames */.AK)("rotate-45 p-0 absolute -bottom-[3.5px] -right-[3.5px] ", color ? "fill-slate-400/40 " : "fill-slate-700/40"),
                    width: 24,
                    height: 24
                }),
                graphql/* SUPPORTED_CHAINS.includes */.Gw.includes(chainId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartComponent, {
                    height: Number(height),
                    width: Number(width),
                    t: t,
                    token: token,
                    chainId: chainId
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-mt-0.5 absolute flex flex-col -mr-0.5 inset-0 shadow-slate-900 text-xxs items-center justify-center font-medium overflow-hidden shadow text-red-800 rounded-xl p-0 m-0 transform-gpu z-[3] pointer-events-none w-[calc(100%+0.25rem)] h-[calc(100%+0.25rem)]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex z-[2] w-full h-full rounded-xl items-center justify-center pb-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WarningIconRound */.d$, {
                                width: 40,
                                height: 40
                            }),
                            t("Charts are not supported for this chain yet"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {})
                        ]
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }, [
        isMounted,
        active,
        chartSize,
        onResize,
        onResizeStop,
        color,
        chainId,
        height,
        width,
        t,
        token,
        chartActive
    ]);
};
/* harmony default export */ var components_Chart = (Chart);

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/address/getAddress.js
var getAddress = __webpack_require__(92221);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/ens/namehash.js
var namehash = __webpack_require__(3492);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var multicall_hooks = __webpack_require__(12737);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(27857);
// EXTERNAL MODULE: ./src/hooks/utils/index.ts + 6 modules
var utils = __webpack_require__(51473);
;// CONCATENATED MODULE: ./src/hooks/useENSAddress.ts






/**
 * Does a lookup for an ENS name to find its address.
 */ /**
 * @param {string | null}ensName
 * @return {{boolean, string}}
 */ function useENSAddress(ensName) {
    const debouncedName = (0,utils/* useDebounce */.Nr)(ensName, 200);
    const ensNodeArgument = (0,react.useMemo)(()=>{
        if (!debouncedName) return [
            undefined
        ];
        try {
            return debouncedName ? [
                (0,namehash/* namehash */.V)(debouncedName)
            ] : [
                undefined
            ];
        } catch (error) {
            return [
                undefined
            ];
        }
    }, [
        debouncedName
    ]);
    const registrarContract = (0,useContract/* useENSRegistrarContract */.zb)(false);
    const resolverAddress = (0,multicall_hooks/* useSingleCallResult */.Wk)(registrarContract, "resolver", ensNodeArgument);
    const resolverAddressResult = resolverAddress.result;
    const resolverContract = (0,useContract/* useENSResolverContract */.uU)(resolverAddressResult && !(0,src_functions/* isZero */.Fr)(resolverAddressResult) ? resolverAddressResult : undefined, false);
    const addr = (0,multicall_hooks/* useSingleCallResult */.Wk)(resolverContract, "addr", ensNodeArgument);
    const changed = debouncedName !== ensName;
    var _result;
    return {
        address: changed ? null : (_result = addr.result) !== null && _result !== void 0 ? _result : null,
        loading: changed || resolverAddress.loading || addr.loading
    };
}

;// CONCATENATED MODULE: ./src/components/Input/Address.tsx




const matchSpaces = /\s+/g;
const Address = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { id , value ="" , onChange , placeholder ="Address or LNS name" , title ="Address or LNS name" , className ="" , error , variant ="default" , ...rest } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            id: id,
            ref: ref,
            title: title,
            placeholder: placeholder,
            value: value,
            type: "search",
            className: variant === "default" ? (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_CLASSNAME, error ? ERROR_INPUT_CLASSNAME : "", className) : className,
            onChange: (event)=>onChange && onChange(event.target.value.replace(matchSpaces, "")),
            inputMode: "search",
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: "false",
            pattern: "^(0x[a-fA-F0-9]{40})$",
            ...rest
        })
    });
});

;// CONCATENATED MODULE: ./src/components/Input/utils.ts
const inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
const escapeRegExp = (string)=>{
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") // $& means the whole matched string
    ;
};

;// CONCATENATED MODULE: ./src/components/Input/Numeric.tsx





const defaultClassName = "w-0 p-0 text-2xl bg-transparent";
const Input = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { value , onUserInput , placeholder ="0" , className =defaultClassName , title ="Token Amount" , inputMode ="decimal" , type ="text" , pattern ="^[0-9]*[.,]?[0-9]*$" , min =0 , minLength =1 , maxLength =79 , variant ="default" , error , ...rest } = param;
    const enforcer = (nextUserInput)=>{
        if (nextUserInput === "" || inputRegex.test(escapeRegExp(nextUserInput)) && !isNaN(Number(nextUserInput))) {
            if (onUserInput) {
                onUserInput(nextUserInput);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        ref: ref,
        value: value,
        onChange: (event)=>{
            // replace commas with periods, because uniswap exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: inputMode,
        title: title,
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: false,
        // text-specific options
        type: type,
        pattern: pattern,
        placeholder: placeholder,
        min: min,
        minLength: minLength,
        maxLength: maxLength,
        className: variant === "default" ? (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_CLASSNAME, error ? ERROR_INPUT_CLASSNAME : "", className) : className,
        ...rest
    });
});
/* harmony default export */ var Numeric = ((/* unused pure expression or super */ null && (Input)));

;// CONCATENATED MODULE: ./src/components/Input/index.ts



/** Base classes */ const DEFAULT_INPUT_FONT = "text-left text-base md:text-sm placeholder:font-normal font-medium";
const DEFAULT_INPUT_BG = "bg-white bg-opacity-[0.06]";
const DEFAULT_INPUT_RING = "focus-within:ring-2 focus:outline-none border-none focus:ring-2 focus:ring-offset-2 focus-within:ring-offset-2 ring-blue-500 focus:ring-blue-500 focus-within:ring-blue-500";
const DEFAULT_INPUT_APPEARANCE = "rounded-xl shadow-md min-h-[44px] w-full truncate";
const DEFAULT_INPUT_PADDING = "py-3 px-4";
const ERROR_INPUT_CLASSNAME = "!ring-red/70 !ring-2 !ring-offset-2";
/** Unstyled input */ const DEFAULT_INPUT_UNSTYLED = (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_FONT, "p-0 bg-transparent border-none focus:outline-none focus:ring-0 w-full truncate font-medium");
// Default class with padding
const DEFAULT_INPUT_CLASSNAME = (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_FONT, DEFAULT_INPUT_BG, DEFAULT_INPUT_RING, DEFAULT_INPUT_APPEARANCE, DEFAULT_INPUT_PADDING);
const Input_Input = {
    Address: Address,
    Numeric: Input
};

;// CONCATENATED MODULE: ./src/components/Layout/Account/AdressInput.tsx








const AddressInput = (param)=>{
    let { children , userExpertMode =false , recipientActive =false , chainId , isWrap , ...props } = param;
    const [query, setQuery] = (0,react.useState)("");
    const inputRef = (0,react.useRef)(null);
    const { address: recipientAddress  } = useENSAddress(query);
    const _recipient = (0,react.useMemo)(()=>query !== "bch" && userExpertMode && recipientActive ? recipientAddress ? recipientAddress : query && (0,isAddress/* isAddress */.U)(query) ? (0,getAddress/* getAddress */.K)(query, chainId) : undefined : undefined, [
        chainId,
        query,
        recipientActive,
        recipientAddress,
        userExpertMode
    ]);
    // reset recipient on removing receipient
    (0,react.useEffect)(()=>{
        if (!recipientActive) {
            setQuery("");
        }
    }, [
        recipientActive
    ]);
    if (typeof children === "function") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                recipientActive && userExpertMode && !isWrap && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,src_functions/* classNames */.AK)("relative flex items-center justify-between gap-2 px-3 mx-4 mb-4 rounded-2xl py-2 text-primary bg-tokenselectorlist", !_recipient && query !== "" ? "!ring-2 !ring-red-500 focus:!ring-transparent focus-within:!ring-secondarybg  selection:" : _recipient ? "!ring-2 !ring-green-500" : "focus-within:!ring-2 focus-within:!ring-secondarybg"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Address, {
                            type: "text",
                            variant: "unstyled",
                            id: "token-search",
                            ref: inputRef,
                            placeholder: "Add Recipient by Address or ".concat(chainId === enums/* ChainId.SMARTBCH */.a_.SMARTBCH || enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET ? "LNS" : "ENS"),
                            value: query,
                            onChange: setQuery,
                            className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, "!bg-transparent btn w-full flex group !text-primary  placeholder:text-slate-800 !font-medium  gap-2 cursor-pointer opacity-80 hover:opacity-100 hover:bg-opacity-70 px-4 h-[34px] rounded-xl text-base")
                        }),
                        query ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* XCircleIcon */.oO, {
                            width: 20,
                            height: 20,
                            className: "cursor-pointer z-[10] text-slate-900 hover:text-slate-700",
                            onClick: ()=>setQuery("")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* UserPlus */.bD, {
                            className: "user-select-none pointer-events-none text-slate-600 fill-slate-600 z-[10]",
                            strokeWidth: 2,
                            width: 20,
                            height: 20
                        })
                    ]
                }),
                children(_recipient)
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            recipientActive && userExpertMode && !isWrap && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Address, {
                type: "text",
                variant: "unstyled",
                id: "token-search",
                ref: inputRef,
                placeholder: "Add Recipient by Address or ".concat(chainId === enums/* ChainId.SMARTBCH */.a_.SMARTBCH || enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET ? "LNS" : "ENS"),
                value: query,
                onChange: setQuery,
                className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, !_recipient && query !== "" ? "!ring-1 !ring-red-500 focus:!ring-transparent" : _recipient ? " !ring-1 !ring-green-500" : "", " bg-slate-500 btn w-full font-medium flex items-center justify-center gap-2 cursor-pointer opacity-80 hover:opacity-100 bg-primarybg  text-primary hover:bg-opacity-70 px-4 h-[34px] rounded-xl text-base")
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Animation/SlideIn/index.ts + 6 modules
var SlideIn = __webpack_require__(79850);
// EXTERNAL MODULE: ./src/components/Overlay/index.ts + 3 modules
var Overlay = __webpack_require__(48084);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./src/state/lists/hooks.ts + 1 modules
var lists_hooks = __webpack_require__(34556);
;// CONCATENATED MODULE: ./src/hooks/Token/useTokensFromMap.ts

/** reduce token map into standard address <-> Token mapping, optionally include user added tokens
 * @param {ChainId | undefined}chainId
 * @param {ChainTokenMap} tokenMap
 * @return {Record<string, Token>}
 */ function useTokensFromMap(chainId, tokenMap) {
    return (0,react.useMemo)(()=>{
        if (!chainId) return {};
        var _chainId;
        // reduce to just tokens
        const mapWithoutUrls = Object.keys((_chainId = tokenMap[chainId]) !== null && _chainId !== void 0 ? _chainId : {}).reduce((newMap, address)=>{
            newMap[address] = tokenMap[chainId][address].token;
            return newMap;
        }, {});
        return mapWithoutUrls;
    }, [
        chainId,
        tokenMap
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/Token/useTokens.ts
// import { WNATIVE } from '@emberswap/emberswap-sdk2/dist/constants'
// import { Address, Type } from '@emberswap/emberswap-sdk2/dist/types'
// import { useMemo } from 'react'
// import { useToken } from 'wagmi'
// 
// import { isAddress } from '../../functions'


/**
 * @param {ChainId | undefined} chainId
 * @return {Token}
 */ function useTokens(chainId) {
    return useTokensFromMap(chainId, (0,lists_hooks/* useCombinedActiveList */.z0)());
} // import { useUserAddedTokens } from '../state/user/hooks'
 /** Check if currency is included in custom list from user storage
 * @param {Currency | undefined | null}currency
 * @return {boolean}
 */  // export function useIsUserAddedToken(currency: Currency | undefined | null): boolean {
 //   const userAddedTokens = useUserAddedTokens()
 //   if (!currency) {
 //     return false
 //   }
 //   return !!userAddedTokens.find((token: any) => currency.equals(token))
 // }
 /**
 * @param {string | undefined}currencyId
 * @return {Type | null | undefined}
 */  // export function useCurrency(currencyId: string | undefined, chainId: ChainId): Type | null | undefined {
 //   const native = useMemo(() => Native.onChain(chainId), [chainId])
 //   const isNative = currencyId?.toUpperCase() === native.symbol.toUpperCase()
 //   const { data: _token } = useToken({
 //     address: isAddress(currencyId) ? (currencyId as Address) : undefined,
 //     chainId,
 //   })
 // 
 //     const token = useMemo(() => {
 //       if (!_token) return undefined
 //       const { decimals, address, symbol, name } = _token
 //       return new Token({ chainId, decimals, address, symbol, name })
 //     }, [_token, chainId])
 // 
 //   return isNative ? native : token
 // }

// EXTERNAL MODULE: ./src/state/user/hooks.tsx
var user_hooks = __webpack_require__(8350);
// EXTERNAL MODULE: ./src/components/Currency/index.ts + 2 modules
var components_Currency = __webpack_require__(50731);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js + 1 modules
var tabs = __webpack_require__(49808);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(7360);
;// CONCATENATED MODULE: ./src/components/Tabs/TabGroup.tsx



const TabGroup = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Group */.O.Group, {
        ...props,
        ref: ref,
        children: children
    });
});

;// CONCATENATED MODULE: ./src/components/Tabs/TabList.tsx




const TabList = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
        ...props,
        ref: ref,
        className: (0,src_functions/* classNames */.AK)("bg-slate-400/50 divide-x divide-slate-400 divide-y-[0px] visible rounded-xl overflow-hidden grid grid-flow-col", className),
        children: children
    });
});

;// CONCATENATED MODULE: ./src/components/Tabs/Tab.tsx







const _Tab = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { children , className , ...props } = param;
    return(// @ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab */.O, {
        as: react.Fragment,
        ref: ref,
        children: (param)=>/*#__PURE__*/ {
            let { selected  } = param;
            return (0,jsx_runtime.jsx)(Button/* Button */.z, {
                size: "sm",
                className: (0,src_functions/* classNames */.AK)(className, "hover:ring-0 focus:ring-0 outline-none "),
                color: "gray",
                variant: selected ? "filled" : "empty",
                ...props,
                children: children
            });
        }
    }));
});
const Tab = Object.assign(_Tab, {
    Group: TabGroup,
    List: TabList,
    Panels: tabs/* Tab.Panels */.O.Panels,
    Panel: tabs/* Tab.Panel */.O.Panel
});

;// CONCATENATED MODULE: ./src/components/Tabs/index.ts


// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 54 modules
var chunk_LAFZBYO7 = __webpack_require__(40984);
;// CONCATENATED MODULE: ./src/wagmi/hooks/useTokens.ts



/**
 * @param {FetchTokenArgs[]}tokens
 * @return {QueryKeyArgs}
 */ function queryKey(param) {
    let { tokens  } = param;
    return [
        {
            entity: "tokens",
            tokens: tokens || []
        }
    ];
}
const queryFn = (param)=>{
    let { queryKey: [{ tokens  }]  } = param;
    if (!tokens) throw new Error("tokens is required");
    if (tokens.filter((el)=>!el.address).length > 0) throw new Error("address is required");
    return Promise.all(tokens.map((token)=>{
        return (0,chunk_LAFZBYO7/* fetchToken */.EC)({
            address: token.address,
            chainId: token.chainId,
            formatUnits: token.formatUnits
        });
    }));
};
/**
 * @param {UseTokensArgs} tokens
 * @param {UseTokensConfig} onError, onSettled, onSuccess
 * @return {any}
 */ function useTokens_useTokens(param) {
    let { tokens =[] , cacheTime , enabled =true , staleTime =1000 * 60 * 60 * 24 , suspense , onError , onSettled , onSuccess  } = param;
    const _enabled = (0,react.useMemo)(()=>{
        return Boolean(tokens && (tokens === null || tokens === void 0 ? void 0 : tokens.length) > 0 && enabled && tokens.map((el)=>el.address && el.chainId));
    }, [
        enabled,
        tokens
    ]);
    return (0,dist/* useQuery */.aM)(queryKey({
        tokens
    }), queryFn, {
        cacheTime,
        enabled: _enabled,
        staleTime,
        suspense,
        onError,
        onSettled,
        onSuccess
    });
}

// EXTERNAL MODULE: ./src/components/Dialog/index.ts + 12 modules
var Dialog = __webpack_require__(66205);
// EXTERNAL MODULE: ./src/components/Copy/index.tsx
var Copy = __webpack_require__(55029);
// EXTERNAL MODULE: ./src/components/Currency/Icon.tsx
var Icon = __webpack_require__(78722);
;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenSelectorImportRow.tsx











const TokenSelectorImportRow = (param)=>{
    let { currencies , className ="" , onImport , hideIcons =false , slideIn =true  } = param;
    var ref;
    const [open, setOpen] = (0,react.useState)(false);
    const content = (0,react.useMemo)(()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "my-3 space-y-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-2 p-3 rounded-2xl",
                    children: [
                        !hideIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-10 h-10 overflow-hidden bg-white rounded-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center w-full h-full bg-red/10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-5 h-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WarningIconRound */.d$, {
                                        width: 20,
                                        height: 20,
                                        className: "text-red"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-lg font-medium text-slate-200",
                            children: "Trade at your own risk!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "text-sm font-normal text-center text-slate-400",
                            children: [
                                currencies.length > 1 ? "These tokens don't" : "This token doesn't",
                                " appear on the active token list(s). Anyone can create a token, including creating fake versions of existing tokens that claim to represent projects"
                            ]
                        })
                    ]
                }),
                currencies.map((currency)=>{
                    if (!currency) return;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between p-3 px-4 bg-slate-700 rounded-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium text-slate-200",
                                        children: currency.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-xs font-medium text-slate-400",
                                        children: currency.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        className: "flex items-center gap-1 text-xs font-medium text-blue-500 hover:text-blue-400",
                                        href: constants/* chains */.p5[currency.chainId].getTokenUrl(currency.address),
                                        children: [
                                            "View on Explorer ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ExternalLinkIcon */.h0, {
                                                width: 16,
                                                height: 16
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "flex justify-end text-xs font-medium text-slate-400",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {
                                            toCopy: currency.address,
                                            children: (0,src_functions/* shortenAddress */.Xn)(currency.wrapped.address)
                                        })
                                    })
                                ]
                            })
                        ]
                    }, currency.address);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "default",
                    as: "div",
                    onClick: onImport,
                    children: "Import"
                })
            ]
        }), [
        currencies,
        hideIcons,
        onImport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: slideIn && currencies[0] ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: ()=>setOpen(true),
                    className: (0,src_functions/* classNames */.AK)(className, "group flex items-center w-full px-6 py-2.5 token-".concat((ref = currencies[0]) === null || ref === void 0 ? void 0 : ref.symbol)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between flex-grow gap-2 rounded cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center flex-grow gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-7 h-7",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            currency: currencies[0],
                                            width: 28,
                                            height: 28
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-xs font-medium text-slate-200",
                                                children: currencies[0].symbol
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-xxs text-slate-500",
                                                children: currencies[0].name
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                as: "div",
                                color: "green",
                                size: "xs",
                                children: "Import"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn/* SlideIn.FromLeft */.oX.FromLeft, {
                    show: open,
                    onClose: ()=>setOpen(false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Overlay/* Overlay.Content */.a.Content, {
                        className: "bg-slate-800 !pb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay.Header */.a.Header, {
                                onClose: ()=>setOpen(false),
                                title: "Import Token"
                            }),
                            content
                        ]
                    })
                })
            ]
        }) : content
    });
};

;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenListImportChecker.tsx








const TokenListImportChecker = (param)=>{
    let { chainId , tokens , children  } = param;
    const tokenMap = useTokens(chainId);
    const [customTokensMap, { addCustomTokens  }] = (0,user_hooks/* useCustomTokens */.Xd)(chainId);
    const _tokens = (0,react.useMemo)(()=>{
        if (!tokens || Object.keys(tokenMap).length === 0) return [];
        return tokens.filter((el)=>{
            return !(el.address in tokenMap) && !(el.address.toLowerCase() in customTokensMap);
        });
    }, [
        customTokensMap,
        tokenMap,
        tokens
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_TokenListImportChecker, {
        chainId: chainId,
        onAddTokens: addCustomTokens,
        tokens: _tokens,
        tokenMap: tokenMap,
        customTokensMap: customTokensMap,
        children: children
    });
};
const _TokenListImportChecker = (param)=>{
    let { children , tokens , onAddTokens: addCustomTokens , tokenMap , customTokensMap  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    const onClose = (0,react.useCallback)(()=>{
        setOpen(false);
    }, []);
    const { data: currencies  } = useTokens_useTokens({
        tokens: tokens.map((el)=>({
                address: el.address,
                chainId: el.chainId
            }))
    });
    const _currencies = (0,react.useMemo)(()=>{
        if (!currencies) return;
        return currencies.map((el, idx)=>{
            const { address , name , symbol , decimals  } = el;
            return new entities/* Token */.WU({
                address,
                name,
                symbol,
                decimals,
                chainId: tokens[idx].chainId
            });
        });
    }, [
        currencies,
        tokens
    ]);
    const handleImport = (0,react.useCallback)(()=>{
        if (!currencies) return;
        if (addCustomTokens && _currencies) {
            addCustomTokens(_currencies);
        }
        onClose();
    }, [
        _currencies,
        currencies,
        addCustomTokens,
        onClose
    ]);
    (0,react.useEffect)(()=>{
        if (!tokens) return;
        tokens.map((el)=>{
            if (!(el.address in tokenMap) && !(el.address.toLowerCase() in customTokensMap)) setOpen(true);
        });
    }, [
        customTokensMap,
        tokenMap,
        tokens
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            _currencies && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog */.V, {
                open: open,
                onClose: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.V.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog.Header */.V.Header, {
                            onClose: ()=>setOpen(false),
                            title: _currencies.length > 1 ? "Import Tokens" : "Import Token"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectorImportRow, {
                            currencies: _currencies,
                            onImport: handleImport,
                            slideIn: false
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/utils/index.mjs
var dist_utils = __webpack_require__(9053);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/constants/address.js
var constants_address = __webpack_require__(66373);
;// CONCATENATED MODULE: ./src/hooks/useBalance.ts






const useBalances = (param)=>{
    let { watch =true , enabled =true , chainId , account , currencies  } = param;
    const { data: nativeBalance , isLoading: isNativeLoading , isError: isNativeError  } = (0,dist/* useBalance */.KQ)({
        address: account,
        chainId,
        enabled,
        watch: !(typeof enabled !== undefined && !enabled) && watch
    });
    const [validatedTokens, validatedTokenAddresses] = (0,react.useMemo)(()=>currencies.reduce((acc, currencies)=>{
            if (chainId && currencies && (0,src_functions/* isAddress */.UJ)(currencies.wrapped.address)) {
                acc[0].push(currencies.wrapped);
                acc[1].push([
                    currencies.wrapped.address
                ]);
            }
            return acc;
        }, [
            [],
            []
        ]), [
        chainId,
        currencies
    ]);
    const contracts = (0,react.useMemo)(()=>{
        const input = validatedTokenAddresses.map((token)=>{
            return {
                chainId,
                address: token[0],
                abi: chunk_LAFZBYO7/* erc20ABI */.em,
                functionName: "balanceOf",
                args: [
                    account
                ]
            };
        });
        return input;
    }, [
        validatedTokenAddresses,
        chainId,
        account
    ]);
    const { data , isError , isLoading  } = (0,dist/* useContractReads */.Dm)({
        contracts,
        enabled,
        watch: !(typeof enabled !== undefined && !enabled) && watch
    });
    const tokens = (0,react.useMemo)(()=>{
        const result = {};
        if ((data === null || data === void 0 ? void 0 : data.length) !== contracts.length) return result;
        for(let i = 0; i < validatedTokenAddresses.length; i++){
            const value = data[i].result;
            const amount = value ? dist_utils/* JSBI.BigInt */.QA.BigInt(value.toString()) : undefined;
            if (!result[validatedTokens[i].address]) {
                result[validatedTokens[i].address] = entities/* Amount.fromRawAmount */.$d.fromRawAmount(validatedTokens[i], "0");
            }
            if (amount) result[validatedTokens[i].address] = entities/* Amount.fromRawAmount */.$d.fromRawAmount(validatedTokens[i], amount);
            else result[validatedTokens[i].address] = entities/* Amount.fromRawAmount */.$d.fromRawAmount(validatedTokens[i], "0");
        }
        return result;
    }, [
        contracts.length,
        data,
        validatedTokenAddresses.length,
        validatedTokens
    ]);
    return (0,react.useMemo)(()=>{
        if (chainId && (nativeBalance === null || nativeBalance === void 0 ? void 0 : nativeBalance.value)) tokens[constants_address/* zeroAddress */.D] = entities/* Amount.fromRawAmount */.$d.fromRawAmount(entities/* Native.onChain */._r.onChain(chainId), nativeBalance.value.toString());
        return {
            data: tokens,
            isLoading: isLoading || isNativeLoading,
            isError: isError || isNativeError
        };
    }, [
        tokens,
        chainId,
        nativeBalance === null || nativeBalance === void 0 ? void 0 : nativeBalance.value,
        isLoading,
        isNativeLoading,
        isError,
        isNativeError
    ]);
};
const useBalance = (param)=>{
    let { watch =true , chainId , account , currency , enabled =true  } = param;
    const currencies = (0,react.useMemo)(()=>[
            currency
        ], [
        currency
    ]);
    const { data , isLoading , isError  } = useBalances({
        watch,
        chainId,
        currencies,
        account,
        enabled
    });
    return (0,react.useMemo)(()=>{
        const walletBalance = currency ? data === null || data === void 0 ? void 0 : data[currency.isNative ? constants_address/* zeroAddress */.D : currency.wrapped.address] : undefined;
        return {
            isError: isError,
            isLoading: isLoading,
            data: walletBalance ? walletBalance : undefined
        };
    }, [
        isError,
        isLoading,
        currency,
        data
    ]);
};

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/parseUnits.js
var parseUnits = __webpack_require__(22852);
;// CONCATENATED MODULE: ./src/hooks/usePrices.ts





const usePrices = (param)=>{
    let { chainId , options  } = param;
    const queryKey = (0,react.useMemo)(()=>[
            "/api/prices/".concat(chainId)
        ], [
        chainId
    ]);
    const { data , isError , isLoading  } = (0,dist/* useQuery */.aM)(queryKey, ()=>fetch("/api/prices/".concat(chainId)).then((response)=>response.json()), {
        staleTime: 300,
        enabled: Boolean(chainId),
        ...options
    });
    return (0,react.useMemo)(()=>{
        if (!graphql/* SUPPORTED_CHAINS.includes */.Gw.includes(Number(chainId))) return {
            isError: true,
            isLoading: false,
            data: {}
        };
        return {
            isError,
            isLoading,
            data: data && !isError && !isLoading && graphql/* SUPPORTED_CHAINS.includes */.Gw.includes(Number(chainId)) ? Object.entries(data.prices).reduce((acc, param)=>{
                let [address, price] = param;
                if ((0,isAddress/* isAddress */.U)(address)) {
                    acc[(0,getAddress/* getAddress */.K)(address)] = new entities/* Fraction */.iA((0,parseUnits/* parseUnits */.v)(price.toFixed(18), 18).toString(), (0,parseUnits/* parseUnits */.v)("1", 18).toString());
                }
                return acc;
            }, {}) : undefined
        };
    }, [
        chainId,
        data,
        isError,
        isLoading
    ]);
};

;// CONCATENATED MODULE: ./src/components/List/ListControl.tsx


const ListControl = (param)=>{
    let { children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,src_functions/* classNames */.AK)("bg-white dark:bg-secondary rounded-xl overflow-hidden", className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Skeleton/Box.tsx


const Box = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...props,
        className: (0,src_functions/* classNames */.AK)(props.className ? props.className : "", "rounded-lg overflow-hidden relative after:absolute after:inset-0 after:translate-x-[-100%] after:animate-wave after:content-[] after:bg-shimmer-gradient")
    });
};

;// CONCATENATED MODULE: ./src/components/Skeleton/Circle.tsx


const Circle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...props,
        style: {
            minWidth: props.radius,
            minHeight: props.radius,
            width: props.radius,
            height: props.radius
        },
        className: (0,src_functions/* classNames */.AK)(props.className ? props.className : "", "rounded-full overflow-hidden relative after:absolute after:inset-0 after:translate-x-[-100%] after:animate-wave after:content-[] after:bg-shimmer-gradient")
    });
};

// EXTERNAL MODULE: ./node_modules/class-variance-authority/dist/index.mjs + 1 modules
var class_variance_authority_dist = __webpack_require__(45139);
;// CONCATENATED MODULE: ./src/components/Skeleton/Text.tsx




const skeletonTextVariants = (0,class_variance_authority_dist/* cva */.j)("flex w-full", {
    variants: {
        fontSize: {
            xs: "h-[18px] py-[3px]",
            sm: "h-5 py-[3px]",
            default: "h-6 py-[3px]",
            lg: "h-[28px] py-[3px]",
            xl: "h-[28px]",
            "2xl": "h-[44px] py-[6px]",
            "3xl": "h-[36px] py-[3px]"
        },
        align: {
            left: "",
            center: "justify-center",
            right: "justify-end"
        }
    },
    defaultVariants: {
        fontSize: "default",
        align: "left"
    }
});
const Text = (param)=>{
    let { className ="" , align , fontSize , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...props,
        className: (0,src_functions/* classNames */.AK)(skeletonTextVariants({
            align,
            fontSize
        })),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,src_functions/* classNames */.AK)(className, "flex w-full h-full rounded-md overflow-hidden animate-pulse bg-black/[0.10] dark:bg-white/[0.10]")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Skeleton/index.ts



const Skeleton = {
    Box: Box,
    Circle: Circle,
    Text: Text
};

;// CONCATENATED MODULE: ./src/components/List/ListItem.tsx




const ListItem = (param)=>{
    let { as , icon: Icon , iconProps , subtitle , title , onClick , className , value , loading =false , ...rest } = param;
    const Component = as || "button";
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        ...rest,
        type: "button",
        onClick: onClick,
        className: (0,src_functions/* classNames */.AK)(className, subtitle ? "items-start" : "items-center", "relative flex gap-4 px-4 py-3 w-full cursor-pointer"),
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Circle, {
                    radius: (ref = iconProps === null || iconProps === void 0 ? void 0 : iconProps.width) !== null && ref !== void 0 ? ref : 18
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-0.5 items-start w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                            fontSize: "sm"
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                            fontSize: "xs"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        minWidth: (ref1 = iconProps === null || iconProps === void 0 ? void 0 : iconProps.width) !== null && ref1 !== void 0 ? ref1 : 18,
                        minHeight: (ref2 = iconProps === null || iconProps === void 0 ? void 0 : iconProps.height) !== null && ref2 !== void 0 ? ref2 : 18,
                        paddingTop: subtitle ? 1 : 0
                    },
                    children: /*#__PURE__*/ react.createElement(Icon, {
                        width: 18,
                        height: 18,
                        strokeWidth: 2,
                        ...iconProps,
                        className: (0,src_functions/* classNames */.AK)(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className, "text-blue-500 rounded-full")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-0.5 items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm font-medium dark:text-slate-200",
                            children: title
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[10px] text-gray-700 dark:text-slate-400 text-left",
                            children: subtitle
                        })
                    ]
                }),
                typeof value === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-xs text-gray-500 dark:text-slate-500",
                    children: value
                }) : value
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/List/ListKeyValue.tsx




const ListKeyValue = (param)=>{
    let { title , subtitle , children , skeleton , flex =false , className =""  } = param;
    if (skeleton) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 gap-2 px-4 py-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-0.5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                            fontSize: "sm"
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                            fontSize: "xs"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                        fontSize: "sm"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,src_functions/* classNames */.AK)(className, flex ? "flex justify-between items-center" : "grid grid-cols-2", "gap-2 py-3 px-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-medium text-gray-600 dark:text-slate-400",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-gray-500 dark:text-slate-500",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex justify-end w-full text-sm font-medium text-right text-gray-900 truncate dark:text-slate-50",
                    children: children
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/List/ListLabel.tsx



const ListLabel = (param)=>{
    let { children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,src_functions/* classNames */.AK)(className, "flex justify-start text-xs font-medium text-gray-500 dark:text-slate-400 px-2"),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/List/ListMenuItem.tsx
"use client";





const ListMenuItem = (param)=>{
    let { as , icon: Icon , iconProps , subtitle , title , onClick , hoverIcon: HoverIcon , hoverIconProps , className , disabled =false , ...rest } = param;
    const Component = as || "button";
    const [hover, setHover] = (0,react.useState)(false);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, {
        ...rest,
        type: "button",
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        onClick: onClick,
        className: (0,src_functions/* classNames */.AK)(className, disabled ? "opacity-40 !pointer-events-none cursor-default" : "", subtitle ? "items-start" : "items-center", "hover:bg-muted relative flex gap-4 px-4 py-3 w-full cursor-pointer rounded-xl"),
        children: [
            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    minWidth: (ref = iconProps === null || iconProps === void 0 ? void 0 : iconProps.width) !== null && ref !== void 0 ? ref : 18,
                    minHeight: (ref1 = iconProps === null || iconProps === void 0 ? void 0 : iconProps.height) !== null && ref1 !== void 0 ? ref1 : 18,
                    paddingTop: subtitle ? 1 : 0
                },
                children: /*#__PURE__*/ react.createElement(Icon, {
                    ...iconProps,
                    width: 18,
                    height: 18,
                    strokeWidth: 2,
                    className: (0,src_functions/* classNames */.AK)(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className, "text-blue-500")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-0.5 items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-medium text-gray-900 dark:text-slate-200",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-normal text-left text-gray-600 dark:text-slate-400",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                as: react.Fragment,
                show: hover,
                enter: "ease-in-out duration-300",
                enterFrom: "translate-x-[10px] opacity-0",
                enterTo: "translate-x-[-8px] opacity-100",
                leave: "ease-in-out duration-300",
                leaveFrom: "translate-x-[-8px] opacity-100",
                leaveTo: "translate-x-[10px] opacity-0",
                unmount: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 bottom-0 right-0 flex items-center justify-center",
                    children: HoverIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverIcon, {
                        ...hoverIconProps,
                        width: (ref2 = hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.width) !== null && ref2 !== void 0 ? ref2 : 20,
                        height: (ref3 = hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.height) !== null && ref3 !== void 0 ? ref3 : 20
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightIcon */.XC, {
                        ...hoverIconProps,
                        width: (ref4 = hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.width) !== null && ref4 !== void 0 ? ref4 : 24,
                        height: (ref5 = hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.height) !== null && ref5 !== void 0 ? ref5 : 24,
                        strokeWidth: (ref6 = hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.strokeWidth) !== null && ref6 !== void 0 ? ref6 : 5,
                        fill: "currentColor",
                        className: (0,src_functions/* classNames */.AK)((hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.className) ? hoverIconProps === null || hoverIconProps === void 0 ? void 0 : hoverIconProps.className : "", "!text-blue")
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/List/index.tsx








const List = (param)=>{
    let { children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,src_functions/* classNames */.AK)("flex flex-col gap-3 pt-3", className),
        children: children
    });
};
List.Item = ListItem;
List.MenuItem = ListMenuItem;
List.Label = ListLabel;
List.Control = ListControl;
List.KeyValue = ListKeyValue;

;// CONCATENATED MODULE: ./src/components/TokenListFilterByQuery/index.tsx





const TokenListFilterByQuery = (param)=>{
    let { children , chainId , tokenMap , balancesMap , pricesMap , includeNative =true  } = param;
    const tokenMapValues = (0,react.useMemo)(()=>Object.values(tokenMap), [
        tokenMap
    ]);
    const inputRef = (0,react.useRef)(null);
    const [query, setQuery] = (0,react.useState)("");
    const debouncedQuery = (0,hooks/* useDebounce */.Nr)(query, 400);
    const searching = (0,react.useRef)(false);
    const _includeNative = includeNative && chainId && (!debouncedQuery || debouncedQuery.toLowerCase().includes(entities/* Native.onChain */._r.onChain(chainId).symbol.toLowerCase()));
    (0,react.useEffect)(()=>{
        if (query.length > 0) {
            searching.current = true;
        }
    }, [
        query
    ]);
    const { data: searchTokenResult , isLoading  } = (0,dist/* useToken */.dQ)({
        address: (0,src_functions/* isAddress */.UJ)(debouncedQuery) && !tokenMap[debouncedQuery.toLowerCase()] ? debouncedQuery : undefined,
        chainId
    });
    const searchToken = (0,react.useMemo)(()=>{
        if (!searchTokenResult || !chainId) return undefined;
        const { decimals , address , symbol , name  } = searchTokenResult;
        return new entities/* Token */.WU({
            chainId,
            decimals,
            address,
            symbol,
            name
        });
    }, [
        chainId,
        searchTokenResult
    ]);
    const filteredTokens = (0,react.useMemo)(()=>{
        const filtered = (0,hooks/* filterTokens */.ls)(tokenMapValues, debouncedQuery);
        searching.current = false;
        return filtered;
    }, [
        tokenMapValues,
        debouncedQuery
    ]);
    const sortedTokens = (0,react.useMemo)(()=>{
        return [
            ...filteredTokens
        ].sort((0,hooks/* tokenComparator */.W8)(balancesMap, pricesMap));
    }, [
        filteredTokens,
        pricesMap,
        balancesMap
    ]);
    const filteredSortedTokens = (0,hooks/* getSortedTokensByQuery */.zh)(sortedTokens, debouncedQuery);
    const filteredSortedTokensWithNative = (0,react.useMemo)(()=>{
        if (_includeNative) return [
            entities/* Native.onChain */._r.onChain(chainId),
            ...filteredSortedTokens
        ];
        return filteredSortedTokens;
    }, [
        _includeNative,
        chainId,
        filteredSortedTokens
    ]);
    return (0,react.useMemo)(()=>{
        return children({
            currencies: filteredSortedTokensWithNative,
            inputRef,
            query,
            onInput: setQuery,
            searching: isLoading || searching.current,
            queryToken: [
                searchToken
            ]
        });
    }, [
        children,
        filteredSortedTokensWithNative,
        isLoading,
        query,
        searchToken
    ]);
};

// EXTERNAL MODULE: ./src/components/Badge/index.ts + 1 modules
var Badge = __webpack_require__(47743);
;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenSelectorRow.tsx










const TokenSelectorRow = /*#__PURE__*/ (0,react.memo)(function TokenSelectorRow(param) {
    let { price , balance , currency , style , disableNative =false , className ="" , onSelect , pin , onPath , midSelector , selected  } = param;
    const onClick = (0,react.useCallback)(()=>{
        onSelect(currency);
    }, [
        currency,
        onSelect
    ]);
    const onPin = (0,react.useCallback)((e)=>{
        e.stopPropagation();
        pin === null || pin === void 0 ? void 0 : pin.onPin();
    }, [
        pin
    ]);
    const ref = (0,react.useRef)(null);
    const inViewport = (0,hooks/* useInViewport */.NM)(ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: onClick,
        className: (0,src_functions/* classNames */.AK)(className, "group flex items-center  hover:bg-blue-600 focus:bg-red-500 h-[48px] token-".concat(currency === null || currency === void 0 ? void 0 : currency.symbol)),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between flex-grow gap-2 rounded cursor-pointer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center flex-grow gap-2",
                    children: [
                        selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            // position="bottom-right"
                            badgeContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rounded-full bg-slate-300",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CheckCircleIcon */.rE, {
                                    width: 14,
                                    height: 14,
                                    className: "rounded-full fill-fire1"
                                })
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-7 h-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                    disableLink: true,
                                    currency: currency,
                                    width: 28,
                                    height: 28,
                                    priority: inViewport
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-7 w-7",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                disableLink: true,
                                currency: currency,
                                width: 28,
                                height: 28,
                                priority: inViewport
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-xs font-medium text-primary group-hover:text-slate-50",
                                    children: disableNative && currency.symbol === entities/* Native.onChain */._r.onChain(currency.chainId).wrapped.symbol ? entities/* Native.onChain */._r.onChain(currency.chainId).symbol : currency.symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-xs text-slate-500 group-hover:text-blue-100",
                                    children: disableNative && currency.name === entities/* Native.onChain */._r.onChain(currency.chainId).wrapped.name ? entities/* Native.onChain */._r.onChain(currency.chainId).name : currency.name
                                })
                            ]
                        })
                    ]
                }),
                (balance === null || balance === void 0 ? void 0 : balance.greaterThan(constants/* ZERO */.xE)) && !midSelector && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-xs font-medium text-right text-primary",
                            children: balance.toSignificant(6)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-right text-xxs text-slate-400",
                            children: price ? "$".concat(balance.multiply(price).toFixed(2)) : "-"
                        })
                    ]
                }),
                onPath && onPath.isPath && midSelector && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                    name: "pin",
                    onClick: onPath.onRemovePath,
                    className: "z-50 mr-2 opacity-50 grayscale",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {
                        className: "w-6 h-6 fill-slate-500"
                    })
                }),
                pin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                    name: "pin",
                    onClick: onPin,
                    className: (0,src_functions/* classNames */.AK)(pin.isPinned ? "" : "grayscale opacity-50", "z-50"),
                    children: "⭐"
                })
            ]
        })
    });
});
const TokenSelectorCustomTokenRow = (param)=>{
    let { style , currency , onRemove  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center w-full p-4",
        style: style,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center justify-between flex-grow gap-2 rounded cursor-pointer",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-row items-center flex-grow gap-2",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "w-7 h-7",
                            children: /*#__PURE__*/ _jsx(Currency.Icon, {
                                disableLink: true,
                                currency: currency,
                                width: 28,
                                height: 28
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col items-start",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "text-xs font-medium text-slate-200",
                                    children: currency.symbol
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ _jsx(NetworkIcon, {
                                            type: "naked",
                                            chainId: currency.chainId,
                                            width: 14,
                                            height: 14
                                        }),
                                        /*#__PURE__*/ _jsx("a", {
                                            className: "text-xxs text-slate-500",
                                            children: chains[currency.chainId].name
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(IconButton, {
                            onClick: onRemove,
                            children: /*#__PURE__*/ _jsx(XCircleIcon, {
                                width: 20,
                                height: 20,
                                className: "text-slate-500"
                            })
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            as: "a",
                            rel: "noopener noreffer",
                            target: "_blank",
                            href: chains[currency.chainId].getTokenUrl(currency.wrapped.address),
                            children: /*#__PURE__*/ _jsx(ExternalLinkIcon, {
                                width: 20,
                                height: 20,
                                className: " fill-blue-500"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenSelectorCurrencyList.tsx








const TokenSelectorCurrencyList = /*#__PURE__*/ (0,react.memo)(function TokenSelectorCurrencyList(param) {
    let { onSelect , currencies , chainId , selected , pin , officialTokenIds , balancesMap , midSelector , onPath , userPath , disableNative  } = param;
    const { address  } = (0,dist/* useAccount */.mA)();
    const { data: pricesMap  } = usePrices({
        chainId
    });
    const rowData = (0,react.useMemo)(()=>{
        if (!currencies) return [];
        return currencies.map((currency)=>{
            return {
                disableNative: disableNative,
                className: (0,src_functions/* classNames */.AK)("!pl-3 !pr-6", midSelector ? "" : "rounded-xl px-4", midSelector && userPath && userPath[chainId] && Object.values(userPath[chainId]).some((t)=>t.address == currency.wrapped.address) ? "!bg-slate-700 " : ""),
                midSelector: midSelector,
                account: address,
                currency: currency,
                balance: balancesMap === null || balancesMap === void 0 ? void 0 : balancesMap[currency.isNative ? constants_address/* zeroAddress */.D : currency.address],
                price: pricesMap === null || pricesMap === void 0 ? void 0 : pricesMap[currency.isNative ? constants_address/* zeroAddress */.D : currency.wrapped.address],
                showWarning: currency.isNative ? false : !officialTokenIds.includes(currency.address),
                onSelect: ()=>onSelect(currency),
                pin: pin ? {
                    onPin: ()=>{
                        return pin === null || pin === void 0 ? void 0 : pin.onPin(currency.id);
                    },
                    isPinned: pin.isPinned(currency.id)
                } : undefined,
                onPath: onPath ? {
                    onRemovePath: ()=>onPath.onRemovePath(currency),
                    isPath: onPath.isPath(currency)
                } : undefined,
                selected: selected ? currency.isNative === true && selected.isNative === true || selected.isToken && currency.isToken && currency.wrapped.address === selected.wrapped.address : false
            };
        });
    }, [
        currencies,
        disableNative,
        midSelector,
        userPath,
        chainId,
        address,
        balancesMap,
        pricesMap,
        officialTokenIds,
        pin,
        onPath,
        selected,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.List */.F.List, {
        className: "scroll",
        rowHeight: 48,
        rowRenderer: TokenSelectorRow,
        rowData: rowData
    });
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-virtualized-auto-sizer/dist/index.esm.js
var index_esm = __webpack_require__(11728);
// EXTERNAL MODULE: ./src/constants/token-lists/index.ts
var token_lists = __webpack_require__(23023);
// EXTERNAL MODULE: ./src/functions/convert/index.ts + 4 modules
var convert = __webpack_require__(6835);
// EXTERNAL MODULE: ./src/hooks/useFetchListCallback.ts
var useFetchListCallback = __webpack_require__(35552);
// EXTERNAL MODULE: ./src/state/lists/actions.ts
var actions = __webpack_require__(53247);
// EXTERNAL MODULE: ./src/wagmi/hooks/useActiveWeb3React.ts + 1 modules
var useActiveWeb3React = __webpack_require__(32553);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.js + 1 modules
var switch_switch = __webpack_require__(73933);
;// CONCATENATED MODULE: ./src/components/Switch/index.tsx



const COLOR = {
    default: (checked)=>checked ? "bg-slate-100" : "bg-slate-100",
    gradient: (checked)=>checked ? "bg-gradient-to-r from-blue-500 to-pink-500" : "bg-slate-700"
};
const HEIGHT = {
    xs: 20,
    sm: 28,
    md: 36
};
const WIDTH = {
    xs: 49,
    sm: 57,
    md: 65
};
const Switch = (param)=>{
    let { size ="md" , checked , onChange , checkedIcon ="" , uncheckedIcon ="" , color ="default" , id =""  } = param;
    const height = HEIGHT[size];
    const width = WIDTH[size];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(switch_switch/* Switch */.r, {
        checked: checked,
        onChange: onChange,
        className: (0,src_functions/* classNames */.AK)(checked ? "bg-slate-800" : "bg-slate-700 bg-opacity-50", "items-center relative inline-flex flex-shrink-0 rounded-full cursor-pointer ease-in-out duration-200 ".concat(id)),
        style: {
            height,
            width
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            id: id,
            className: (0,src_functions/* classNames */.AK)(checked ? "translate-x-[32px]" : "translate-x-[2px]", COLOR[color](checked), "transition-transform pointer-events-none p-1 rounded-full ease-in-out duration-200 inline-flex items-center justify-center"),
            style: {
                height: height - 6,
                width: height - 6,
                transform: "translate(".concat(checked ? 30 : 2, ", 0)")
            },
            children: checked ? checkedIcon : uncheckedIcon
        })
    });
};
/* harmony default export */ var components_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenSelectorCustomTokensOverlay.tsx

























const TokenSelectorCustomTokensRow = (param)=>{
    let { currency , onRemove  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center w-full p-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between flex-grow gap-2 rounded cursor-pointer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center flex-grow gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-7 h-7",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                disableLink: true,
                                currency: currency,
                                width: 28,
                                height: 28
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-xs font-medium text-slate-200",
                                    children: currency.symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NetworkIcon */.dF, {
                                            type: "naked",
                                            chainId: currency.chainId,
                                            width: 14,
                                            height: 14
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-xxs text-slate-500",
                                            children: constants/* chains */.p5[currency.chainId].name
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                            onClick: onRemove,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* XCircleIcon */.oO, {
                                width: 20,
                                height: 20,
                                className: "text-slate-500"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                            as: "a",
                            rel: "noopener noreffer",
                            target: "_blank",
                            href: constants/* chains */.p5[currency.chainId].getTokenUrl(currency.wrapped.address),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ExternalLinkIcon */.h0, {
                                width: 20,
                                height: 20,
                                className: " fill-blue-500"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const TokenSelectorCustomTokensOverlay = (param)=>{
    let { customTokensMap , onRemoveToken  } = param;
    // used for import list
    const [importList, setImportList] = (0,react.useState)();
    const [listURL, setListUrl] = (0,react.useState)();
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const { publicClient  } = (0,useActiveWeb3React/* default */.Z)();
    const [listUrlInput, setListUrlInput] = (0,react.useState)("");
    const lists = (0,lists_hooks/* useAllLists */.R0)();
    // user must accept
    const [confirmed, setConfirmed] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    // monitor is list is loading
    const [_addError, _setAddError] = (0,react.useState)(null);
    const [ids, tokens] = (0,react.useMemo)(()=>{
        const ids = [];
        const tokens = [];
        if (customTokensMap) {
            Object.entries(customTokensMap).forEach((param)=>{
                let [k, v] = param;
                ids.push(k);
                tokens.push(v);
            });
        }
        return [
            ids,
            tokens
        ];
    }, [
        customTokensMap
    ]);
    const rowData = (0,react.useMemo)(()=>{
        if (!customTokensMap) return [];
        return Object.values(customTokensMap).map((currency)=>({
                currency: currency,
                onRemove: ()=>onRemoveToken({
                        chainId: currency.chainId,
                        address: currency.wrapped.address
                    })
            }));
    }, [
        customTokensMap,
        onRemoveToken
    ]);
    // sort by active but only if not visible
    const activeListUrls = (0,lists_hooks/* useActiveListUrls */.v0)();
    const [activeCopy, setActiveCopy] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (!activeCopy && activeListUrls) {
            setActiveCopy(activeListUrls);
        }
    }, [
        activeCopy,
        activeListUrls
    ]);
    const fetchList = (0,useFetchListCallback/* useFetchListCallback */.j)(publicClient);
    const validUrl = (0,react.useMemo)(()=>{
        return (0,convert/* uriToHttp */.ie)(listUrlInput).length > 0 || Boolean((0,src_functions/* parseENSAddress */.yw)(listUrlInput));
    }, [
        listUrlInput
    ]);
    const sortedLists = (0,react.useMemo)(()=>{
        const listUrls = Object.keys(lists || {}).filter((l)=>l !== token_lists/* EMBERSWAP_LIST */.wI);
        return listUrls.filter((listUrl)=>{
            var ref;
            // only show loaded lists, hide unsupported lists
            return Boolean((ref = lists[listUrl]) === null || ref === void 0 ? void 0 : ref.current) && !token_lists/* UNSUPPORTED_LIST_URLS.includes */.US.includes(listUrl);
        }).sort((u1, u2)=>{
            const { current: l1  } = lists[u1];
            const { current: l2  } = lists[u2];
            // first filter on active lists
            if ((activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u1)) && !(activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u2))) {
                return -1;
            }
            if (!(activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u1)) && (activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u2))) {
                return 1;
            }
            if (l1 && l2) {
                return l1.name.toLowerCase() < l2.name.toLowerCase() ? -1 : l1.name.toLowerCase() === l2.name.toLowerCase() ? 0 : 1;
            }
            if (l1) return -1;
            if (l2) return 1;
            return 0;
        });
    }, [
        lists,
        activeCopy
    ]);
    // temporary fetched list for import flow
    const [tempList, setTempList] = (0,react.useState)();
    const [addError, setAddError] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        /** */ async function fetchTempList() {
            fetchList(listUrlInput, false).then((list)=>setTempList(list)).catch(()=>setAddError("Error importing list"));
        }
        // if valid url, fetch details for card
        if (validUrl) {
            fetchTempList();
        } else {
            setTempList(undefined);
            listUrlInput !== "" && setAddError("Enter valid list location");
        }
        // reset error
        if (listUrlInput === "") {
            setAddError(undefined);
        }
    }, [
        fetchList,
        listUrlInput,
        validUrl
    ]);
    // check if list is already imported
    const isImported = Object.keys(lists).includes(listUrlInput);
    // set list values and have parent modal switch to import list view
    const handleImport = (0,react.useCallback)(()=>{
        if (!tempList) return;
        setImportList(tempList);
        // setModalView(CurrencyModalView.importList)
        setListUrl(listUrlInput);
    }, [
        listUrlInput,
        setImportList,
        setListUrl,
        tempList
    ]);
    const handleAddList = (0,react.useCallback)(()=>{
        if (listURL) {
            var ref;
            const adding = Boolean((ref = lists[listURL]) === null || ref === void 0 ? void 0 : ref.loadingRequestId);
            if (adding) {
                return;
            } else {
                _setAddError(null);
                fetchList(listURL).then(()=>{
                    // turn list on
                    dispatch((0,actions/* enableList */.ic)(listURL));
                    setListUrl("");
                    setImportList(undefined);
                    setListUrlInput("");
                    setConfirmed(false);
                // go back to lists
                // setModalView(CurrencyModalView.manage)
                }).catch((error)=>{
                    _setAddError(error.message);
                    dispatch((0,actions/* removeList */.J_)(listURL));
                });
            }
        }
    }, [
        dispatch,
        fetchList,
        listURL,
        lists
    ]);
    const isImportList = (0,react.useMemo)(()=>Boolean(listURL && importList), [
        importList,
        listURL
    ]);
    const handleRemoveList = (0,react.useCallback)((listUrl)=>{
        dispatch((0,actions/* removeList */.J_)(listUrl));
    }, [
        dispatch
    ]);
    const handleEnableList = (0,react.useCallback)((listUrl)=>{
        dispatch((0,actions/* enableList */.ic)(listUrl));
    }, [
        dispatch
    ]);
    const handleDisableList = (0,react.useCallback)((listUrl)=>{
        dispatch((0,actions/* disableList */.K$)(listUrl));
    }, [
        dispatch
    ]);
    const onClose = (0,react.useCallback)(()=>{
        setListUrl("");
        setImportList(undefined);
        setConfirmed(false);
    }, []);
    if (!isMounted) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute top-0 left-0 w-full h-full p-6 mt-12 !bg-transparent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Group, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.List, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab, {
                            children: [
                                "Tokens (",
                                ids.length || "0",
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab, {
                            children: [
                                "Lists (",
                                (activeListUrls === null || activeListUrls === void 0 ? void 0 : activeListUrls.filter((l)=>l !== token_lists/* EMBERSWAP_LIST */.wI).length) || "0",
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Panels, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab.Panel, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-2 px-3 py-2 mt-2 rounded-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative min-h-[320px] rounded-t-none lg:max-h-[calc(100%-108px)] rounded-xl overflow-hidden h-full",
                                    children: [
                                        tokens.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 flex items-center justify-center pointer-events-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col items-center justify-center gap-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "flex text-xs italic text-primary",
                                                    children: "No custom tokens found"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.List */.F.List, {
                                            className: "scroll",
                                            rowHeight: 48,
                                            rowRenderer: TokenSelectorCustomTokensRow,
                                            rowData: rowData
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Panel, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-2 px-3 py-2 mt-2 rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,src_functions/* classNames */.AK)("relative flex items-center justify-between gap-2 px-3 mx-0  rounded-2xl py-1.5 text-primary bg-tokenselectorlist", !importList && listUrlInput !== "" ? "!ring-2 !ring-red-500 focus:!ring-transparent focus-within:!ring-secondarybg  selection:" : importList ? "!ring-2 !ring-green-500" : "focus-within:!ring-2 focus-within:!ring-secondarybg"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Address, {
                                                    type: "text",
                                                    id: "lists-importer",
                                                    placeholder: "Add list by HTTPS, IPFS or ENS",
                                                    variant: "unstyled",
                                                    value: listUrlInput !== null && listUrlInput !== void 0 ? listUrlInput : "",
                                                    onChange: (val)=>setListUrlInput(val),
                                                    className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, "!bg-transparent btn w-full flex group !text-primary  placeholder:text-slate-800 !font-medium  gap-2 cursor-pointer opacity-80 hover:opacity-100 hover:bg-opacity-70 px-4 h-[34px] rounded-xl text-base")
                                                }),
                                                listUrlInput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* XCircleIcon */.oO, {
                                                    width: 20,
                                                    height: 20,
                                                    className: "cursor-pointer text-slate-500 hover:text-slate-300",
                                                    onClick: ()=>setListUrlInput("")
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SearchIcon */.W1, {
                                                    className: "text-slate-500",
                                                    strokeWidth: 2,
                                                    width: 20,
                                                    height: 20
                                                })
                                            ]
                                        }),
                                        addError && !tempList ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            title: addError,
                                            className: "overflow-hidden text-red-500 text-ellipsis",
                                            children: addError
                                        }) : null,
                                        tempList && !isImported ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TokenListLayout, {
                                            tokenList: tempList,
                                            listURL: listUrlInput,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex gap-1 px-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        size: "xs",
                                                        width: "md",
                                                        variant: "filled",
                                                        color: "red",
                                                        onClick: handleImport,
                                                        children: "Import"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full overflow-y-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-full min-h-[300px] pt-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                                                    disableWidth: true,
                                                    children: (param)=>{
                                                        let { height  } = param;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                height
                                                            },
                                                            className: "space-y-2",
                                                            children: sortedLists.map((listUrl)=>{
                                                                const { current: list  } = lists[listUrl];
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: list && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TokenListLayout, {
                                                                        tokenList: list,
                                                                        listURL: listUrl,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                onClick: ()=>handleRemoveList(listUrl),
                                                                                className: "right-0 pr-3 text-slate-700 hover:text-slate-600 justify-self-end text-end",
                                                                                children: "Remove"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "flex gap-1 pr-2",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Switch, {
                                                                                    checked: Boolean(activeListUrls === null || activeListUrls === void 0 ? void 0 : activeListUrls.includes(listUrl)),
                                                                                    onChange: ()=>{
                                                                                        return (activeListUrls === null || activeListUrls === void 0 ? void 0 : activeListUrls.includes(listUrl)) ? handleDisableList(listUrl) : handleEnableList(listUrl);
                                                                                    },
                                                                                    size: "sm"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, listUrl)
                                                                });
                                                            })
                                                        });
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportDialog, {
                                    setConfirmed: setConfirmed,
                                    handleAddList: handleAddList,
                                    open: isImportList,
                                    onClose: onClose,
                                    importList: importList,
                                    listURL: listURL,
                                    confirmed: confirmed,
                                    _addError: _addError
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const TokenListLayout = (param)=>{
    let { tokenList , listURL , children  } = param;
    var ref;
    const listUrl = listURL ? "https://tokenlists.org/token-list?url=".concat(listURL) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
        className: "transition rounded-xl items-center bg-tokenselectorlist !flex-row !pt-0 px-2",
        children: [
            (tokenList === null || tokenList === void 0 ? void 0 : tokenList.logoURI) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                width: 40,
                height: 40,
                src: tokenList.logoURI,
                alt: "".concat(tokenList === null || tokenList === void 0 ? void 0 : tokenList.name, " list logo")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "40px",
                    height: "40px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List.Control, {
                className: "relative flex flex-col flex-1 flex-grow !bg-transparent justify-center px-1 py-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        rel: "noreferrer",
                        target: "_blank",
                        href: listUrl,
                        className: "overflow-hidden text-sm font-medium text-ellipsis",
                        children: tokenList === null || tokenList === void 0 ? void 0 : tokenList.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between w-full text-xxs",
                        children: [
                            tokenList === null || tokenList === void 0 ? void 0 : tokenList.tokens.length,
                            " tokens",
                            children === null || children === void 0 ? void 0 : children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xxs text-primary",
                        children: ((ref = tokenList === null || tokenList === void 0 ? void 0 : tokenList.tokens[0]) === null || ref === void 0 ? void 0 : ref.chainId) && [
                            ...new Set(tokenList === null || tokenList === void 0 ? void 0 : tokenList.tokens.map((t)=>t.chainId))
                        ].reduce((accumulator, currentChainId, index)=>{
                            if (index === 0) {
                                return entities/* Chain.from */.qo.from(currentChainId).name;
                            } else {
                                return accumulator + ", " + entities/* Chain.from */.qo.from(currentChainId).name;
                            }
                        }, "")
                    })
                ]
            }),
            children === null || children === void 0 ? void 0 : children[1]
        ]
    });
};
const ImportDialog = (param)=>{
    let { handleAddList , onClose , open , importList , listURL , confirmed , _addError , setConfirmed  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog */.V, {
        onClose: onClose,
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.V.Content, {
            className: "!bg-tokenselector gradient-backdrop-blur !mb-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog.Header */.V.Header, {
                    onClose: onClose,
                    title: "Import List"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                    className: "transition overflow-hidden relative lg:max-h-[calc(100%-108px)] border-t -ml-3 -mr-3 p-4 rounded-t-none border-slate-200/5 rounded-xl items-center !pt-0 px-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col w-auto h-auto gap-3 p-4",
                            children: [
                                importList && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenListLayout, {
                                    tokenList: importList,
                                    listURL: listURL
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid justify-center grid-flow-col gap-4 mb-3 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WarningIconRound */.d$, {
                                            className: "text-red-500",
                                            height: 32,
                                            width: 32
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-medium text-red-500",
                                            children: "Import at your own risk "
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid gap-4 mb-3 text-xs text-center text-primary",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-medium ",
                                            children: "By adding this list you are implicitly trusting that the data is correct. Anyone can create a list, including creating fake versions of existing lists and lists that claim to represent projects that do not have one."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-bold text-red-500",
                                            children: "If you purchase a token from this list, you may not be able to sell it back."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-center w-full p-0 cursor-pointer select-none wrap",
                                    onClick: ()=>setConfirmed(!confirmed),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "h-5 m-0 bg-red-500",
                                            name: "confirmed",
                                            type: "checkbox",
                                            checked: confirmed,
                                            onChange: ()=>setConfirmed(!confirmed)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-primary ml-2.5 font-medium text-xxs",
                                            children: "I understand"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            fullWidth: true,
                            className: "!rounded-xl !px-2",
                            color: "gradient",
                            variant: "outlined",
                            size: "xl",
                            style: {
                                borderRadius: "20px",
                                padding: "10px 1rem"
                            },
                            disabled: !confirmed,
                            onClick: handleAddList,
                            children: "Import"
                        }),
                        _addError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            title: _addError,
                            className: "overflow-hidden text-red-500 overflow-ellipsis",
                            children: _addError
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenSelectorSettingsOverlay.tsx






const TokenSelectorSettingsOverlay = (param)=>{
    let { customTokensMap , onRemoveToken  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                className: "group w-[24px] h-[24px] flex items-center justify-center",
                onClick: ()=>{
                    setOpen(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CodeIcon */.dN, {
                    width: 20,
                    height: 20,
                    className: "duration-1000 ease-in-out group-hover:text-gray-500 text-slate-100"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn/* SlideIn.FromLeft */.oX.FromLeft, {
                show: open,
                onClose: ()=>setOpen(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Overlay/* Overlay.Content */.a.Content, {
                    className: "!bg-tokenselector gradient-backdrop-blur shadow-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay.Header */.a.Header, {
                            className: "!bg-transparent ",
                            onClose: ()=>setOpen(false),
                            title: "Settings"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectorCustomTokensOverlay, {
                            customTokensMap: customTokensMap,
                            onRemoveToken: onRemoveToken
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/TokenSelector/TokenSelector.tsx



// import { buttonIconVariants } from '@sushiswap/ui/components/button'

// import { useOtherTokenListsQuery } from 'useContracthooks/useOtherTokenLists'








// import { useTokenWithCache } from '../../hooks'













/**
 * @param {string}address 
 * @return {string}
 */ function TokenSelector_getAddress(address) {
    if (address === "NATIVE") return "NATIVE";
    return (0,getAddress/* getAddress */.K)(address);
}
const TokenSelector = /*#__PURE__*/ (0,react.memo)(function TokenSelector(param) {
    let { currency , open , chainId , onClose , onSelect , includeNative =true , title , midSelector , hidePinnedTokens , hideSearch , isLoading  } = param;
    const { address  } = (0,dist/* useAccount */.mA)();
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const { data: pricesMap  } = usePrices({
        chainId
    });
    const [customTokenMap, { addCustomToken , removeCustomToken  }] = (0,user_hooks/* useCustomTokens */.Xd)(chainId);
    const defaultTokenMap = useTokens(chainId);
    const [{ pinnedTokens: pinnedTokenMap , userPath  }, { resetPath , removePath , addPinnedToken , removePinnedToken  }] = (0,user_hooks/* useSettings */.rV)(chainId);
    const _tokenMap = (0,react.useMemo)(()=>({
            ...defaultTokenMap,
            ...customTokenMap
        }), [
        defaultTokenMap,
        customTokenMap
    ]);
    const _tokenMapValues = (0,react.useMemo)(()=>{
        return Object.values(_tokenMap);
    }, [
        _tokenMap
    ]);
    const { data: balancesMap  } = useBalances({
        account: address,
        chainId,
        currencies: _tokenMapValues,
        enabled: open && !midSelector
    });
    // console.log(balancesMap)
    const officialTokenIds = (0,react.useMemo)(()=>{
        if (!defaultTokenMap) return [];
        return Object.values(defaultTokenMap).map((el)=>el.wrapped.address);
    }, [
        defaultTokenMap
    ]);
    const pinnedTokens = (0,react.useMemo)(()=>{
        var ref;
        return ((ref = pinnedTokenMap === null || pinnedTokenMap === void 0 ? void 0 : pinnedTokenMap[chainId]) !== null && ref !== void 0 ? ref : []).map((id)=>{
            const [, address] = id.split(":");
            if (address === "NATIVE") return entities/* Native.onChain */._r.onChain(chainId);
            return (defaultTokenMap === null || defaultTokenMap === void 0 ? void 0 : defaultTokenMap[address]) || (customTokenMap === null || customTokenMap === void 0 ? void 0 : customTokenMap[address]);
        }).filter((token)=>!!token);
    }, [
        chainId,
        customTokenMap,
        pinnedTokenMap,
        defaultTokenMap
    ]);
    const hasToken = (0,react.useCallback)((currency)=>{
        var ref;
        if (typeof currency === "string") {
            var ref1;
            if (!currency.includes(":")) {
                throw new Error("Address provided instead of id");
            }
            const [chainId, address] = currency.split(":");
            if (address !== "NATIVE" && !(0,isAddress/* isAddress */.U)(address)) {
                throw new Error("Address provided not a valid ERC20 address");
            }
            return pinnedTokenMap === null || pinnedTokenMap === void 0 ? void 0 : (ref1 = pinnedTokenMap[chainId]) === null || ref1 === void 0 ? void 0 : ref1.includes("".concat(chainId, ":").concat(TokenSelector_getAddress(address)));
        }
        return !!(pinnedTokenMap === null || pinnedTokenMap === void 0 ? void 0 : (ref = pinnedTokenMap[currency.chainId]) === null || ref === void 0 ? void 0 : ref.includes(currency.id));
    }, [
        pinnedTokenMap
    ]);
    const _onPin = (0,react.useCallback)((currencyId)=>{
        if (!hasToken(currencyId)) {
            addPinnedToken(currencyId);
        } else {
            removePinnedToken(currencyId);
        }
    }, [
        addPinnedToken,
        hasToken,
        removePinnedToken
    ]);
    const isPath = (0,react.useCallback)((currency)=>{
        if (userPath && chainId && userPath[chainId]) {
            return Object.values(userPath[chainId]).some((t)=>t.address == currency.wrapped.address);
        }
        return false;
    }, [
        chainId,
        userPath
    ]);
    const _onRemovePath = (0,react.useCallback)((currency)=>{
        removePath && removePath({
            chainId: currency.chainId,
            address: currency.wrapped.address
        });
        chainId && userPath && Object.values(userPath[chainId]).length < 0 && setActiveTokens(false);
    }, [
        chainId,
        removePath,
        userPath
    ]);
    const [activeTokens, setActiveTokens] = (0,react.useState)(false);
    const handleSelect = (0,react.useCallback)((currency)=>{
        onSelect(currency);
        !midSelector && onClose();
    }, [
        midSelector,
        onClose,
        onSelect
    ]);
    const handleImport = (0,react.useCallback)((currency)=>{
        addCustomToken(currency);
        handleSelect(currency);
    }, [
        handleSelect,
        addCustomToken
    ]);
    return (0,react.useMemo)(()=>{
        if (!isMounted) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenListFilterByQuery, {
            tokenMap: _tokenMap,
            chainId: chainId,
            pricesMap: !midSelector ? pricesMap : undefined,
            balancesMap: !midSelector ? balancesMap : undefined,
            includeNative: includeNative,
            children: (param)=>{
                let { currencies , inputRef , query , onInput , searching , queryToken  } = param;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Dialog/* Dialog */.V, {
                    open: open,
                    onClose: onClose,
                    initialFocus: inputRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog.Content */.V.Content, {
                        className: "!max-w-md overflow-hidden !bg-tokenselector gradient-backdrop-blur !flex flex-col justify-start min-h-[75vh] pb-[16px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideIn/* SlideIn */.oX, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog.Header */.V.Header, {
                                    onClose: onClose,
                                    title: title,
                                    children: !midSelector && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectorSettingsOverlay, {
                                        customTokensMap: customTokenMap,
                                        onRemoveToken: removeCustomToken
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !hideSearch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative flex items-center justify-between w-full gap-1 pr-3 my-3 mb-5 ring-offset-2 ring-offset-secondarybg bg-tokenselectorlist rounded-2xl focus-within:ring-2 text-primary ring-transparent",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Address, {
                                                    variant: "unstyled",
                                                    id: "token-search",
                                                    ref: inputRef,
                                                    title: "Search token by address or symbol",
                                                    placeholder: "Search token by address or symbol",
                                                    value: query,
                                                    onChange: onInput,
                                                    className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, DEFAULT_INPUT_PADDING),
                                                    type: "text"
                                                }),
                                                searching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative left-[-2px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Spinner */.a.Spinner, {
                                                        className: "w-3.5 h-3.5 stroke-[3px] animate-spin-slow text-slate-500"
                                                    })
                                                }) : query ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* XCircleIcon */.oO, {
                                                    width: 20,
                                                    height: 20,
                                                    className: "cursor-pointer text-slate-500 hover:text-slate-300",
                                                    onClick: ()=>onInput("")
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SearchIcon */.W1, {
                                                    className: "text-slate-500",
                                                    strokeWidth: 2,
                                                    width: 20,
                                                    height: 20
                                                })
                                            ]
                                        }) : null,
                                        pinnedTokens && pinnedTokens.length > 0 && !hidePinnedTokens && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap gap-1.5",
                                            children: pinnedTokens.map((token)=>{
                                                if (!includeNative && token.isNative) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                        size: "sm",
                                                        variant: "filled",
                                                        color: "gray",
                                                        className: "group !rounded-xl !text-xs !font-medium",
                                                        onClick: ()=>handleSelect(token),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                                                width: 20,
                                                                height: 20,
                                                                // className={buttonIconVariants({ size: 'default' })}
                                                                currency: token,
                                                                disableLink: true
                                                            }),
                                                            !includeNative && token.symbol === entities/* Native.onChain */._r.onChain(token.chainId).wrapped.symbol ? entities/* Native.onChain */._r.onChain(token.chainId).symbol : token.symbol,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                                                                name: "remove",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    _onPin(token.id);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {
                                                                    width: 16
                                                                })
                                                            }, token.id)
                                                        ]
                                                    }, token.id)
                                                }, token.id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative grid pt-2 ",
                                    children: !midSelector ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-xs text-right pr-16 mb-0.5 text-primary justify-self-end",
                                        children: address && "Balances"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center w-full gap-4 px-4 -mb-1 text-xs justify-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (0,src_functions/* classNames */.AK)("cursor-pointer ", !activeTokens ? " text-slate-200 font-medium" : "text-slate-400"),
                                                onClick: ()=>setActiveTokens(false),
                                                children: "All Tokens"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (0,src_functions/* classNames */.AK)(activeTokens ? "text-slate-200 font-medium" : "text-slate-400", chainId && userPath && userPath[chainId] && Object.values(userPath[chainId]).length > 0 ? "cursor-pointer" : "cursor-not-allowed"),
                                                onClick: ()=>{
                                                    var ref;
                                                    chainId && userPath && userPath[chainId] && ((ref = Object.values(userPath[chainId])) === null || ref === void 0 ? void 0 : ref.length) > 0 && setActiveTokens(true);
                                                },
                                                children: "Active Tokens"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                onClick: ()=>resetPath && chainId && resetPath(chainId),
                                                className: "!px-2 !py-1 !h-auto ml-auto mb-1 hover:text-slate-300 hover:font-bold transition-all duration-500 !font-medium text-slate-400/60 hover:from-orange-500/70 hover:via-red-500/70 hover:to-yellow-500/70 from-orange-500/40 via-red-500/40 to-yellow-500/40 bg-gradient-to-t",
                                                children: "Reset Path"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(List.Control, {
                                    className: (0,src_functions/* classNames */.AK)(midSelector ? "mt-2" : "px-1 py-1", "relative flex flex-col flex-1 flex-grow !bg-tokenselectorlist rounded-xl"),
                                    children: [
                                        queryToken[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectorImportRow, {
                                            className: "!px-6",
                                            currencies: queryToken,
                                            onImport: ()=>queryToken[0] && handleImport(queryToken[0])
                                        }),
                                        /* isQueryTokenLoading ||*/ isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "py-0.5 h-[64px] -mb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center w-full h-full px-3 rounded-lg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-between flex-grow gap-2 rounded",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-row items-center flex-grow gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Circle, {
                                                                    radius: 40
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col items-start",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                                                                            className: "w-full"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                                                                            fontSize: "sm",
                                                                            className: "w-full"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-col w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                                                                    className: "w-[80px]"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                                                                    fontSize: "sm",
                                                                    align: "right",
                                                                    className: "w-[40px]"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectorCurrencyList, {
                                                    disableNative: !includeNative,
                                                    midSelector: midSelector,
                                                    balancesMap: balancesMap,
                                                    userPath: userPath,
                                                    selected: currency,
                                                    onSelect: handleSelect,
                                                    pin: {
                                                        onPin: _onPin,
                                                        isPinned: hasToken
                                                    },
                                                    onPath: {
                                                        onRemovePath: _onRemovePath,
                                                        isPath: isPath
                                                    },
                                                    officialTokenIds: officialTokenIds,
                                                    currencies: activeTokens && midSelector ? currencies.filter((c)=>chainId && userPath && userPath[chainId] && Object.values(userPath[chainId]).some((t)=>t.address == c.wrapped.address)) : currencies,
                                                    chainId: chainId
                                                }),
                                                currencies.length === 0 && !queryToken && chainId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute inset-0 flex items-center justify-center pointer-events-none",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col items-center justify-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "flex text-xs italic text-slate-500",
                                                                children: "No tokens found on"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: "flex gap-1 text-xs italic font-medium text-slate-500",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NetworkIcon */.dF, {
                                                                        width: 14,
                                                                        height: 14,
                                                                        chainId: chainId
                                                                    }),
                                                                    " ",
                                                                    constants/* chains */.p5[chainId].name
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                });
            }
        });
    }, [
        isMounted,
        _tokenMap,
        chainId,
        midSelector,
        pricesMap,
        balancesMap,
        includeNative,
        open,
        onClose,
        title,
        customTokenMap,
        removeCustomToken,
        hideSearch,
        pinnedTokens,
        hidePinnedTokens,
        address,
        activeTokens,
        userPath,
        isLoading,
        currency,
        handleSelect,
        _onPin,
        hasToken,
        _onRemovePath,
        isPath,
        officialTokenIds,
        resetPath,
        handleImport
    ]);
});

;// CONCATENATED MODULE: ./src/components/TokenSelector/index.ts







// EXTERNAL MODULE: ./src/components/Tooltip/index.tsx
var Tooltip = __webpack_require__(54218);
;// CONCATENATED MODULE: ./src/components/SettingsOverlay/CurrencyCombinationDisclosure.tsx












const CurrencyCombinationDisclosure = (param)=>{
    let { chainId  } = param;
    const [tokenOverlay, setTokenOverlayOpen] = (0,react.useState)(false);
    const tokenMap = useTokens(chainId);
    const [customTokensMap] = (0,user_hooks/* useCustomTokens */.Xd)(chainId);
    const _tokenMap = (0,react.useMemo)(()=>({
            ...tokenMap,
            ...customTokensMap
        }), [
        tokenMap,
        customTokensMap
    ]);
    const _tokenMapValues = (0,react.useMemo)(()=>{
        return Object.values(_tokenMap);
    }, [
        _tokenMap
    ]);
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const [{ userPath , userPathType  }, { removePath , addPath , updateUserPathType  }] = (0,user_hooks/* useSettings */.rV)(chainId);
    const onSelect = (0,react.useCallback)((currency)=>{
        if (userPath[currency.chainId] && Object.values(userPath[currency.chainId]).some((t)=>t.address == currency.wrapped.address)) {
            removePath && removePath({
                chainId: currency.chainId,
                address: currency.wrapped.address
            });
        } else {
            addPath && addPath(currency);
        }
    }, [
        addPath,
        removePath,
        userPath
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        setTokenOverlayOpen(false);
    }, []);
    return (0,react.useMemo)(()=>{
        if (!isMounted) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                    children: (param)=>/*#__PURE__*/ {
                        let { open  } = param;
                        return (0,jsx_runtime.jsxs)("div", {
                            className: "border-b select-none border-slate-200/5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                    as: "div",
                                    className: "relative flex items-center justify-between w-full gap-3 cursor-pointer group rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center w-5 h-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: "-ml-1.5 text-slate-500",
                                                width: "28",
                                                height: "28",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 100 125",
                                                x: "2px",
                                                y: "2px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeWidth: 2,
                                                    stroke: "#97A3B7",
                                                    d: "m 40.875,6.84375 c -1.79015,0 -3.250011,1.459904 -3.25,3.25 l 0,27.53125 -21.59375,0 5.1875,-5.15625 c 1.269627,-1.261979 1.26583,-3.296709 0,-4.5625 -0.632915,-0.632897 -1.482964,-0.96875 -2.3125,-0.96875 -0.829537,0 -1.64742,0.336773 -2.28125,0.96875 L 5.9375,38.5625 c -1.26766,1.263953 -1.2639608,3.326093 0,4.59375 L 16.625,53.875 c 1.26396,1.267656 3.327921,1.265793 4.59375,0 1.265829,-1.26579 1.269628,-3.331771 0,-4.59375 l -5.1875,-5.15625 21.59375,0 0,11.75 c 2.1e-5,3.580201 2.919691,6.5 6.5,6.5 l 11.75,0 0,27.5625 c 1e-5,1.790097 1.459851,3.21875 3.25,3.21875 1.790151,0 3.250011,-1.428653 3.25,-3.21875 l 0,-27.5625 21.59375,0 -5.1875,5.15625 c -1.269627,1.261979 -1.26583,3.296709 0,4.5625 0.632913,0.632896 1.482964,0.96875 2.3125,0.96875 0.829537,0 1.64742,-0.336773 2.28125,-0.96875 L 94.0625,61.4375 c 1.26766,-1.263954 1.263961,-3.326093 0,-4.59375 L 83.375,46.125 c -1.263959,-1.267655 -3.32792,-1.265793 -4.59375,0 -1.265828,1.265791 -1.269627,3.331771 0,4.59375 l 5.1875,5.15625 -21.59375,0 0,-11.75 c -2.1e-5,-3.580201 -2.91969,-6.5 -6.5,-6.5 l -11.75,0 0,-27.53125 c -1.1e-5,-1.790096 -1.459851,-3.25 -3.25,-3.25 z m 3.25,37.28125 11.75,0 0,11.75 -11.75,0 z",
                                                    fill: "#97A3B7"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid items-center justify-between w-full grid-cols-10 gap-1 py-4 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center col-span-5 gap-1 text-sm font-medium text-left break-words ",
                                                    children: [
                                                        "Currency Combinations",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                            button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* InformationCircleIcon */.AV, {
                                                                width: 14,
                                                                height: 14
                                                            }),
                                                            panel: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex flex-col gap-2 w-80",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-xs font-medium text-slate-300",
                                                                        children: "Currency combinations play a crucial role in facilitating trading between different tokens. The currency combinations are intermediary tokens used to establish liquidity and enable seamless trading between two other tokens that may not have a direct trading pair."
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-xs font-medium text-slate-300",
                                                                        children: "Currency combinations empower traders to access a wider range of assets while maintaining the decentralized and non-custodial nature of the exchange."
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-end col-span-5 gap-1",
                                                    children: [
                                                        userPathType === "auto" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-sm font-medium group-hover:text-slate-400 text-slate-600",
                                                            children: "Auto"
                                                        }) : userPath && _tokenMap && chainId && userPath[chainId] && Object.values(userPath[chainId]).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex w-full h-full overflow-hidden overflow-x-scroll text-sm font-medium rounded-md scrollableContainer whitespace-nowrap group-hover:text-slate-400 text-slate-600",
                                                            onWheel: (e)=>e.currentTarget.scrollBy(e.deltaY / 4, 0),
                                                            children: _tokenMapValues.map((t)=>{
                                                                if (chainId && t && userPath[chainId] && Object.values(userPath[chainId]).some((z)=>z.address === t.wrapped.address)) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "p-1 m-0 flex flex-row items-center flex-grow gap-0.5 max-w-max ",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "w-8 h-8 p-1 m-0 flex items-center flex-grow gap-0.5 max-w-max ",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                                                                currency: t,
                                                                                width: 32,
                                                                                height: 32,
                                                                                disableLink: true
                                                                            })
                                                                        })
                                                                    });
                                                                }
                                                                return;
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-sm font-medium group-hover:text-slate-400 text-slate-600",
                                                            children: "Custom"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,src_functions/* classNames */.AK)(open ? "rotate-90" : "rotate-0", "transition-all w-5 h-5 -mr-1.5 flex items-center delay-300"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightIcon */.XC, {
                                                                width: 16,
                                                                height: 16,
                                                                className: "group-hover:text-slate-200 text-slate-300"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                    unmount: false,
                                    className: "transition-[max-height] overflow-hidden mb-3",
                                    enter: "duration-300 ease-in-out",
                                    enterFrom: "transform max-h-0",
                                    enterTo: "transform max-h-[380px]",
                                    leave: "transition-[max-height] duration-250 ease-in-out",
                                    leaveFrom: "transform max-h-[380px]",
                                    leaveTo: "transform max-h-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Group, {
                                            selectedIndex: userPathType === "auto" ? 0 : 1,
                                            onChange: (index)=>updateUserPathType(index === 0 ? "auto" : "custom"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.List, {
                                                    className: "grid-cols-8 md:grid-cols-none md:flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                                            className: (0,src_functions/* classNames */.AK)(userPathType === "auto" ? "bg-slate-400/20" : "", "col-span-3 md:!flex-1 !rounded-none !border-transparent hover:bg-slate-400/40"),
                                                            children: "Auto"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                                            onClick: ()=>userPathType !== "auto" && setTokenOverlayOpen(true),
                                                            className: (0,src_functions/* classNames */.AK)(userPathType !== "auto" ? "bg-slate-400/20" : "", "col-span-5 md:!flex-1 !rounded-none border-transparent hover:bg-slate-400/40"),
                                                            children: userPathType !== "auto" ? "Change Path" : "Custom"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab.Panel, {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelector, {
                    title: "Change Path",
                    onSelect: onSelect,
                    currency: undefined,
                    open: tokenOverlay,
                    chainId: chainId,
                    onClose: handleClose,
                    includeNative: false,
                    midSelector: true
                })
            ]
        });
    }, [
        _tokenMap,
        _tokenMapValues,
        chainId,
        handleClose,
        isMounted,
        onSelect,
        tokenOverlay,
        updateUserPathType,
        userPath,
        userPathType
    ]);
};

;// CONCATENATED MODULE: ./src/components/SettingsOverlay/ExchangeOverlay.tsx








const ExchangeOverlay = ()=>{
    const [{ userSlippageTolerance , slippageToleranceType  }, { updateSlippageTolerance , updateSlippageToleranceType  }] = (0,user_hooks/* useSettings */.rV)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)("div", {
                className: "border-b border-slate-200/5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                        as: "div",
                        className: "relative flex items-center justify-between w-full gap-3 cursor-pointer group rounded-xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center w-5 h-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "-ml-0.5 text-slate-500",
                                    width: "20",
                                    height: "12",
                                    viewBox: "0 0 20 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m18.617 6.797-8.125 5a.922.922 0 0 1-.492.14.984.984 0 0 1-.46-.117.953.953 0 0 1-.477-.82V2.68L2.367 6.797a.937.937 0 0 1-.984-1.594l8.125-5a.93.93 0 0 1 1.43.797v8.32l6.695-4.117a.938.938 0 0 1 .984 1.594Z",
                                        fill: "#97A3B7"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full gap-1 py-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm font-medium",
                                                children: "Exchanges"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* InformationCircleIcon */.AV, {
                                                    width: 14,
                                                    height: 14
                                                }),
                                                panel: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col gap-2 w-80",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xs font-medium text-slate-300",
                                                            children: "Slippage tolerance is the utmost percentage of slippage a user is willing to execute a trade with; if the actual slippage falls outside of the user-designated range, the transaction will revert."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xs font-medium text-slate-300",
                                                            children: "Slippage is the difference between the expected value of output from a trade and the actual value due to asset volatility and liquidity depth."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm font-medium group-hover:text-slate-400 text-slate-600",
                                                children: slippageToleranceType === "auto" ? "Auto" : "Custom (".concat(Number(userSlippageTolerance), "%)")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,src_functions/* classNames */.AK)(open ? "rotate-90" : "rotate-0", "transition-all w-5 h-5 -mr-1.5 flex items-center delay-300"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightIcon */.XC, {
                                                    width: 16,
                                                    height: 16,
                                                    className: "group-hover:text-slate-200 text-slate-300"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        unmount: false,
                        className: "transition-[max-height] overflow-hidden mb-3",
                        enter: "duration-300 ease-in-out",
                        enterFrom: "transform max-h-0",
                        enterTo: "transform max-h-[380px]",
                        leave: "transition-[max-height] duration-250 ease-in-out",
                        leaveFrom: "transform max-h-[380px]",
                        leaveTo: "transform max-h-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Group, {
                                selectedIndex: slippageToleranceType === "auto" ? 0 : 1,
                                onChange: (index)=>updateSlippageToleranceType(index === 0 ? "auto" : "custom"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.List, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                                children: "Auto"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                                children: "Custom"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Panels, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab.Panel, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab.Panel, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col gap-2 px-3 py-2 mt-2 bg-slate-900 rounded-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "flex items-center gap-1 text-xs font-medium text-slate-300",
                                                            children: "Custom Slippage"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Numeric, {
                                                                    variant: "unstyled",
                                                                    value: userSlippageTolerance !== null && userSlippageTolerance !== void 0 ? userSlippageTolerance : "",
                                                                    onUserInput: (val)=>updateSlippageTolerance(val),
                                                                    placeholder: "1",
                                                                    className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, "")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-xs font-medium text-slate-400",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/SettingsOverlay/ExpertMode.tsx





const ExpertMode = ()=>{
    const [{ userExpertMode  }, { updateExpertMode  }] = (0,user_hooks/* useSettings */.rV)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[52px] flex items-center border-b border-slate-200/5 select-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex items-center justify-between w-full gap-3 group rounded-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-center w-5 h-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        className: "-ml-0.5 text-slate-500",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M7.167 1.333 6.75.5l-.417.833-.833.105.695.59L5.917 3l.833-.555.833.555-.278-.973.695-.59-.833-.104Zm6.945 8.889-.695-1.389-.695 1.389-1.389.174 1.158.984-.463 1.62 1.389-.926 1.388.926-.463-1.62 1.158-.984-1.388-.174ZM3.556 3.278 3 2.167l-.556 1.11-1.11.14.925.786L1.89 5.5 3 4.76l1.11.74-.37-1.297.927-.786-1.111-.14ZM.845 12.166c0 .445.173.863.488 1.178l1.322 1.322c.315.315.733.488 1.178.488.445 0 .864-.173 1.179-.488l9.655-9.655c.315-.315.488-.734.488-1.179 0-.445-.173-.863-.488-1.178l-1.322-1.322c-.63-.63-1.727-.63-2.357 0l-9.655 9.655a1.655 1.655 0 0 0-.488 1.179Zm11.322-9.655 1.321 1.321-2.988 2.99L9.178 5.5l2.989-2.988Z",
                            fill: "#97A3B7"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between w-full gap-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium",
                                    children: "Expert Mode"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                    button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* InformationCircleIcon */.AV, {
                                        width: 14,
                                        height: 14
                                    }),
                                    panel: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-xs font-medium w-80 text-slate-300",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: "WARNING:"
                                            }),
                                            " Enabling Expert Mode will bypass all confirmation messages and will allow for trades with high price impact. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "ONLY"
                                                    }),
                                                    " use if you are an advanced user and know what you are doing. ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Use at your own risk."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gap-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Switch, {
                                checked: userExpertMode,
                                onChange: ()=>updateExpertMode(!userExpertMode),
                                size: "sm"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/constants/index.ts
var src_constants = __webpack_require__(1880);
;// CONCATENATED MODULE: ./src/components/SettingsOverlay/SlippageToleranceDisclosure.tsx









const SlippageToleranceDisclosure = (param)=>{
    let { chainId  } = param;
    const [{ slippageToleranceType , userSlippageTolerance  }, { updateSlippageTolerance , updateSlippageToleranceType  }] = (0,user_hooks/* useSettings */.rV)(chainId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)("div", {
                className: "border-b select-none border-slate-200/5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                        as: "div",
                        className: "relative flex items-center justify-between w-full gap-3 cursor-pointer group rounded-xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center w-5 h-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "-ml-0.5 text-slate-500",
                                    width: "20",
                                    height: "12",
                                    viewBox: "0 0 20 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m18.617 6.797-8.125 5a.922.922 0 0 1-.492.14.984.984 0 0 1-.46-.117.953.953 0 0 1-.477-.82V2.68L2.367 6.797a.937.937 0 0 1-.984-1.594l8.125-5a.93.93 0 0 1 1.43.797v8.32l6.695-4.117a.938.938 0 0 1 .984 1.594Z",
                                        fill: "#97A3B7"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full gap-1 py-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm font-medium",
                                                children: "Slippage Tolerance"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* InformationCircleIcon */.AV, {
                                                    width: 14,
                                                    height: 14
                                                }),
                                                panel: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col gap-2 w-80",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xs font-medium text-slate-300",
                                                            children: "Slippage tolerance is the utmost percentage of slippage a user is willing to execute a trade with; if the actual slippage falls outside of the user-designated range, the transaction will revert."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-xs font-medium text-slate-300",
                                                            children: "Slippage is the difference between the expected value of output from a trade and the actual value due to asset volatility and liquidity depth."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm font-medium group-hover:text-slate-400 text-slate-600",
                                                children: slippageToleranceType === "auto" ? "Auto(".concat(Number(src_constants/* INITIAL_ALLOWED_SLIPPAGE */.g), "%)") : "Custom(".concat(Number(userSlippageTolerance), "%)")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,src_functions/* classNames */.AK)(open ? "rotate-90" : "rotate-0", "transition-all w-5 h-5 -mr-1.5 flex items-center delay-300"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightIcon */.XC, {
                                                    width: 16,
                                                    height: 16,
                                                    className: "group-hover:text-slate-200 text-slate-300"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        unmount: false,
                        className: "transition-[max-height] overflow-hidden mb-3",
                        enter: "duration-300 ease-in-out",
                        enterFrom: "transform max-h-0",
                        enterTo: "transform max-h-[380px]",
                        leave: "transition-[max-height] duration-250 ease-in-out",
                        leaveFrom: "transform max-h-[380px]",
                        leaveTo: "transform max-h-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Group, {
                                selectedIndex: slippageToleranceType === "auto" ? 0 : 1,
                                onChange: (index)=>updateSlippageToleranceType(index === 0 ? "auto" : "custom"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.List, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                                className: (0,src_functions/* classNames */.AK)(slippageToleranceType === "auto" ? "bg-slate-400/20" : "", "!rounded-none !border-transparent hover:bg-slate-400/40"),
                                                children: "Auto"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                                                className: (0,src_functions/* classNames */.AK)(slippageToleranceType !== "auto" ? "bg-slate-400/20" : "", "!rounded-none border-transparent hover:bg-slate-400/40"),
                                                children: "Custom"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab.Panels, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab.Panel, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab.Panel, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col gap-2 px-3 py-2 mt-2 bg-slate-600/40 backdrop-blur-[1px] rounded-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "flex items-center gap-1 text-xs font-medium text-slate-800",
                                                            children: "Custom Slippage"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Numeric, {
                                                                    variant: "unstyled",
                                                                    value: userSlippageTolerance !== null && userSlippageTolerance !== void 0 ? userSlippageTolerance : "",
                                                                    onUserInput: (val)=>updateSlippageTolerance(val),
                                                                    placeholder: "1",
                                                                    className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, "")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-xs font-medium text-slate-600",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/SettingsOverlay/index.tsx









const SettingsOverlay = (param)=>{
    let { chainId , userExpertMode  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-flow-col gap-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                    className: "flex items-center hover:animate-spin-slow min-w-5 min-h-5",
                    onClick: ()=>setOpen(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Settings */.Zr, {
                        className: "stroke-slate-600 fill-transparent hover:stroke-slate-800",
                        width: 24,
                        height: 24
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn/* SlideIn */.oX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn/* SlideIn.FromLeft */.oX.FromLeft, {
                    show: open,
                    onClose: ()=>setOpen(false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay.Content */.a.Content, {
                        className: " backdrop-blur-10xl bg-gray-100/90 shadow shadow-slate-800 !pb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "h-full px-3 -ml-3 -mr-3 overflow-x-hidden overflow-y-auto scroll",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay.Header */.a.Header, {
                                    onClose: ()=>setOpen(false),
                                    title: "Settings"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlippageToleranceDisclosure, {
                                            chainId: chainId
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertMode, {}),
                                        userExpertMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyCombinationDisclosure, {
                                                    chainId: chainId
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeOverlay, {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/abi/encodeFunctionData.js
var encodeFunctionData = __webpack_require__(96606);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 9 modules
var Toast = __webpack_require__(78871);
;// CONCATENATED MODULE: ./src/hooks/useSendTransaction.ts



/**
 * @param {{}}param0
 * @return {{}}
 */ function useSendTransaction(param) {
    let { chainId , onError , onMutate , onSuccess , onSettled , prepare , enabled =true  } = param;
    const [request, setRequest] = (0,react.useState)();
    // console.debug('useSendTransaction (wrapper) re-runing with', {
    //   request,
    //   chainId,
    //   enabled,
    // })
    const { config  } = (0,dist/* usePrepareSendTransaction */.M5)({
        data: request === null || request === void 0 ? void 0 : request.data,
        account: request === null || request === void 0 ? void 0 : request.from,
        to: request === null || request === void 0 ? void 0 : request.to,
        value: request === null || request === void 0 ? void 0 : request.value,
        chainId,
        enabled
    });
    console.debug("usePrepareSendTransaction returned config", {
        config
    });
    const _onSettled = (0,react.useCallback)((data, e, variables, context)=>{
        console.debug("onSettled callback", {
            data,
            e,
            variables,
            context
        });
        // TODO: ignore until wagmi workaround on ethers error
        // @ts-ignore
        if (e) {
            (0,Toast/* createErrorToast */.rv)(e === null || e === void 0 ? void 0 : e.message, true);
        }
        if (onSettled) {
            onSettled(data, e, variables, context);
        }
    }, [
        onSettled
    ]);
    (0,react.useEffect)(()=>{
        // console.debug('Prepare effect called with setRequest', setRequest)
        prepare(setRequest);
    }, [
        prepare
    ]);
    return (0,dist/* useSendTransaction */.pQ)({
        ...config,
        chainId,
        onError,
        onMutate,
        onSuccess,
        // TODO: ignore until wagmi workaround on ethers error
        // @ts-ignore
        onSettled: _onSettled,
        mode: "prepared"
    });
}

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/actions/getContract.js
var actions_getContract = __webpack_require__(96036);
;// CONCATENATED MODULE: ./src/constants/abis/weth9.json
var weth9_namespaceObject = JSON.parse('[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"guy","type":"address"},{"name":"wad","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"src","type":"address"},{"name":"dst","type":"address"},{"name":"wad","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"wad","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"dst","type":"address"},{"name":"wad","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"deposit","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":true,"name":"guy","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":true,"name":"dst","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"dst","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Withdrawal","type":"event"}]');
;// CONCATENATED MODULE: ./src/hooks/useWETH9Contract.ts




const getWETH9ContractConfig = (chainId)=>({
        address: chainId ? constants/* WNATIVE_ADDRESS */.df[chainId] : "",
        abi: weth9_namespaceObject
    });
/**
 * @param {ChainId | undefined} chainId 
 * @return {Contract | null}
 */ function useWETH9Contract(chainId) {
    const publicClient = (0,dist/* usePublicClient */.t_)({
        chainId: chainId
    });
    return (0,actions_getContract/* getContract */.uN)({
        ...getWETH9ContractConfig(chainId),
        publicClient: publicClient
    });
}

;// CONCATENATED MODULE: ./src/hooks/useWrapCallback.ts







var WrapType;
(function(WrapType) {
    WrapType["Wrap"] = "Wrap";
    WrapType["Unwrap"] = "Unwrap";
})(WrapType || (WrapType = {}));
const useWrapCallback = (param)=>{
    let { chainId , wrapType , amount , onSuccess  } = param;
    const { address  } = (0,dist/* useAccount */.mA)();
    const contract = useWETH9Contract(chainId);
    const onSettled = (0,react.useCallback)((data)=>{
        if (data && onSuccess && amount && chainId) {
            const ts = new Date().getTime();
            onSuccess({
                type: wrapType === WrapType.Wrap ? "enterBar" : "leaveBar",
                chainId,
                txHash: data.hash,
                promise: (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                    hash: data.hash,
                    chainId: chainId
                }),
                summary: {
                    pending: "".concat(wrapType === WrapType.Wrap ? "Wrapping" : "Unwrapping", " ").concat(amount.toSignificant(6), " ").concat(amount.currency.symbol),
                    completed: "Successfully ".concat(wrapType === WrapType.Wrap ? "wrapped" : "unwrapped", " ").concat(amount.toSignificant(6), " ").concat(amount.currency.symbol),
                    failed: "Something went wrong when trying to ".concat(wrapType === WrapType.Wrap ? "wrap" : "unwrap")
                },
                groupTimestamp: ts,
                timestamp: ts
            });
        }
    }, [
        amount,
        chainId,
        onSuccess,
        wrapType
    ]);
    const prepare = (0,react.useCallback)((setRequest)=>{
        if (!contract || !chainId || !address || !amount || !amount.greaterThan(constants/* ZERO */.xE)) return;
        if (wrapType === WrapType.Wrap) {
            setRequest({
                from: address,
                to: contract.address,
                data: (0,encodeFunctionData/* encodeFunctionData */.R)({
                    abi: contract.abi,
                    functionName: "deposit"
                }),
                value: BigInt(amount.quotient.toString())
            });
        }
        if (wrapType === WrapType.Unwrap) {
            setRequest({
                from: address,
                to: contract.address,
                data: (0,encodeFunctionData/* encodeFunctionData */.R)({
                    abi: contract.abi,
                    functionName: "withdraw",
                    args: [
                        amount.quotient.toString()
                    ]
                })
            });
        }
    }, [
        address,
        amount,
        chainId,
        contract,
        wrapType
    ]);
    return useSendTransaction({
        chainId,
        prepare,
        onSettled,
        enabled: !!contract && chainId && address && amount && (amount === null || amount === void 0 ? void 0 : amount.greaterThan(constants/* ZERO */.xE))
    });
};

;// CONCATENATED MODULE: ./src/components/Checker/Amounts.tsx







const Amounts = (param)=>{
    let { amounts , children , className , variant , fullWidth , as , size , color  } = param;
    var ref;
    const { address  } = (0,dist/* useAccount */.mA)();
    const amountsAreDefined = (0,react.useMemo)(()=>{
        return amounts.every((el)=>{
            return el === null || el === void 0 ? void 0 : el.greaterThan(constants/* ZERO */.xE);
        });
    }, [
        amounts
    ]);
    const currencies = (0,react.useMemo)(()=>{
        return amounts.map((amount)=>{
            return amount === null || amount === void 0 ? void 0 : amount.currency;
        });
    }, [
        amounts
    ]);
    const { data: balances  } = useBalances({
        currencies,
        chainId: currencies === null || currencies === void 0 ? void 0 : (ref = currencies[0]) === null || ref === void 0 ? void 0 : ref.chainId,
        account: address,
        enabled: amountsAreDefined
    });
    const sufficientBalance = (0,react.useMemo)(()=>{
        return amounts === null || amounts === void 0 ? void 0 : amounts.every((amount)=>{
            var ref;
            if (!amount) return true;
            return !(balances === null || balances === void 0 ? void 0 : (ref = balances[amount.currency.isNative ? constants_address/* zeroAddress */.D : amount.currency.wrapped.address]) === null || ref === void 0 ? void 0 : ref.lessThan(amount));
        });
    }, [
        amounts,
        balances
    ]);
    return (0,react.useMemo)(()=>{
        if (!amountsAreDefined) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            id: "amount-checker",
            disabled: true,
            className: className,
            variant: variant,
            as: as,
            fullWidth: fullWidth,
            size: size,
            color: color,
            children: "Enter Amount"
        });
        if (!sufficientBalance) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            disabled: true,
            className: className,
            variant: variant,
            as: as,
            fullWidth: fullWidth,
            size: size,
            color: color,
            children: "Insufficient Balance"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }, [
        amountsAreDefined,
        as,
        children,
        className,
        color,
        fullWidth,
        size,
        sufficientBalance,
        variant
    ]);
};

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/rpc.js
var rpc = __webpack_require__(42455);
;// CONCATENATED MODULE: ./src/functions/trade/calculateGasMargin.ts
/** Add 20%
 * @param {bigint}value
 * @return {bigint}
 */ function calculateGasMargin(value) {
    return value * BigInt(120) / BigInt(100);
}

;// CONCATENATED MODULE: ./src/hooks/useERC20Allowance.ts



/**
 * @param {boolean}watch 
 * @param {Token}token 
 * @param {string}owner 
 * @param {string}spender 
 * @return {UseERC20AllowanceReturn}
 */ function useERC20Allowance(watch, token, owner, spender) {
    const args = (0,react.useMemo)(()=>[
            owner,
            spender
        ], [
        owner,
        spender
    ]);
    const data = (0,dist/* useContractRead */["do"])({
        address: token === null || token === void 0 ? void 0 : token.address,
        abi: chunk_LAFZBYO7/* erc20ABI */.em,
        functionName: "allowance",
        args,
        watch,
        enabled: !!token
    });
    const amount = data.data !== undefined && token ? entities/* Amount.fromRawAmount */.$d.fromRawAmount(token, data.data.toString()) : undefined;
    return (0,react.useMemo)(()=>({
            ...data,
            data: amount
        }), [
        amount,
        data
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useERC20ApproveCallback.ts









var ApprovalState;
(function(ApprovalState) {
    ApprovalState["LOADING"] = "LOADING";
    ApprovalState["UNKNOWN"] = "UNKNOWN";
    ApprovalState["NOT_APPROVED"] = "NOT_APPROVED";
    ApprovalState["PENDING"] = "PENDING";
    ApprovalState["APPROVED"] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
/** returns a variable indicating the state of the approval and a function which approves if necessary or early returns
 * @param {boolean} watch
 * @param {Amount<Type>} amountToApprove
 * @param {string} spender
 * @param {boolean} approveMax
 * @param {NotificationData} onSuccess notification handler
 * @return {[ApprovalState, void]}
 */ function useERC20ApproveCallback(watch, amountToApprove, spender, approveMax) {
    var ref;
    const { address  } = (0,dist/* useAccount */.mA)();
    const walletClient = (0,dist/* useWalletClient */.py)();
    const [, { createNotification  }] = (0,user_hooks/* useNotifications */.zn)(address);
    // console.log(amountToApprove)
    const onSettled = (0,react.useCallback)((data, e)=>{
        // TODO: ignore until wagmi workaround on ethers error
        // @ts-ignore
        if (e) {
            (0,Toast/* createErrorToast */.rv)(e === null || e === void 0 ? void 0 : e.message, true);
        }
        if (data && amountToApprove) {
            const ts = new Date().getTime();
            createNotification({
                type: "approval",
                chainId: amountToApprove.currency.chainId,
                txHash: data.hash,
                promise: (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                    hash: data.hash,
                    chainId: amountToApprove.currency.chainId
                }),
                summary: {
                    pending: "Approving ".concat(amountToApprove.currency.symbol),
                    completed: "Successfully approved ".concat(amountToApprove.currency.symbol),
                    failed: "Something went wrong approving ".concat(amountToApprove.currency.symbol)
                },
                groupTimestamp: ts,
                timestamp: ts
            });
        }
    }, [
        amountToApprove,
        createNotification
    ]);
    const [request, setRequest] = (0,react.useState)();
    const { config  } = (0,dist/* usePrepareSendTransaction */.M5)({
        chainId: amountToApprove === null || amountToApprove === void 0 ? void 0 : amountToApprove.currency.chainId,
        data: request === null || request === void 0 ? void 0 : request.data,
        account: request === null || request === void 0 ? void 0 : request.from,
        to: request === null || request === void 0 ? void 0 : request.to,
        value: request === null || request === void 0 ? void 0 : request.value
    });
    const { sendTransaction , isLoading: isWritePending  } = (0,dist/* useSendTransaction */.pQ)({
        ...config,
        onSettled
    });
    const token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    const { data: currentAllowance , isLoading  } = useERC20Allowance(watch, token, address !== null && address !== void 0 ? address : undefined, spender);
    // check the current approval status
    const approvalState = (0,react.useMemo)(()=>{
        if (isLoading) return ApprovalState.LOADING;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if (amountToApprove.currency.isNative) return ApprovalState.APPROVED;
        if (isWritePending) return ApprovalState.PENDING;
        // We might not have enough data to know whether we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        isLoading,
        isWritePending,
        spender
    ]);
    var ref1;
    const tokenContract = (0,chunk_LAFZBYO7/* getContract */.uN)({
        address: (ref1 = token === null || token === void 0 ? void 0 : token.address) !== null && ref1 !== void 0 ? ref1 : constants_address/* zeroAddress */.D,
        abi: chunk_LAFZBYO7/* erc20ABI */.em,
        walletClient
    });
    const prepare = (0,react.useCallback)(async ()=>{
        try {
            if (!(amountToApprove === null || amountToApprove === void 0 ? void 0 : amountToApprove.currency.chainId) || approvalState !== ApprovalState.NOT_APPROVED || !token || !tokenContract || !amountToApprove || !spender) {
                return;
            }
            const estimatedGas = await tokenContract.estimateGas.approve([
                spender,
                BigInt(amountToApprove.quotient.toString())
            ], {
                account: spender
            }).catch(()=>{
                // General fallback for tokens who restrict approval amounts
                return tokenContract.estimateGas.approve([
                    spender,
                    BigInt(amountToApprove.quotient.toString())
                ], {
                    gasPrice: undefined,
                    maxFeePerGas: undefined,
                    maxPriorityFeePerGas: undefined,
                    gas: undefined,
                    nonce: undefined,
                    value: undefined,
                    accessList: undefined,
                    type: undefined,
                    account: spender,
                    blockNumber: undefined,
                    blockTag: undefined
                });
            });
            setRequest({
                from: address,
                to: tokenContract === null || tokenContract === void 0 ? void 0 : tokenContract.address,
                data: (0,encodeFunctionData/* encodeFunctionData */.R)({
                    abi: tokenContract.abi,
                    functionName: "approve",
                    args: [
                        spender,
                        !approveMax ? BigInt(amountToApprove.quotient.toString()) : BigInt(constants/* MAX_UINT256.toString */.fV.toString())
                    ]
                }),
                gas: calculateGasMargin(estimatedGas)
            });
        } catch (e) {
            if (e instanceof rpc/* UserRejectedRequestError */.ab) return;
            console.error(e);
        }
    }, [
        amountToApprove,
        approvalState,
        token,
        tokenContract,
        spender,
        address,
        approveMax
    ]);
    // Prepare transaction
    (0,react.useEffect)(()=>{
        void prepare();
    }, [
        prepare
    ]);
    return (0,react.useMemo)(()=>{
        return [
            approvalState,
            ()=>{
                return sendTransaction === null || sendTransaction === void 0 ? void 0 : sendTransaction();
            }
        ];
    }, [
        approvalState,
        sendTransaction
    ]);
}

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-select/dist/index.mjs + 52 modules
var react_select_dist = __webpack_require__(87547);
;// CONCATENATED MODULE: ./src/components/Select/index.tsx







const Select = react_select_dist/* Root */.fC;
const SelectGroup = react_select_dist/* Group */.ZA;
const SelectValue = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-2 pt-[22px] font-medium",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* Value */.B4, {
            ref: ref,
            className: (0,src_functions/* classNames */.AK)(className ? className : "", "!text-red-500"),
            ...props
        })
    });
});
SelectValue.displayName = react_select_dist/* Value.displayName */.B4.displayName;
const SelectIcon = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(react_select_dist/* Icon */.JO, {
        ref: ref,
        ...props,
        asChild: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
            strokeWidth: 2,
            width: 16,
            height: 16,
            className: (0,src_functions/* classNames */.AK)(className, "w-4 h-4")
        })
    });
});
SelectIcon.displayName = react_select_dist/* Icon.displayName */.JO.displayName;
const SelectTrigger = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { className ="" , children , ...props } = param;
    const content = props.asChild ? children : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectIcon, {})
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* Trigger */.xz, {
            ref: ref,
            className: (0,src_functions/* classNames */.AK)("h-[54px] data-[state=open]:bg-accent group relative rounded-xl flex items-center justify-between gap-1 w-full pointer-events-auto cursor-pointer text-gray-900 dark:text-slate-50 bg-secondary px-4", className),
            ...props,
            children: content
        })
    });
});
SelectTrigger.displayName = react_select_dist/* Trigger.displayName */.xz.displayName;
const SelectContent = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className ="" , children , collisionPadding =8 , sideOffset =4 , position ="popper" , ...props } = param;
    return (0,jsx_runtime.jsx)(react_select_dist/* Portal */.h_, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_select_dist/* Content */.VY, {
            ref: ref,
            collisionPadding: collisionPadding,
            sideOffset: sideOffset,
            className: (0,src_functions/* classNames */.AK)("max-h-[--radix-select-content-available-height] p-0.5 relative z-[1081] min-w-[8rem] rounded-xl overflow-hidden !cursor-pointer bg-white/50 paper dark:bg-slate-800/50 shadow-md animate-in fade-in-80", position === "popper" ? "translate-y-1 " : "", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* ScrollUpButton */.u_, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* Viewport */.l_, {
                    className: (0,src_functions/* classNames */.AK)("p-1", position === "popper" ? "h-[var(--radix-select-trigger-height)]  min-w-[var(--radix-select-trigger-width)]" : ""),
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* ScrollDownButton */.$G, {})
            ]
        })
    });
});
SelectContent.displayName = react_select_dist/* Content.displayName */.VY.displayName;
const SelectLabel = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                value: props["aria-label"],
                placeholder: "hidden placeholder",
                className: "hidden peer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* Label */.__, {
                ref: ref,
                className: (0,src_functions/* classNames */.AK)("pointer-events-none font-medium peer-focus:font-normal absolute cursor-pointer text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-[15px] scale-75 top-4 z-10 origin-[0] left-4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[15px]", className),
                ...props
            })
        ]
    });
});
SelectLabel.displayName = react_select_dist/* Label.displayName */.__.displayName;
const SelectItem = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className ="" , children , ...props } = param;
    return (0,jsx_runtime.jsxs)(react_select_dist/* Item */.ck, {
        ref: ref,
        className: (0,src_functions/* classNames */.AK)("text-gray-700 dark:text-slate-300 relative flex w-full cursor-pointer select-none items-center rounded-md py-2 pl-8 pr-2 text-sm outline-none hover:bg-muted focus:bg-accent data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* ItemIndicator */.wU, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CheckIcon */.nQ, {
                        strokeWidth: 3,
                        width: 16,
                        height: 16,
                        className: "text-blue-500"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* ItemText */.eT, {
                children: children
            })
        ]
    });
});
SelectItem.displayName = react_select_dist/* Item.displayName */.ck.displayName;
const SelectSeparator = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(react_select_dist/* Separator */.Z0, {
        ref: ref,
        className: (0,src_functions/* classNames */.AK)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    });
});
SelectSeparator.displayName = react_select_dist/* Separator.displayName */.Z0.displayName;
const SelectCaption = (param)=>{
    let { caption , isError  } = param;
    if (!caption) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx("span", {
        className: classNames(isError ? "text-red" : "", "mt-1.5 inline-block px-4 text-xs text-gray-500"),
        children: caption
    });
};


;// CONCATENATED MODULE: ./src/components/Checker/ApproveERC20.tsx









const Component = (param)=>{
    let { id , amount , contract , children , className ="" , fullWidth =true , size ="md" , enabled =true , ...props } = param;
    var ref, ref1;
    const [max, setMax] = (0,react.useState)(false);
    const [approvalState, onApprove] = useERC20ApproveCallback(Boolean(!!amount && !!contract), amount, contract, max);
    if (approvalState === ApprovalState.APPROVED || !enabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    const loading = [
        ApprovalState.UNKNOWN,
        ApprovalState.LOADING,
        ApprovalState.PENDING
    ].includes(approvalState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,src_functions/* classNames */.AK)(className, "justify-center items-center text-center w-full"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            color: "gradient",
            // key={index}
            loading: loading,
            "testdata-id": id,
            variant: "outlined",
            size: size,
            className: (0,src_functions/* classNames */.AK)(className, "flex "),
            fullWidth: fullWidth,
            onClick: onApprove,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid w-full grid-flow-col grid-cols-1 mx-auto text-center",
                children: [
                    "Approve ",
                    amount === null || amount === void 0 ? void 0 : amount.currency.symbol,
                    " ",
                    max ? "Permanently" : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-2 my-auto place-content-center flex flex-col gap-1 w-6 h-6 disabled:pointer-events-none disabled:saturate-[0] cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                            value: "".concat(max),
                            onValueChange: (val)=>setMax(val === "true"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_dist/* Trigger */.xz, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconButton */.hU, {
                                        className: "p-1 rounded-full bg-slate-400/50 hover:bg-slate-400/80",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
                                            width: 20,
                                            height: 20,
                                            className: "fill-slate-400/80 hover:fill-slate-400",
                                            x: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectContent, {
                                    className: " w-80",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectItem, {
                                            value: "false",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col pointer-events-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-semibold",
                                                        children: "Approve one-time only"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-sm",
                                                        children: [
                                                            "You'll give your approval to spend ",
                                                            amount === null || amount === void 0 ? void 0 : amount.toSignificant(6),
                                                            " ",
                                                            amount === null || amount === void 0 ? void 0 : (ref = amount.currency) === null || ref === void 0 ? void 0 : ref.symbol,
                                                            " on your behalf"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectItem, {
                                            value: "true",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col pointer-events-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-semibold",
                                                        children: "Approve unlimited amount"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-sm",
                                                        children: [
                                                            "You won't need to approve again next time you want to spend",
                                                            " ",
                                                            amount === null || amount === void 0 ? void 0 : (ref1 = amount.currency) === null || ref1 === void 0 ? void 0 : ref1.symbol,
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const ApproveERC20 = dynamic_default()(()=>Promise.resolve(Component), {
    ssr: false
});

// EXTERNAL MODULE: ./src/wagmi/hooks/useAutoConnect.ts
var useAutoConnect = __webpack_require__(25869);
// EXTERNAL MODULE: ./src/components/Animation/index.ts + 2 modules
var Animation = __webpack_require__(43509);
// EXTERNAL MODULE: ./src/state/application/hooks.ts
var application_hooks = __webpack_require__(91475);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 1 modules
var menu = __webpack_require__(30471);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(95237);
;// CONCATENATED MODULE: ./src/components/Menu/MenuButton.tsx




const MenuButton = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className , children , ...props } = param;
    return(// @ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
        as: react.Fragment,
        ref: ref,
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            ...props,
            className: className,
            children: children
        })
    }));
});

;// CONCATENATED MODULE: ./src/components/Menu/MenuItem.tsx




const MenuItem = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className ="" , startIcon , children , as , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Item */.v.Item, {
        ...props,
        ref: ref,
        as: as || "div",
        className: (param)=>{
            let { active  } = param;
            return (0,src_functions/* classNames */.AK)(active ? "text-white bg-blue-500" : "text-high-emphesis", "whitespace-nowrap flex gap-2 items-center font-medium text-sm cursor-pointer select-none relative py-2 pl-4 pr-9 my-1 mx-1 rounded-xl", className);
        },
        children: [
            startIcon && startIcon,
            children
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/Menu/MenuItems.tsx




const MenuItems = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
        ...props,
        ref: ref,
        className: (0,src_functions/* classNames */.AK)(className, "bg-slate-200 absolute right-0 mt-1 top-0 min-w-[224px] w-[fit-content] rounded-xl ring-2 ring-black ring-opacity-5 shadow-md shadow-black/30 focus:outline-none")
    });
});

;// CONCATENATED MODULE: ./src/components/Menu/Menu.tsx










const MenuRoot = (param)=>{
    let { className ="" , button , appearOnMount =false , children  } = param;
    const [referenceElement, setReferenceElement] = react.useState(null);
    const [popperElement, setPopperElement] = react.useState(null);
    const { styles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        placement: "bottom-end",
        modifiers: [
            {
                name: "flip",
                enabled: true,
                options: {
                    padding: 8
                }
            },
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        10
                    ]
                }
            }
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation/* AppearOnMount */.NT, {
        enabled: appearOnMount,
        children: (mounted)=>mounted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
                as: "div",
                className: (0,src_functions/* classNames */.AK)(className, "relative"),
                children: [
                    /*#__PURE__*/ react.cloneElement(button, {
                        ref: setReferenceElement
                    }),
                    /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ react.cloneElement(children, {
                        ref: setPopperElement,
                        style: styles.popper,
                        ...attributes.popper
                    }), document.body)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
                as: "div",
                className: (0,src_functions/* classNames */.AK)(className, "relative"),
                children: [
                    /*#__PURE__*/ react.cloneElement(button, {
                        ref: setReferenceElement
                    }),
                    /*#__PURE__*/ react.cloneElement(children, {
                        ref: setPopperElement,
                        style: styles.popper,
                        ...attributes.popper
                    })
                ]
            })
    });
};
const Menu = Object.assign(MenuRoot, {
    Item: MenuItem,
    Items: MenuItems,
    Button: MenuButton
});

;// CONCATENATED MODULE: ./src/components/Menu/index.ts


;// CONCATENATED MODULE: ./src/components/WalletButton/Connect.tsx










const Connect_Icons = {
    Injected: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Injected */.kz, {
        width: 16,
        height: 16
    }),
    MetaMask: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* MetamaskIcon */.Qc, {
        width: 16,
        height: 16
    }),
    WalletConnect: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* WalletConnectIcon */.Jw, {
        width: 16,
        height: 16
    })
};
const ConnectButton = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { children , ...rest } = param;
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const [hover, setHover] = (0,react.useState)(false);
    const [debouncedHover, setDebouncedHover] = (0,react.useState)(false);
    const DebouncedHover = (0,hooks/* useDebounce */.Nr)([
        debouncedHover,
        hover
    ], 200);
    const [, { updateConnection  }] = (0,application_hooks/* useIsConnected */.T9)();
    const { connectors , connect  } = (0,dist/* useConnect */.$4)();
    (0,react.useEffect)(()=>{
        const [debouncedHover] = DebouncedHover;
        setHover(debouncedHover);
    }, [
        DebouncedHover
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        className: rest.fullWidth ? "w-full" : "",
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Button, {
            onMouseEnter: ()=>{
                setHover(true);
                setDebouncedHover(true);
            },
            onMouseLeave: ()=>setDebouncedHover(false),
            ...rest,
            as: "div",
            children: children || "Connect Wallet"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
            show: hover,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.Items, {
                placement: "top",
                className: "z-[100] grid !bg-transparent -mt-1 justify-center group-one origin-top min-w-[240px] max-h-60 py-2 gap-x-4 w-fit overflow-hidden rounded-lg shadow-lg ring-opacity-5 focus:outline-none",
                onMouseLeave: ()=>setDebouncedHover(false),
                onMouseEnter: ()=>{
                    setDebouncedHover(true);
                    setHover(true);
                },
                children: [
                    connectors.map((connector)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.Item, {
                            onClick: ()=>{
                                connect({
                                    connector
                                });
                                updateConnection(true);
                            },
                            as: "div",
                            className: "z-50 flex items-center w-full h-auto gap-3 hover:opacity-80 transform-all hover:bg-gray-500 group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-ml-[6px] group-hover:bg-blue-100 rounded-full group-hover:ring-[5px] group-hover:ring-blue-100",
                                    children: Connect_Icons[connector.name] && Connect_Icons[connector.name]
                                }),
                                connector.name
                            ]
                        }, connector.id)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu.Item, {
                        as: "a",
                        onClick: ()=>{},
                        href: "https://ethereum.org/wallets",
                        rel: "noreferrer",
                        target: "_blank",
                        className: "z-50 grid items-center justify-center w-full h-auto -mt-1 leading-none cursor-pointer text-xxxs tracking-default hover:opacity-80 hover:bg-gray-500 text-pollingactive ",
                        children: [
                            t("New to Crypto?"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "z-50 grid font-bold cursor-pointer text-fire1 hover:opacity-50",
                                children: t("Learn more about wallets")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-0 left-0 custom-backdrop-blur z-1"
                    })
                ]
            })
        })
    });
});

;// CONCATENATED MODULE: ./src/components/WalletButton/Button.tsx








const Button_Button = (param)=>{
    let { hack , children , supportedNetworks , appearOnMount =true , ...rest } = param;
    // TODO ramin: remove param when wagmi adds onConnecting callback to useAccount
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pendingConnection , isReconnecting , isConnected , isConnecting  } = (0,useActiveWeb3React/* default */.Z)();
    (0,useAutoConnect/* useAutoConnect */.v)();
    if (isConnecting && appearOnMount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
            className: rest.fullWidth ? "w-full !opacity-100" : "!opacity-100",
            size: "md",
            color: "gray",
            variant: "filled",
            rounded: "none",
            disabled: true,
            ...rest,
            children: [
                "Connecting",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation/* AppearOnMount */.NT, {
        enabled: appearOnMount,
        children: (isMounted)=>{
            // Pending confirmation state
            // Awaiting wallet confirmation
            if (pendingConnection) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                    className: rest.fullWidth ? "w-full !opacity-100" : "!opacity-100",
                    size: "md",
                    color: "gray",
                    variant: "filled",
                    rounded: "none",
                    disabled: true,
                    ...rest,
                    children: [
                        "Authorize Wallet",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {})
                    ]
                });
            }
            // Disconnected state
            // We are mounted on the client, but we're not connected, and we're not reconnecting (address is not available)
            if (!isConnected && !isReconnecting && isMounted) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectButton, {
                    ...rest,
                    children: children
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                size: "md",
                color: "gray",
                variant: "filled",
                rounded: "none",
                ...rest,
                children: children || "Connect Wallet"
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Checker/Connected.tsx




const Connected = (param)=>{
    let { children , className , variant , fullWidth , size , name , onBlur , as , color  } = param;
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const { address  } = (0,dist/* useAccount */.mA)();
    if (isMounted && !address) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "animate-border hover:animate-none group-one-hover:animate-none group-hover:animate-none duration-500 ease-in-out flex flex-col gap-2 space-y-2 rounded-[1.1rem] bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-[length:200%_200%] p-[1px] transition focus:outline-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button, {
            color: color,
            appearOnMount: false,
            className: className,
            variant: variant,
            fullWidth: fullWidth,
            size: size,
            name: name,
            as: as,
            onBlur: onBlur,
            children: "Connect Wallet"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Checker/Custom.tsx


const Custom = (param)=>{
    let { showGuardIfTrue , guard , children  } = param;
    if (showGuardIfTrue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,react.cloneElement)(guard, {
                ...guard.props,
                disabled: true
            }, guard.props.children)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Checker/Network.tsx



const Network = (param)=>{
    let { chainId , children , ...rest } = param;
    const { chain  } = (0,dist/* useNetwork */.LN)();
    const { switchNetwork  } = (0,dist/* useSwitchNetwork */.g0)();
    if (!chainId) return null;
    if ((chain === null || chain === void 0 ? void 0 : chain.id) !== chainId) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "opacity-80 hover:opacity-100 flex font-medium items-center animate-border hover:animate-none group-one-hover:animate-none group-hover:animate-none duration-500 ease-in-out gap-2 rounded-2xl bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-[length:200%_200%] p-[1px] transition focus:outline-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            className: "px-4 h-[52px] rounded-2xl text-base font-semibold relative whitespace-nowrap bg-secondarybg min-w-[260px] flex items-center justify-center w-full",
            onClick: ()=>switchNetwork && switchNetwork(chainId),
            ...rest,
            children: [
                "Switch to ",
                constants/* chainName */.pN[chainId]
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Checker/index.ts





const Checker = {
    Amounts: Amounts,
    Connected: Connected,
    Network: Network,
    Custom: Custom,
    ApproveERC20: ApproveERC20
};

;// CONCATENATED MODULE: ./src/hooks/useProviderOrSigner.ts



const useProviderOrSigner = function() {
    let withSignerIfPossible = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    const [chainId] = (0,application_hooks/* useSessionChainId */.or)();
    const publicClient = (0,dist/* usePublicClient */.t_)({
        chainId
    });
    const { address , isConnected  } = (0,dist/* useAccount */.mA)();
    const { data: walletClient  } = (0,dist/* useWalletClient */.py)();
    return (0,react.useMemo)(()=>withSignerIfPossible && address && isConnected && walletClient ? walletClient : publicClient, [
        address,
        isConnected,
        publicClient,
        walletClient,
        withSignerIfPossible
    ]);
};

;// CONCATENATED MODULE: ./src/constants/abis/routeProcessor3.ts
const routeProcessor3 = [
    {
        inputs: [
            {
                internalType: "address[]",
                name: "priviledgedUserList",
                type: "address[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenIn",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenOut",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountIn",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountOut",
                type: "uint256"
            }
        ],
        name: "Route",
        type: "event"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenIn",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "tokenOut",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "route",
                type: "bytes"
            }
        ],
        name: "processRoute",
        outputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "resume",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address"
            },
            {
                internalType: "bool",
                name: "priviledge",
                type: "bool"
            }
        ],
        name: "setPriviledge",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "transferValueTo",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amountValueTransfer",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "tokenIn",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "tokenOut",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "route",
                type: "bytes"
            }
        ],
        name: "transferValueAndprocessRoute",
        outputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256"
            }
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "amount0Delta",
                type: "int256"
            },
            {
                internalType: "int256",
                name: "amount1Delta",
                type: "int256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "uniswapV3SwapCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];

;// CONCATENATED MODULE: ./src/hooks/useSushiSwapRouter.ts





// TODO CELO NOT FOUND?
const getRouterProcessorContractConfig = (chainId)=>({
        address: chainId ? constants/* ROUTER_PROCESSOR_ADDRESS */.Hp[chainId] : constants_address/* zeroAddress */.D,
        abi: routeProcessor3
    });
/**
 * @param {number | undefined}chainId
 * @return {Contract | null}
 */ function useRouteProcessorContract(chainId) {
    const { data: walletClient  } = useWalletClient();
    return getContract({
        ...getRouterProcessorContractConfig(chainId),
        walletClient: walletClient ? walletClient : undefined
    });
}

// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
;// CONCATENATED MODULE: ./src/classes/liquidity-providers/UniswapV2Base.ts

/**
 *
 */ class UniswapV2BaseProvider extends entities/* LiquidityProvider */.zz {
    /**
   * @param {ChainId}chainId
   * @param {Address}factory
   * @param {string}initCodeHash
   * @param {[Token, Token][]}currencyCombinations
   */ constructor(chainId, factory, initCodeHash){
        super(chainId);
        this.fee = 0.003;
        this.factory = factory[chainId];
        this.initCodeHash = initCodeHash[chainId];
    }
}

;// CONCATENATED MODULE: ./src/classes/liquidity-providers/EmberswapV2.ts



/**
 *
 */ class EmberSwapV2Provider extends UniswapV2BaseProvider {
    /**
   * @return {LiquidityProviders}
   */ getType() {
        return entities/* LiquidityProviders.EmberSwapV2 */.Dm.EmberSwapV2;
    }
    /**
   * @return {string}
   */ getPoolProviderName() {
        return "EmberSwap";
    }
    /**
   * @return {string}
   */ getPoolProviderURI() {
        return "https://raw.githubusercontent.com/emberswap/assets/master/blockchains/smartbch/assets/0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D/logo.png";
    }
    /**
   * @param {ChainId}chainId
   */ constructor(chainId){
        const factory = {
            [enums/* ChainId.SMARTBCH */.a_.SMARTBCH]: "0xE62983a68679834eD884B9673Fb6aF13db740fF0",
            [enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET]: "0xa27588D9cff3130AC91C39b1B1c992976d492476"
        };
        const initCodeHash = {
            [enums/* ChainId.SMARTBCH */.a_.SMARTBCH]: "0x4eae98fedf0a51d24c5a3a59dddb69e9fbeead94344889e370a14507c35f9b4a",
            [enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET]: "0x4eae98fedf0a51d24c5a3a59dddb69e9fbeead94344889e370a14507c35f9b4a"
        };
        super(chainId, factory, initCodeHash);
        this.fee = 0.0025;
    }
}

;// CONCATENATED MODULE: ./src/classes/liquidity-providers/MistswapV2.ts



/**
 *
 */ class MistSwapV2Provider extends UniswapV2BaseProvider {
    /**
   * @return {LiquidityProviders}
   */ getType() {
        return entities/* LiquidityProviders.MistSwapV2 */.Dm.MistSwapV2;
    }
    /**
   * @return {string}
   */ getPoolProviderName() {
        return "MistSwap";
    }
    /**
   * @return {string}
   */ getPoolProviderURI() {
        return "https://raw.githubusercontent.com/emberswap/emberswap-tokenlist/main/assets/smartbch/0x5fA664f69c2A4A3ec94FaC3cBf7049BD9CA73129/logo.png";
    }
    /**
   * @param {ChainId}chainId
   */ constructor(chainId){
        const factory = {
            [enums/* ChainId.SMARTBCH */.a_.SMARTBCH]: "0x6008247F53395E7be698249770aa1D2bfE265Ca0",
            [enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET]: "0xaa094cA3FBd19dCCcE91C79d1FffA28293B05f28"
        };
        const initCodeHash = {
            [enums/* ChainId.SMARTBCH */.a_.SMARTBCH]: "0xacca68b46e4aa677641d8d20d81c9f4b252af83de62ff9e2fb58a9b648ee3537",
            [enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET]: "0xacca68b46e4aa677641d8d20d81c9f4b252af83de62ff9e2fb58a9b648ee3537"
        };
        super(chainId, factory, initCodeHash);
    }
}

;// CONCATENATED MODULE: ./src/classes/Graph.ts
/* eslint-disable new-cap */ /* eslint-disable no-unused-vars */ /* eslint-disable camelcase */ 


const ROUTER_DISTRIBUTION_PORTION = 65535;
var Graph_RouteStatus;
(function(RouteStatus) {
    RouteStatus["Success"] = "Success";
    RouteStatus["NoWay"] = "NoWay";
    RouteStatus["Partial"] = "Partial";
})(Graph_RouteStatus || (Graph_RouteStatus = {}));
/** */ class Edge {
    /** */ cleanTmpData() {
        this.amountInPrevious = 0;
        this.amountOutPrevious = 0;
        this.canBeUsed = true;
        this.direction = true;
        this.spentGas = 0;
        this.spentGasNew = 0;
        this.bestEdgeIncome = 0;
    }
    /**
   * @param {Vertice} v
   * @return {BigNumber}
   */ reserve(v) {
        return v === this.vert0 ? this.pool.getReserve0() : this.pool.getReserve1();
    }
    /**
   * @param {Vertice} v
   * @param {number} amountIn
   * @return {{number, number}}
   */ calcOutput(v, amountIn) {
        let res;
        let gas;
        if (v === this.vert1) {
            if (this.direction) {
                if (amountIn < this.amountOutPrevious) {
                    const { inp , gasSpent  } = this.pool.calcInByOut(this.amountOutPrevious - amountIn, true);
                    res = this.amountInPrevious - inp;
                    gas = gasSpent;
                } else {
                    const { out , gasSpent: gasSpent1  } = this.pool.calcOutByIn(amountIn - this.amountOutPrevious, false);
                    res = out + this.amountInPrevious;
                    gas = gasSpent1;
                }
            } else {
                const { out: out1 , gasSpent: gasSpent2  } = this.pool.calcOutByIn(this.amountOutPrevious + amountIn, false);
                res = out1 - this.amountInPrevious;
                gas = gasSpent2;
            }
        } else {
            if (this.direction) {
                const { out: out2 , gasSpent: gasSpent3  } = this.pool.calcOutByIn(this.amountInPrevious + amountIn, true);
                res = out2 - this.amountOutPrevious;
                gas = gasSpent3;
            } else {
                if (amountIn < this.amountInPrevious) {
                    const { inp: inp1 , gasSpent: gasSpent4  } = this.pool.calcInByOut(this.amountInPrevious - amountIn, false);
                    res = this.amountOutPrevious - inp1;
                    gas = gasSpent4;
                } else {
                    const { out: out3 , gasSpent: gasSpent5  } = this.pool.calcOutByIn(amountIn - this.amountInPrevious, true);
                    res = out3 + this.amountOutPrevious;
                    gas = gasSpent5;
                }
            }
        }
        // this.testApply(v, amountIn, out);
        return {
            out: res,
            gasSpent: gas - this.spentGas
        };
    }
    /**
   * @param {Vertice} v
   * @param {number} amountOut
   * @return {{number, number}}
   */ calcInput(v, amountOut) {
        let res;
        let gas;
        if (v === this.vert1) {
            if (!this.direction) {
                if (amountOut < this.amountOutPrevious) {
                    const { out , gasSpent  } = this.pool.calcOutByIn(this.amountOutPrevious - amountOut, false);
                    res = this.amountInPrevious - out;
                    gas = gasSpent;
                } else {
                    const { inp , gasSpent: gasSpent1  } = this.pool.calcInByOut(amountOut - this.amountOutPrevious, true);
                    res = inp + this.amountInPrevious;
                    gas = gasSpent1;
                }
            } else {
                const { inp: inp1 , gasSpent: gasSpent2  } = this.pool.calcInByOut(this.amountOutPrevious + amountOut, true);
                res = inp1 - this.amountInPrevious;
                gas = gasSpent2;
            }
        } else {
            if (!this.direction) {
                const { inp: inp2 , gasSpent: gasSpent3  } = this.pool.calcInByOut(this.amountInPrevious + amountOut, false);
                res = inp2 - this.amountOutPrevious;
                gas = gasSpent3;
            } else {
                if (amountOut < this.amountInPrevious) {
                    const { out: out1 , gasSpent: gasSpent4  } = this.pool.calcOutByIn(this.amountInPrevious - amountOut, true);
                    res = this.amountOutPrevious - out1;
                    gas = gasSpent4;
                } else {
                    const { inp: inp3 , gasSpent: gasSpent5  } = this.pool.calcInByOut(amountOut - this.amountInPrevious, false);
                    res = inp3 + this.amountOutPrevious;
                    gas = gasSpent5;
                }
            }
        }
        // this.testApply(v, amountIn, out);
        return {
            inp: res,
            gasSpent: gas - this.spentGas
        };
    }
    /**
   * @param {Vertice} from
   * @param {number} amountOut
   * @return {boolean}
   */ checkMinimalLiquidityExceededAfterSwap(from, amountOut) {
        if (from === this.vert0) {
            const r1 = parseInt(this.pool.getReserve1().toString());
            if (this.direction) {
                return r1 - amountOut - this.amountOutPrevious < this.pool.minLiquidity;
            } else {
                return r1 - amountOut + this.amountOutPrevious < this.pool.minLiquidity;
            }
        } else {
            const r0 = parseInt(this.pool.getReserve0().toString());
            if (this.direction) {
                return r0 - amountOut + this.amountInPrevious < this.pool.minLiquidity;
            } else {
                return r0 - amountOut - this.amountInPrevious < this.pool.minLiquidity;
            }
        }
    }
    // doesn't used in production - just for testing
    /**
   * @param {Vertice} from
   * @param {number} amountIn
   * @param {number} amountOut
   * @return {string}
   */ testApply(from, amountIn, amountOut) {
        console.assert(this.amountInPrevious * this.amountOutPrevious >= 0);
        const inPrev = this.direction ? this.amountInPrevious : -this.amountInPrevious;
        const outPrev = this.direction ? this.amountOutPrevious : -this.amountOutPrevious;
        const to = from.getNeibour(this);
        let directionNew;
        let amountInNew = 0;
        let amountOutNew = 0;
        if (to) {
            const inInc = from === this.vert0 ? amountIn : -amountOut;
            const outInc = from === this.vert0 ? amountOut : -amountIn;
            const inNew = inPrev + inInc;
            const outNew = outPrev + outInc;
            console.assert(inNew * outNew >= 0);
            if (inNew >= 0) {
                directionNew = true;
                amountInNew = inNew;
                amountOutNew = outNew;
            } else {
                directionNew = false;
                amountInNew = -inNew;
                amountOutNew = -outNew;
            }
        } else console.error("Error 221");
        if (directionNew) {
            const calc = this.pool.calcOutByIn(amountInNew, true).out;
            const res = (0,functions/* closeValues */.S)(amountOutNew, calc, 1e-6);
            if (!res) console.log("Err 225-1 !!", amountOutNew, calc, Math.abs(calc / amountOutNew - 1));
            return res;
        } else {
            const calc1 = this.pool.calcOutByIn(amountOutNew, false).out;
            const res1 = (0,functions/* closeValues */.S)(amountInNew, calc1, 1e-6);
            if (!res1) console.log("Err 225-2!!", amountInNew, calc1, Math.abs(calc1 / amountInNew - 1));
            return res1;
        }
    }
    /**
   * @param {Vertice} from
   */ applySwap(from) {
        console.assert(this.amountInPrevious * this.amountOutPrevious >= 0);
        const inPrev = this.direction ? this.amountInPrevious : -this.amountInPrevious;
        const outPrev = this.direction ? this.amountOutPrevious : -this.amountOutPrevious;
        const to = from.getNeibour(this);
        if (to) {
            const inInc = from === this.vert0 ? from.bestIncome : -to.bestIncome;
            const outInc = from === this.vert0 ? to.bestIncome : -from.bestIncome;
            const inNew = inPrev + inInc;
            const outNew = outPrev + outInc;
            console.assert(inNew * outNew >= 0);
            if (inNew >= 0) {
                this.direction = true;
                this.amountInPrevious = inNew;
                this.amountOutPrevious = outNew;
            } else {
                this.direction = false;
                this.amountInPrevious = -inNew;
                this.amountOutPrevious = -outNew;
            }
        } else console.error("Error 221");
        this.spentGas = this.spentGasNew;
        (0,functions/* ASSERT */.ZO)(()=>{
            const precision = 1e-9;
            // if (this.pool instanceof StableSwapRPool) {
            //   let price = this.pool.calcCurrentPriceWithoutFee(true)
            //   if (price < 1) price = 1 / price
            //   if (price > 1e8) {
            //     // precision degradation for extreme conditions. Almost impossible situation in production
            //     precision = 2e-3
            //   }
            // }
            if (this.direction) {
                const granularity = this.pool.granularity1();
                return (0,functions/* closeValues */.S)(this.amountOutPrevious / granularity, this.pool.calcOutByIn(this.amountInPrevious, this.direction).out / granularity, precision);
            } else {
                const granularity1 = this.pool.granularity0();
                return (0,functions/* closeValues */.S)(this.amountInPrevious / granularity1, this.pool.calcOutByIn(this.amountOutPrevious, this.direction).out / granularity1, precision);
            }
        }, "Error 225");
    }
    /**
   * @param {RPool} p
   * @param {Vertice} v0
   * @param {Vertice} v1
   */ constructor(p, v0, v1){
        this.pool = p;
        this.vert0 = v0;
        this.vert1 = v1;
        this.amountInPrevious = 0;
        this.amountOutPrevious = 0;
        this.canBeUsed = true;
        this.direction = true;
        this.spentGas = 0;
        this.spentGasNew = 0;
        this.bestEdgeIncome = 0;
    }
}
/**
 *
 */ class Vertice {
    /** */ cleanTmpData() {
        this.bestIncome = 0;
        this.gasSpent = 0;
        this.bestTotal = 0;
        this.bestSource = undefined;
        this.checkLine = -1;
    }
    /**
   * @param {Edge} e
   * @return {Vertice}
   */ getNeibour(e) {
        if (!e) return;
        return e.vert0 === this ? e.vert1 : e.vert0;
    }
    /**
   * @return {Edge[]}
   */ getOutputEdges() {
        return this.edges.filter((e)=>{
            if (!e.canBeUsed) return false;
            if (e.amountInPrevious === 0) return false;
            if (e.direction !== (e.vert0 === this)) return false;
            return true;
        });
    }
    /**
   * @return {Edge[]}
   */ getInputEdges() {
        return this.edges.filter((e)=>{
            if (!e.canBeUsed) return false;
            if (e.amountInPrevious === 0) return false;
            if (e.direction === (e.vert0 === this)) return false;
            return true;
        });
    }
    /**
   * @param {RToken} t
   */ constructor(t){
        this.token = t;
        (0,entities/* setTokenId */.tH)(this.token);
        this.edges = [];
        this.price = 0;
        this.gasPrice = 0;
        this.bestIncome = 0;
        this.gasSpent = 0;
        this.bestTotal = 0;
        this.bestSource = undefined;
        this.checkLine = -1;
    }
}
/** */ class Graph_Graph {
    /**
   * @param {RToken} t
   * @return {Vertice | undefined}
   */ getVert(t) {
        return this.tokens.get(t.tokenId);
    }
    /** */ cleanTmpData() {
        this.edges.forEach((e)=>e.cleanTmpData());
        this.vertices.forEach((v)=>v.cleanTmpData());
    }
    /** Set prices using greedy algorithm
   * @param {Vertice} from
   * @param {number} price
   * @param {NetworkInfo[]} networks
   * @param {number}minLiquidity
   * @param {boolean} logging
   */ setPricesStable(from, price, networks) {
        let minLiquidity = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, logging = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        const processedVert = new Set();
        let nextEdges = [];
        const edgeValues = new Map();
        const value = (e)=>edgeValues.get(e);
        /**
     * @param {Vertice} v
     * @param {number} price
     */ function addVertice(v, price) {
            v.price = price;
            const newEdges = v.edges.filter((e)=>{
                if (processedVert.has(v.getNeibour(e))) return false;
                if (e.pool.alwaysAppropriateForPricing()) return true;
                const liquidity = price * parseInt(e.reserve(v).toString());
                if (liquidity < minLiquidity) return false;
                edgeValues.set(e, liquidity);
                return true;
            });
            newEdges.sort((e1, e2)=>value(e1) - value(e2));
            const res = [];
            while(nextEdges.length && newEdges.length){
                if (value(nextEdges[0]) < value(newEdges[0])) res.push(nextEdges.shift());
                else res.push(newEdges.shift());
            }
            nextEdges = [
                ...res,
                ...nextEdges,
                ...newEdges
            ];
            processedVert.add(v);
        }
        if (logging) console.log("Pricing: Initial token ".concat(from.token.symbol, " price=").concat(price));
        addVertice(from, price);
        while(nextEdges.length > 0){
            const bestEdge = nextEdges.pop();
            const [vFrom, vTo] = processedVert.has(bestEdge.vert1) ? [
                bestEdge.vert1,
                bestEdge.vert0
            ] : [
                bestEdge.vert0,
                bestEdge.vert1
            ];
            if (processedVert.has(vTo)) continue;
            const p = bestEdge.pool.calcCurrentPriceWithoutFee(vFrom === bestEdge.vert1);
            if (logging) console.log("Pricing: + Token ".concat(vTo.token.symbol, " price=").concat(vFrom.price * p) + " from ".concat(vFrom.token.symbol, " pool=").concat(bestEdge.pool.address, " liquidity=").concat(edgeValues.get(bestEdge)));
            addVertice(vTo, vFrom.price * p);
        }
        const gasPrice = new Map();
        networks.forEach((n)=>{
            var ref;
            const vPrice = ((ref = this.getVert(n.baseToken)) === null || ref === void 0 ? void 0 : ref.price) || 0;
            gasPrice.set(n.chainId, n.gasPrice * vPrice);
        });
        processedVert.forEach((v)=>{
            const gasPriceChainId = gasPrice.get(v.token.chainId);
            console.assert(gasPriceChainId !== undefined, "Error 427");
            console.assert(v.price !== 0, "Error 428");
            v.gasPrice = gasPriceChainId / v.price;
        });
    }
    /** Set prices using greedy algorithm
   * @param {Vertice} from
   * @param {number} price
   * @param {number} gasPrice
   */ setPricesStableInsideChain(from, price, gasPrice) {
        const processedVert = new Set();
        let nextEdges = [];
        const edgeValues = new Map();
        const value = (e)=>edgeValues.get(e);
        /**
     * @param {Vertice} v
     * @param {number} price
     * @param {number} gasPrice
     */ function addVertice(v, price, gasPrice) {
            v.price = price;
            v.gasPrice = gasPrice;
            const newEdges = v.edges.filter((e)=>{
                const newV = v.getNeibour(e);
                return (newV === null || newV === void 0 ? void 0 : newV.token.chainId) === v.token.chainId && !processedVert.has(v.getNeibour(e));
            });
            newEdges.forEach((e)=>edgeValues.set(e, price * parseInt(e.reserve(v).toString())));
            newEdges.sort((e1, e2)=>value(e1) - value(e2));
            const res = [];
            while(nextEdges.length && newEdges.length){
                if (value(nextEdges[0]) < value(newEdges[0])) res.push(nextEdges.shift());
                else res.push(newEdges.shift());
            }
            nextEdges = [
                ...res,
                ...nextEdges,
                ...newEdges
            ];
            processedVert.add(v);
        }
        addVertice(from, price, gasPrice);
        while(nextEdges.length > 0){
            const bestEdge = nextEdges.pop();
            const [vFrom, vTo] = processedVert.has(bestEdge.vert1) ? [
                bestEdge.vert1,
                bestEdge.vert0
            ] : [
                bestEdge.vert0,
                bestEdge.vert1
            ];
            if (processedVert.has(vTo)) continue;
            const p = bestEdge.pool.calcCurrentPriceWithoutFee(vFrom === bestEdge.vert1);
            addVertice(vTo, vFrom.price * p, vFrom.gasPrice / p);
        }
    }
    /** Set prices by search in depth
   * @param {Vertice} from
   * @param {number} price
   * @param {number} gasPrice
   */ setPrices(from, price, gasPrice) {
        if (from.price !== 0) return;
        from.price = price;
        from.gasPrice = gasPrice;
        const edges = from.edges.map((e)=>[
                e,
                parseInt(e.reserve(from).toString())
            ]).sort((param, param1)=>{
            let [_1, r1] = param, [_2, r2] = param1;
            return r2 - r1;
        });
        edges.forEach((param)=>{
            let [e, _] = param;
            const v = e.vert0 === from ? e.vert1 : e.vert0;
            if (v.price !== 0) return;
            const p = e.pool.calcCurrentPriceWithoutFee(from === e.vert1);
            this.setPrices(v, price * p, gasPrice / p);
        });
    }
    /**
   * @param {RToken} token
   * @return {Vertice}
   */ getOrCreateVertice(token) {
        let vert = this.getVert(token);
        if (vert) return vert;
        vert = new Vertice(token);
        this.vertices.push(vert);
        this.tokens.set(token.tokenId, vert);
        return vert;
    }
    /* exportPath(from: RToken, to: RToken) {

    const fromVert = this.getVert(from) as Vertice
    const toVert = this.getVert(to) as Vertice
    const initValue = (fromVert.bestIncome * fromVert.price) / toVert.price

    const route = new Set<Edge>()
    for (let v = toVert; v !== fromVert; v = v.getNeibour(v.bestSource) as Vertice) {
      if (v.bestSource) route.add(v.bestSource)
    }

    function edgeStyle(e: Edge) {
      const finish = e.vert1.bestSource === e
      const start = e.vert0.bestSource === e
      let label
      if (e.bestEdgeIncome === -1) label = 'label: "low_liq"'
      if (e.bestEdgeIncome !== 0) label = `label: "${print((e.bestEdgeIncome / initValue - 1) * 100, 3)}%"`
      const edgeValue = route.has(e) ? 'value: 2' : undefined
      let arrow
      if (finish && start) arrow = 'arrows: "from,to"'
      if (finish) arrow = 'arrows: "to"'
      if (start) arrow = 'arrows: "from"'
      return ['', label, edgeValue, arrow].filter((a) => a !== undefined).join(', ')
    }

    function print(n: number, digits: number) {
      let out
      if (n === 0) out = '0'
      else {
        const n0 = n > 0 ? n : -n
        const shift = digits - Math.ceil(Math.log(n0) / Math.LN10)
        if (shift <= 0) out = `${Math.round(n0)}`
        else {
          const mult = Math.pow(10, shift)
          out = `${Math.round(n0 * mult) / mult}`
        }
        if (n < 0) out = -out
      }
      return out
    }

    function nodeLabel(v: Vertice) {
      const value = (v.bestIncome * v.price) / toVert.price
      const income = `${print(value, 3)}`
      const total = `${print(v.bestTotal, 3)}`
      // const income = `${print((value/initValue-1)*100, 3)}%`
      // const total = `${print((v.bestTotal/initValue-1)*100, 3)}%`
      const checkLine = v.checkLine === -1 ? undefined : `${v.checkLine}`
      return [checkLine, income, total].filter((a) => a !== undefined).join(':')
    }

    const nodes = `var nodes = new vis.DataSet([
      ${this.vertices.map((t) => `{ id: ${t.token.name}, label: "${nodeLabel(t)}"}`).join(',\n\t\t')}
    ]);\n`
    const edges = `var edges = new vis.DataSet([
      ${this.edges
        .map((p) => `{ from: ${p.vert0.token.name}, to: ${p.vert1.token.name}${edgeStyle(p)}}`)
        .join(',\n\t\t')}
    ]);\n`
    const data = `var data = {
        nodes: nodes,
        edges: edges,
    };\n`

    // TODO: This should be removed, this pacakge will not be installable on a client while this remains.
    const fs = require("fs");
    fs.writeFileSync(
      "D:/Info/Notes/GraphVisualization/data.js",
      nodes + edges + data
    );
  }*/ /**
   * @param {RToken}from
   * @param {RToken}to
   * @param {number}amountIn
   * @return {[Edge[], number, number, number]}
   */ findBestPathExactIn(from, to, amountIn) {
        const start = this.getVert(from);
        const finish = this.getVert(to);
        if (!start || !finish) return;
        this.edges.forEach((e)=>{
            e.bestEdgeIncome = 0;
            e.spentGasNew = 0;
        });
        this.vertices.forEach((v)=>{
            v.bestIncome = 0;
            v.gasSpent = 0;
            v.bestTotal = 0;
            v.bestSource = undefined;
            v.checkLine = -1;
        });
        start.bestIncome = amountIn;
        start.bestTotal = amountIn;
        const processedVert = new Set();
        const nextVertList = [
            start
        ] // TODO: Use sorted Set!
        ;
        let debug_info = "";
        let checkLine = 0;
        for(;;){
            let closestVert;
            let closestTotal;
            let closestPosition = 0;
            nextVertList.forEach((v, i)=>{
                if (closestTotal === undefined || v.bestTotal > closestTotal) {
                    closestTotal = v.bestTotal;
                    closestVert = v;
                    closestPosition = i;
                }
            });
            if (!closestVert) return;
            closestVert.checkLine = checkLine++;
            if (closestVert === finish) {
                const bestPath = [];
                for(let v = finish; v === null || v === void 0 ? void 0 : v.bestSource; v = v.getNeibour(v.bestSource)){
                    bestPath.unshift(v.bestSource);
                }
                (0,functions/* DEBUG */.eM)(()=>console.log(debug_info));
                return {
                    path: bestPath,
                    output: finish.bestIncome,
                    gasSpent: finish.gasSpent,
                    totalOutput: finish.bestTotal
                };
            }
            nextVertList.splice(closestPosition, 1);
            closestVert.edges.forEach((e)=>{
                const v2 = closestVert === e.vert0 ? e.vert1 : e.vert0;
                if (processedVert.has(v2)) return;
                let newIncome;
                let gas;
                try {
                    const { out , gasSpent  } = e.calcOutput(closestVert, closestVert.bestIncome);
                    if (!isFinite(out) || !isFinite(gasSpent)) // Math errors protection
                    return;
                    newIncome = out;
                    gas = gasSpent;
                } catch (err) {
                    // Any arithmetic error or out-of-liquidity
                    e.bestEdgeIncome = -1;
                    return;
                }
                // if (e.checkMinimalLiquidityExceededAfterSwap(closestVert as Vertice, newIncome)) {
                //   e.bestEdgeIncome = -1
                //   return
                // }
                const newGasSpent = closestVert.gasSpent + gas;
                const price = v2.price / finish.price;
                const gasPrice = v2.gasPrice * price;
                const newTotal = newIncome * price - newGasSpent * gasPrice;
                console.assert(e.bestEdgeIncome === 0, "Error 373");
                e.bestEdgeIncome = newIncome * price;
                e.spentGasNew = e.spentGas + gas;
                if (!v2.bestSource) nextVertList.push(v2);
                if (!v2.bestSource || newTotal > v2.bestTotal) {
                    (0,functions/* DEBUG */.eM)(()=>{
                        const st = (closestVert === null || closestVert === void 0 ? void 0 : closestVert.token) == from ? "*" : "";
                        const fn = (v2 === null || v2 === void 0 ? void 0 : v2.token) == to ? "*" : "";
                        debug_info += "".concat(st).concat(closestVert === null || closestVert === void 0 ? void 0 : closestVert.token.name, "->").concat(v2.token.name).concat(fn, " ").concat(v2.bestIncome, " -> ").concat(newIncome, "\n");
                    });
                    v2.bestIncome = newIncome;
                    v2.gasSpent = newGasSpent;
                    v2.bestTotal = newTotal;
                    v2.bestSource = e;
                }
            });
            processedVert.add(closestVert);
        }
    }
    /**
   * @param {RToken}from
   * @param {RToken}to
   * @param {number}amountOut
   * @return {[Edge[], number, number, number]}
   */ findBestPathExactOut(from, to, amountOut) {
        const start = this.getVert(to);
        const finish = this.getVert(from);
        if (!start || !finish) return;
        this.edges.forEach((e)=>{
            e.bestEdgeIncome = 0;
            e.spentGasNew = 0;
        });
        this.vertices.forEach((v)=>{
            v.bestIncome = 0;
            v.gasSpent = 0;
            v.bestTotal = 0;
            v.bestSource = undefined;
            v.checkLine = -1;
        });
        start.bestIncome = amountOut;
        start.bestTotal = amountOut;
        const processedVert = new Set();
        const nextVertList = [
            start
        ] // TODO: Use sorted Set!
        ;
        let debug_info = "";
        let checkLine = 0;
        for(;;){
            let closestVert;
            let closestTotal;
            let closestPosition = 0;
            nextVertList.forEach((v, i)=>{
                if (closestTotal === undefined || v.bestTotal < closestTotal) {
                    closestTotal = v.bestTotal;
                    closestVert = v;
                    closestPosition = i;
                }
            });
            if (!closestVert) return;
            closestVert.checkLine = checkLine++;
            if (closestVert === finish) {
                const bestPath = [];
                for(let v = finish; v === null || v === void 0 ? void 0 : v.bestSource; v = v.getNeibour(v.bestSource)){
                    bestPath.push(v.bestSource);
                }
                (0,functions/* DEBUG */.eM)(()=>console.log(debug_info));
                return {
                    path: bestPath,
                    input: finish.bestIncome,
                    gasSpent: finish.gasSpent,
                    totalInput: finish.bestTotal
                };
            }
            nextVertList.splice(closestPosition, 1);
            closestVert.edges.forEach((e)=>{
                const v2 = closestVert === e.vert0 ? e.vert1 : e.vert0;
                if (processedVert.has(v2)) return;
                let newIncome;
                let gas;
                try {
                    const { inp , gasSpent  } = e.calcInput(closestVert, closestVert.bestIncome);
                    if (!isFinite(inp) || !isFinite(gasSpent)) // Math errors protection
                    return;
                    if (inp < 0) return; // No enouph liquidity in the pool
                    newIncome = inp;
                    gas = gasSpent;
                } catch (e1) {
                    // Any arithmetic error or out-of-liquidity
                    return;
                }
                const newGasSpent = closestVert.gasSpent + gas;
                const price = v2.price / finish.price;
                const gasPrice = v2.gasPrice * price;
                const newTotal = newIncome * price + newGasSpent * gasPrice;
                console.assert(e.bestEdgeIncome === 0, "Error 373");
                e.bestEdgeIncome = newIncome * price;
                e.spentGasNew = e.spentGas + gas;
                if (!v2.bestSource) nextVertList.push(v2);
                if (!v2.bestSource || newTotal < v2.bestTotal) {
                    (0,functions/* DEBUG */.eM)(()=>{
                        const st = (v2 === null || v2 === void 0 ? void 0 : v2.token) == from ? "*" : "";
                        const fn = (closestVert === null || closestVert === void 0 ? void 0 : closestVert.token) == to ? "*" : "";
                        debug_info += "".concat(st).concat(closestVert === null || closestVert === void 0 ? void 0 : closestVert.token.name, "<-").concat(v2.token.name).concat(fn, " ").concat(v2.bestIncome, " -> ").concat(newIncome, "\n");
                    });
                    v2.bestIncome = newIncome;
                    v2.gasSpent = newGasSpent;
                    v2.bestTotal = newTotal;
                    v2.bestSource = e;
                }
            });
            processedVert.add(closestVert);
        }
    }
    /**
   * @param {Vertice | undefined} from
   * @param {Vertice | undefined} to
   * @param {Edge[]} path
   */ addPath(from, to, path) {
        let _from = from;
        path.forEach((e)=>{
            if (_from) {
                e.applySwap(_from);
                _from = _from.getNeibour(e);
            } else {
                console.error("Unexpected 315");
            }
        });
        (0,functions/* ASSERT */.ZO)(()=>{
            const res = this.vertices.every((v)=>{
                let total = 0;
                let totalModule = 0;
                v.edges.forEach((e)=>{
                    if (e.vert0 === v) {
                        if (e.direction) {
                            total -= e.amountInPrevious;
                        } else {
                            total += e.amountInPrevious;
                        }
                        totalModule += e.amountInPrevious;
                    } else {
                        if (e.direction) {
                            total += e.amountOutPrevious;
                        } else {
                            total -= e.amountOutPrevious;
                        }
                        totalModule += e.amountOutPrevious;
                    }
                });
                if (v === from) return total <= 0;
                if (v === to) return total >= 0;
                if (totalModule === 0) return total === 0;
                return Math.abs(total / totalModule) < 1e10;
            });
            return res;
        }, "Error 290");
    }
    /**
   * @param {Vertice | undefined} from
   * @param {Edge[]} path
   * @return {number}
   */ getPrimaryPriceForPath(from, path) {
        let p = 1;
        let prevToken = from;
        path.forEach((edge)=>{
            const direction = edge.vert0 === prevToken;
            const edgePrice = edge.pool.calcCurrentPriceWithoutFee(direction);
            p *= edgePrice;
            prevToken = prevToken.getNeibour(edge);
        });
        return p;
    }
    /**
   * @param {RToken} from
   * @param {RToken} to
   * @param {BigNumber | number} amountIn
   * @param {number | number[]} mode
   * @return {MultiRoute}
   */ findBestRouteExactIn(from, to, amountIn, mode) {
        let amountInBN;
        if (amountIn instanceof bignumber/* BigNumber */.O$) {
            amountInBN = amountIn;
            amountIn = parseInt(amountIn.toString());
        } else {
            amountInBN = (0,functions/* getBigNumber */.Xq)(amountIn);
        }
        let routeValues = [];
        if (Array.isArray(mode)) {
            const sum = mode.reduce((a, b)=>a + b, 0);
            routeValues = mode.map((e)=>e / sum);
        } else {
            for(let i = 0; i < mode; ++i)routeValues.push(1 / mode);
        }
        this.edges.forEach((e)=>{
            e.amountInPrevious = 0;
            e.amountOutPrevious = 0;
            e.direction = true;
        });
        let output = 0;
        let gasSpentInit = 0;
        let totalOutput = 0;
        let totalrouted = 0;
        let primaryPrice;
        let step;
        for(step = 0; step < routeValues.length; ++step){
            const p = this.findBestPathExactIn(from, to, amountIn * routeValues[step]);
            if (!p) {
                break;
            } else {
                output += p.output;
                gasSpentInit += p.gasSpent;
                totalOutput += p.totalOutput;
                this.addPath(this.getVert(from), this.getVert(to), p.path);
                totalrouted += routeValues[step];
            }
        }
        if (step == 0 || output == 0) return {
            status: Graph_RouteStatus.NoWay,
            fromToken: from,
            toToken: to,
            amountIn: 0,
            amountInBN: bignumber/* BigNumber.from */.O$.from(0),
            amountOut: 0,
            amountOutBN: bignumber/* BigNumber.from */.O$.from(0),
            legs: [],
            gasSpent: 0,
            totalAmountOut: 0,
            totalAmountOutBN: bignumber/* BigNumber.from */.O$.from(0)
        };
        let status;
        if (step < routeValues.length) status = Graph_RouteStatus.Partial;
        else status = Graph_RouteStatus.Success;
        this.removeEdgesWithLowFlow(0.001);
        const fromVert = this.getVert(from);
        const toVert = this.getVert(to);
        const { legs , gasSpent  } = this.getRouteLegs(fromVert, toVert);
        console.assert(gasSpent <= gasSpentInit, "Internal Error 491");
        // if (topologyWasChanged || removedEdgesNumber > 0) {
        output = this.updateLegsAmountOut(legs, amountIn * totalrouted);
        totalOutput = output - toVert.gasPrice * gasSpent;
        if (output == 0) {
            status = Graph_RouteStatus.NoWay;
            totalOutput = 0;
        }
        // }
        let swapPrice;
        let priceImpact;
        try {
            var ref, ref1;
            swapPrice = output / amountIn / totalrouted;
            const priceTo = (ref = this.getVert(to)) === null || ref === void 0 ? void 0 : ref.price;
            const priceFrom = (ref1 = this.getVert(from)) === null || ref1 === void 0 ? void 0 : ref1.price;
            primaryPrice = priceTo && priceFrom ? priceFrom / priceTo : undefined;
            priceImpact = primaryPrice !== undefined ? 1 - swapPrice / primaryPrice : undefined;
        } catch (e) {
        /* skip division by 0 errors*/ }
        return {
            status,
            fromToken: from,
            toToken: to,
            primaryPrice,
            swapPrice,
            priceImpact,
            amountIn: amountIn * totalrouted,
            amountInBN: status == Graph_RouteStatus.Success ? amountInBN : (0,functions/* getBigNumber */.Xq)(amountIn * totalrouted),
            amountOut: output,
            amountOutBN: (0,functions/* getBigNumber */.Xq)(output),
            legs,
            gasSpent,
            totalAmountOut: totalOutput,
            totalAmountOutBN: (0,functions/* getBigNumber */.Xq)(totalOutput)
        };
    }
    /**
   * @param {RToken} from
   * @param {RToken} to
   * @param {BigNumber | number} amountOut
   * @param {number | number[]} mode
   * @return {MultiRoute}
   */ findBestRouteExactOut(from, to, amountOut, mode) {
        let routeValues = [];
        if (Array.isArray(mode)) {
            const sum = mode.reduce((a, b)=>a + b, 0);
            routeValues = mode.map((e)=>e / sum);
        } else {
            for(let i = 0; i < mode; ++i)routeValues.push(1 / mode);
        }
        this.edges.forEach((e)=>{
            e.amountInPrevious = 0;
            e.amountOutPrevious = 0;
            e.direction = true;
        });
        let input = 0;
        let gasSpentInit = 0;
        // let totalInput = 0
        let totalrouted = 0;
        let primaryPrice;
        let step;
        for(step = 0; step < routeValues.length; ++step){
            const p = this.findBestPathExactOut(from, to, amountOut * routeValues[step]);
            if (!p) {
                break;
            } else {
                input += p.input;
                gasSpentInit += p.gasSpent;
                // totalInput += p.totalInput
                this.addPath(this.getVert(from), this.getVert(to), p.path);
                totalrouted += routeValues[step];
            // if (step === 0) {
            //   primaryPrice = this.getPrimaryPriceForPath(this.getVert(from) as Vertice, p.path)
            // }
            }
        }
        if (step == 0) return {
            status: Graph_RouteStatus.NoWay,
            fromToken: from,
            toToken: to,
            amountIn: 0,
            amountInBN: bignumber/* BigNumber.from */.O$.from(0),
            amountOut: 0,
            amountOutBN: bignumber/* BigNumber.from */.O$.from(0),
            legs: [],
            gasSpent: 0,
            totalAmountOut: 0,
            totalAmountOutBN: bignumber/* BigNumber.from */.O$.from(0)
        };
        let status;
        if (step < routeValues.length) status = Graph_RouteStatus.Partial;
        else status = Graph_RouteStatus.Success;
        const removedEdgesNumber = this.removeEdgesWithLowFlow(0.001);
        const fromVert = this.getVert(from);
        const toVert = this.getVert(to);
        const { legs , gasSpent , topologyWasChanged  } = this.getRouteLegs(fromVert, toVert);
        console.assert(gasSpent <= gasSpentInit, "Internal Error 491");
        if (topologyWasChanged || removedEdgesNumber > 0) {
            input = this.calcLegsAmountIn(legs, amountOut);
        }
        let swapPrice;
        let priceImpact;
        try {
            var ref, ref1;
            swapPrice = amountOut / input;
            const priceTo = (ref = this.getVert(to)) === null || ref === void 0 ? void 0 : ref.price;
            const priceFrom = (ref1 = this.getVert(from)) === null || ref1 === void 0 ? void 0 : ref1.price;
            primaryPrice = priceTo && priceFrom ? priceFrom / priceTo : undefined;
            priceImpact = primaryPrice !== undefined ? 1 - swapPrice / primaryPrice : undefined;
        } catch (e) {
        /* skip division by 0 errors*/ }
        return {
            status,
            fromToken: from,
            toToken: to,
            primaryPrice,
            swapPrice,
            priceImpact,
            amountIn: input,
            amountInBN: (0,functions/* getBigNumber */.Xq)(input),
            amountOut: amountOut * totalrouted,
            amountOutBN: (0,functions/* getBigNumber */.Xq)(amountOut * totalrouted),
            legs,
            gasSpent,
            totalAmountOut: amountOut - gasSpent * toVert.gasPrice,
            totalAmountOutBN: (0,functions/* getBigNumber */.Xq)(amountOut - gasSpent * toVert.gasPrice)
        };
    }
    /**
   * @param {Vertice}from
   * @param {Vertice}to
   * @return {[RouteLeg[], number, boolean]}
   */ getRouteLegs(from, to) {
        const { vertices , topologyWasChanged  } = this.cleanTopology(from, to);
        const legs = [];
        let gasSpent = 0;
        vertices.forEach((n)=>{
            const outEdges = n.getOutputEdges().map((e)=>{
                const from = this.edgeFrom(e);
                return from ? [
                    e,
                    from.vert,
                    from.amount
                ] : [
                    e
                ];
            });
            let outAmount = outEdges.reduce((a, b)=>a + b[2], 0);
            if (outAmount <= 0) return;
            const total = outAmount;
            // IMPORTANT: Casting to Number to avoid compiler bug which for some reason
            // keeps reference to outAmount which is mutated later
            // const total = Number(outAmount)
            // const totalTest = outAmount
            // console.debug('BEFORE', { outAmount, total, totalTest })
            outEdges.forEach((e, i)=>{
                const p = e[2];
                const quantity = i + 1 === outEdges.length ? 1 : p / outAmount;
                const edge = e[0];
                // console.debug(`edge iter ${0}`, { e, p })
                const poolType = edge.pool instanceof entities/* BridgeUnlimited */.Yl ? "Wrap" : edge.pool instanceof entities/* ConstantProductRPool */.zx ? "Classic" : "Unknown";
                legs.push({
                    poolAddress: edge.pool.address,
                    poolType,
                    poolFee: edge.pool.fee,
                    tokenFrom: n.token,
                    tokenTo: n.getNeibour(edge).token,
                    assumedAmountIn: edge.direction ? edge.amountInPrevious : edge.amountOutPrevious,
                    assumedAmountOut: edge.direction ? edge.amountOutPrevious : edge.amountInPrevious,
                    swapPortion: quantity,
                    absolutePortion: p / total
                });
                gasSpent += e[0].pool.swapGasCost;
                // console.debug('before amountOut mutation', { total, outAmount })
                outAmount -= p;
            // console.debug('after amountOut mutation', { total, outAmount })
            });
            // console.debug('AFTER', { outAmount, total, totalTest }, outAmount / total)
            console.assert(outAmount / total < 1e-12, "Error 281");
        });
        return {
            legs,
            gasSpent,
            topologyWasChanged
        };
    }
    /**
   * @param {Edge} e
   * @return {[Vertice, number] | undefined}
   */ edgeFrom(e) {
        if (e.amountInPrevious === 0) return undefined;
        return e.direction ? {
            vert: e.vert0,
            amount: e.amountInPrevious
        } : {
            vert: e.vert1,
            amount: e.amountOutPrevious
        };
    }
    /**  Removes all edges that have lesser than minFraction portion of vertex output liquidity
   *   Such edges can appear as an accumulation of forward and backward streams
   *   They spend more gas than provide slippage reduction
   *   They confuse users
   *   Also, route processor can fail trying to process them
   * @param {number} minFraction
   * @return {number}
   */ removeEdgesWithLowFlow(minFraction) {
        const weakEdgeList = [];
        this.vertices.forEach((v)=>{
            const outEdges = v.getOutputEdges();
            if (outEdges.length <= 1) return;
            const amounts = outEdges.map((e)=>{
                const data = this.edgeFrom(e);
                if (data !== undefined) return data.amount;
                console.error("Tines: Internal Error 1123");
                return;
            });
            const totalOut = amounts.reduce((a, b)=>a += b, 0);
            outEdges.forEach((e, i)=>{
                if (amounts[i] / totalOut < minFraction) weakEdgeList.push(e);
            });
        });
        weakEdgeList.forEach((e)=>e.canBeUsed = false);
        return weakEdgeList.length;
    }
    /** returns route output
   * @param {RouteLeg[]} legs
   * @param {number} amountIn
   * @return {number}
   */ updateLegsAmountOut(legs, amountIn) {
        const amounts = new Map();
        amounts.set(legs[0].tokenFrom.tokenId, amountIn);
        legs.forEach((l)=>{
            const vert = this.getVert(l.tokenFrom);
            console.assert(vert !== undefined, "Internal Error 570");
            const edge = vert.edges.find((e)=>e.pool.address === l.poolAddress);
            console.assert(edge !== undefined, "Internel Error 569");
            const pool = edge.pool;
            const direction = vert === edge.vert0;
            const inputTotal = amounts.get(l.tokenFrom.tokenId);
            console.assert(inputTotal !== undefined, "Internal Error 564");
            const routerPortion = Math.round(l.swapPortion * ROUTER_DISTRIBUTION_PORTION) / ROUTER_DISTRIBUTION_PORTION;
            const input = Math.floor(inputTotal * routerPortion);
            amounts.set(l.tokenFrom.tokenId, inputTotal - input);
            const output = pool.calcOutByInReal(input, direction);
            const vertNext = vert.getNeibour(edge);
            const prevAmount = amounts.get(vertNext.token.tokenId);
            amounts.set(vertNext.token.tokenId, (prevAmount || 0) + output);
            l.assumedAmountIn = input;
            l.assumedAmountOut = output;
        });
        return amounts.get(legs[legs.length - 1].tokenTo.tokenId) || 0;
    }
    /** TODO: make full test coverage!
   * @param {RouteLeg[]} legs
   * @param {number} amountOut
   * @return {number}
   */ calcLegsAmountIn(legs, amountOut) {
        const totalOutputAssumed = new Map();
        legs.forEach((l)=>{
            const prevValue = totalOutputAssumed.get(l.tokenFrom.tokenId) || 0;
            totalOutputAssumed.set(l.tokenFrom.tokenId, prevValue + l.assumedAmountOut);
        });
        const amounts = new Map();
        amounts.set(legs[legs.length - 1].tokenTo.tokenId, amountOut);
        for(let i = legs.length - 1; i >= 0; --i){
            const l = legs[i];
            const vert = this.getVert(l.tokenTo);
            console.assert(vert !== undefined, "Internal Error 884");
            const edge = vert.edges.find((e)=>e.pool.address === l.poolAddress);
            console.assert(edge !== undefined, "Internel Error 888");
            const pool = edge.pool;
            const direction = vert === edge.vert1;
            const outputTotal = amounts.get(l.tokenTo.tokenId);
            console.assert(outputTotal !== undefined, "Internal Error 893");
            const totalAssumed = totalOutputAssumed.get(l.tokenFrom.tokenId);
            console.assert(totalAssumed !== undefined, "Internal Error 903");
            const output = outputTotal * l.assumedAmountOut / totalAssumed;
            const input = pool.calcInByOut(output, direction).inp;
            const vertNext = vert.getNeibour(edge);
            const prevAmount = amounts.get(vertNext.token.tokenId);
            amounts.set(vertNext.token.tokenId, (prevAmount || 0) + input);
        }
        return amounts.get(legs[0].tokenFrom.tokenId) || 0;
    }
    /** removes all cycles if there are any, then removes all dead end could appear after cycle removing
   * @param {Vertice} from
   * @param {Vertice} to
   * @return {[Vertice[], boolean]} Returns clean result topologically sorted
   */ cleanTopology(from, to) {
        let topologyWasChanged = false;
        let result = this.topologySort(from, to);
        if (result.status !== 2) {
            topologyWasChanged = true;
            // it can be 3, because we make this.removeEdgesWithLowFlow(0.005) before
            // console.assert(result.status === 0, 'Internal Error 554')
            while(result.status === 0){
                this.removeWeakestEdge(result.vertices);
                result = this.topologySort(from, to);
            }
            if (result.status === 3) {
                this.removeDeadEnds(result.vertices);
                result = this.topologySort(from, to);
            }
            console.assert(result.status === 2, "Internal Error 563");
            if (result.status !== 2) return {
                vertices: [],
                topologyWasChanged
            };
        }
        return {
            vertices: result.vertices,
            topologyWasChanged
        };
    }
    /**
   * @param {Vertice[]} verts
   */ removeDeadEnds(verts) {
        verts.forEach((v)=>{
            v.getInputEdges().forEach((e)=>{
                e.canBeUsed = false;
            });
        });
    }
    /**
   * @param {Vertice[]} verts
   */ removeWeakestEdge(verts) {
        let minVert;
        let minVertNext;
        let minOutput = Number.MAX_VALUE;
        verts.forEach((v1, i)=>{
            const v2 = i === 0 ? verts[verts.length - 1] : verts[i - 1];
            let out = 0;
            v1.getOutputEdges().forEach((e)=>{
                if (v1.getNeibour(e) !== v2) return;
                out += e.direction ? e.amountOutPrevious : e.amountInPrevious;
            });
            if (out < minOutput) {
                minVert = v1;
                minVertNext = v2;
                minOutput = out;
            }
        });
        // @ts-ignore
        minVert.getOutputEdges().forEach((e)=>{
            if (minVert.getNeibour(e) !== minVertNext) return;
            e.canBeUsed = false;
        });
    }
    /** topological sort
   *  if there is a cycle - returns [0, <List of envolved vertices in the cycle>]
   *  if there are no cycles but deadends- returns [3, <List of all envolved deadend vertices>]
   *  if there are no cycles or deadends- returns [2, <List of all envolved vertices topologically sorted>]
   * @param {Vertice} from
   * @param {Vertice} to
   * @return {[number, Vertice[]]}
   */ topologySort(from, to) {
        // undefined or 0 - not processed, 1 - in process, 2 - finished, 3 - dedend
        const vertState = new Map();
        const vertsFinished = [];
        const foundCycle = [];
        const foundDeadEndVerts = [];
        /** 0 - cycle was found and created, return
     *   1 - during cycle creating
     *   2 - vertex is processed ok
     *   3 - dead end vertex
     * @param {Vertice} current
     * @return {number}
     */ function topSortRecursive(current) {
            const state = vertState.get(current);
            if (state === 2 || state === 3) return state;
            if (state === 1) {
                console.assert(foundCycle.length == 0, "Internal Error 566");
                foundCycle.push(current);
                return 1;
            }
            vertState.set(current, 1);
            let successors2Exist = false;
            const outEdges = current.getOutputEdges();
            for(let i = 0; i < outEdges.length; ++i){
                const e = outEdges[i];
                const res = topSortRecursive(current.getNeibour(e));
                if (res === 0) return 0;
                if (res === 1) {
                    if (foundCycle[0] === current) return 0;
                    else {
                        foundCycle.push(current);
                        return 1;
                    }
                }
                if (res === 2) successors2Exist = true // Ok successors
                ;
            }
            if (successors2Exist) {
                console.assert(current !== to, "Internal Error 589");
                vertsFinished.push(current);
                vertState.set(current, 2);
                return 2;
            } else {
                if (current !== to) {
                    foundDeadEndVerts.push(current);
                    vertState.set(current, 3);
                    return 3;
                }
                vertsFinished.push(current);
                vertState.set(current, 2);
                return 2;
            }
        }
        const res = topSortRecursive(from);
        if (res === 0) return {
            status: 0,
            vertices: foundCycle
        };
        if (foundDeadEndVerts.length) return {
            status: 3,
            vertices: foundDeadEndVerts
        };
        (0,functions/* ASSERT */.ZO)(()=>{
            if (vertsFinished[0] !== to) return false;
            if (vertsFinished[vertsFinished.length - 1] !== from) return false;
            return true;
        }, "Internal Error 614");
        if (res === 2) return {
            status: 2,
            vertices: vertsFinished.reverse()
        };
        console.assert(true, "Internal Error 612");
        return {
            status: 1,
            vertices: []
        };
    }
    // Single network usage: (pools, baseToken, gasPrice)
    // Multiple Network usage: (pools, networks)
    /**
   * @param {RPool[]}pools
   * @param {RToken}start
   * @param {RToken | NetworkInfo[]}baseTokenOrNetworks
   * @param {number}gasPriceSingleNetwork
   * @param {number}minPriceLiquidity
   * @param {boolean} priceLogging
   */ constructor(pools, start, baseTokenOrNetworks, gasPriceSingleNetwork, minPriceLiquidity = 0, priceLogging = false){
        const networks = baseTokenOrNetworks instanceof Array ? baseTokenOrNetworks : [
            {
                chainId: baseTokenOrNetworks.chainId,
                baseToken: baseTokenOrNetworks,
                // baseTokenPrice: 1,
                gasPrice: gasPriceSingleNetwork || 0
            }
        ];
        (0,entities/* setTokenId */.tH)(...networks.map((n)=>n.baseToken));
        this.vertices = [];
        this.edges = [];
        this.tokens = new Map();
        pools.forEach((p)=>{
            const v0 = this.getOrCreateVertice(p.token0);
            const v1 = this.getOrCreateVertice(p.token1);
            const edge = new Edge(p, v0, v1);
            v0.edges.push(edge);
            v1.edges.push(edge);
            this.edges.push(edge);
        });
        // networks.forEach((n) => {
        //   const baseVert = this.getVert(n.baseToken)
        //   if (baseVert) {
        //     this.setPricesStable(baseVert, n.baseTokenPrice, n.gasPrice, true)
        //   }
        // })
        const startV = this.getVert(start);
        if (startV !== undefined) this.setPricesStable(startV, 1, networks, minPriceLiquidity, priceLogging);
    }
}

;// CONCATENATED MODULE: ./src/functions/trade/MultiRouter.ts



// Assumes route is a single path
/**
 * @param {MultiRoute}route 
 * @return {number | undefined}
 */ function calcPriceImactWithoutFee(route) {
    if (route.primaryPrice === undefined || route.swapPrice === undefined) {
        return undefined;
    } else {
        let oneMinusCombinedFee = 1;
        route.legs.forEach((l)=>oneMinusCombinedFee *= 1 - l.poolFee);
        // const combinedFee = 1-oneMinusCombinedFee
        return Math.max(0, 1 - route.swapPrice / route.primaryPrice / oneMinusCombinedFee);
    }
}
const defaultFlowNumber = 12;
const maxFlowNumber = 100;
/**
 * @param {MultiRoute}bestSingleRoute 
 * @param {BigNumber | number}amountIn 
 * @param {number}gasPriceIn 
 * @return {number}
 */ function calcBestFlowNumber(bestSingleRoute, amountIn, gasPriceIn) {
    if (amountIn instanceof bignumber/* BigNumber */.O$) {
        amountIn = parseInt(amountIn.toString());
    }
    const priceImpact = calcPriceImactWithoutFee(bestSingleRoute);
    if (!priceImpact) return defaultFlowNumber;
    const bestFlowAmount = Math.sqrt(bestSingleRoute.gasSpent * (gasPriceIn || 0) * amountIn / priceImpact);
    const bestFlowNumber = Math.round(amountIn / bestFlowAmount);
    if (!isFinite(bestFlowNumber)) return maxFlowNumber;
    const realFlowNumber = Math.max(1, Math.min(bestFlowNumber, maxFlowNumber));
    return realFlowNumber;
}
/**
 * @param {MultiRoute}route1 
 * @param {MultiRoute}route2 
 * @return {MultiRoute}
 */ function getBetterRouteExactIn(route1, route2) {
    if (route1.status == entities/* RouteStatus.NoWay */.yB.NoWay) return route2;
    if (route2.status == entities/* RouteStatus.NoWay */.yB.NoWay) return route1;
    if (route1.status == entities/* RouteStatus.Partial */.yB.Partial && route2.status == entities/* RouteStatus.Success */.yB.Success) return route2;
    if (route2.status == entities/* RouteStatus.Partial */.yB.Partial && route1.status == entities/* RouteStatus.Success */.yB.Success) return route1;
    return route1.totalAmountOut > route2.totalAmountOut ? route1 : route2;
}
/**
 * @param {RPool}pools 
 * @return {RPool}
 */ function deduplicatePools(pools) {
    const poolMap = new Map();
    pools.forEach((p)=>{
        const chId0 = p.token0.chainId || 0;
        const chId1 = p.token1.chainId || 0;
        const chainInfo = chId0 < chId1 ? "_".concat(chId0, "_").concat(chId1) : "_".concat(chId1, "_").concat(chId0);
        poolMap.set(p.address + chainInfo, p);
    });
    return Array.from(poolMap.values());
}
/**
 * @param {RToken}from 
 * @param {RToken}to 
 * @param {BigNumber | number}amountIn 
 * @param {RPool[]}pools 
 * @param {RToken | NetworkInfo[]}baseTokenOrNetworks 
 * @param {number}gasPrice 
 * @param {number | number[]}flows 
 * @return {MultiRoute}
 */ function findMultiRouteExactIn(from, to, amountIn, pools, baseTokenOrNetworks, gasPrice, flows) {
    var ref;
    pools = deduplicatePools(pools);
    checkChainId(pools, baseTokenOrNetworks);
    (0,entities/* setTokenId */.tH)(from, to);
    const g = new Graph_Graph(pools, from, baseTokenOrNetworks, gasPrice);
    if (flows !== undefined) return g.findBestRouteExactIn(from, to, amountIn, flows);
    const outSingle = g.findBestRouteExactIn(from, to, amountIn, 1);
    // Possible optimization of timing
    // if (g.findBestPathExactIn(from, to, amountIn/100 + 10_000, 0)?.gasSpent === 0) return outSingle
    g.cleanTmpData();
    const bestFlowNumber = calcBestFlowNumber(outSingle, amountIn, (ref = g.getVert(from)) === null || ref === void 0 ? void 0 : ref.gasPrice);
    if (bestFlowNumber === 1) return outSingle;
    const outMulti = g.findBestRouteExactIn(from, to, amountIn, bestFlowNumber);
    return getBetterRouteExactIn(outSingle, outMulti);
}
/**
 * @param {MultiRoute}route1 
 * @param {MultiRoute}route2 
 * @param {number}gasPrice 
 * @return {MultiRoute}
 */ function getBetterRouteExactOut(route1, route2, gasPrice) {
    if (route1.status == RouteStatus.NoWay) return route2;
    if (route2.status == RouteStatus.NoWay) return route1;
    if (route1.status == RouteStatus.Partial && route2.status == RouteStatus.Success) return route2;
    if (route2.status == RouteStatus.Partial && route1.status == RouteStatus.Success) return route1;
    const totalAmountIn1 = route1.amountIn + route1.gasSpent * gasPrice;
    const totalAmountIn2 = route2.amountIn + route2.gasSpent * gasPrice;
    return totalAmountIn1 < totalAmountIn2 ? route1 : route2;
}
/**
 * @param {RToken}from 
 * @param {RToken}to 
 * @param {BigNumber | number}amountOut 
 * @param {RPool[]}pools 
 * @param {RToken | NetworkInfo[]}baseTokenOrNetworks 
 * @param {number}gasPrice 
 * @param {number | number[]}flows 
 * @return {MultiRoute}
 */ function findMultiRouteExactOut(from, to, amountOut, pools, baseTokenOrNetworks, gasPrice, flows) {
    pools = deduplicatePools(pools);
    checkChainId(pools, baseTokenOrNetworks);
    setTokenId(from, to);
    if (amountOut instanceof BigNumber) {
        amountOut = parseInt(amountOut.toString());
    }
    const g = new Graph(pools, from, baseTokenOrNetworks, gasPrice);
    if (flows !== undefined) return g.findBestRouteExactOut(from, to, amountOut, flows);
    const inSingle = g.findBestRouteExactOut(from, to, amountOut, 1);
    // Possible optimization of timing
    // if (g.findBestPathExactOut(from, to, amountOut/100 + 10_000, 0)?.gasSpent === 0) return inSingle
    g.cleanTmpData();
    const fromV = g.getVert(from);
    const bestFlowNumber = calcBestFlowNumber(inSingle, inSingle.amountIn, fromV === null || fromV === void 0 ? void 0 : fromV.gasPrice);
    if (bestFlowNumber === 1) return inSingle;
    const inMulti = g.findBestRouteExactOut(from, to, amountOut, bestFlowNumber);
    return getBetterRouteExactOut(inSingle, inMulti, (fromV === null || fromV === void 0 ? void 0 : fromV.gasPrice) || 0);
}
/**
 * @param {RToken}from 
 * @param {RToken}to 
 * @param {BigNumber | number}amountIn 
 * @param {RPool[]}pools 
 * @param {RToken | NetworkInfo[]}baseTokenOrNetworks 
 * @param {number}gasPrice 
 * @return {MultiRoute}
 */ function findSingleRouteExactIn(from, to, amountIn, pools, baseTokenOrNetworks, gasPrice) {
    pools = deduplicatePools(pools);
    checkChainId(pools, baseTokenOrNetworks);
    setTokenId(from, to);
    const g = new Graph(pools, from, baseTokenOrNetworks, gasPrice);
    const out = g.findBestRouteExactIn(from, to, amountIn, 1);
    return out;
}
/**
 * @param {RToken}from 
 * @param {RToken}to 
 * @param {BigNumber | number}amountOut 
 * @param {RPool[]}pools 
 * @param {RToken | NetworkInfo[]}baseTokenOrNetworks 
 * @param {number}gasPrice 
 * @return {MultiRoute}
 */ function findSingleRouteExactOut(from, to, amountOut, pools, baseTokenOrNetworks, gasPrice) {
    pools = deduplicatePools(pools);
    checkChainId(pools, baseTokenOrNetworks);
    setTokenId(from, to);
    const g = new Graph(pools, from, baseTokenOrNetworks, gasPrice);
    if (amountOut instanceof BigNumber) {
        amountOut = parseInt(amountOut.toString());
    }
    const out = g.findBestRouteExactOut(from, to, amountOut, 1);
    return out;
}
/**
 * @param {RPool[]}pools 
 * @param {RToken}baseToken 
 * @param {number}minPriceLiquidity 
 * @param {boolean}priceLogging 
 * @return {Map<RToken, number>}
 */ function calcTokenPrices(pools, baseToken) {
    let minPriceLiquidity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, priceLogging = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    setTokenId(baseToken);
    const g = new Graph(pools, baseToken, baseToken, 0, minPriceLiquidity, priceLogging);
    const res = new Map();
    g.vertices.forEach((v)=>{
        if (v.price !== 0) res.set(v.token, v.price);
    });
    return res;
}
// Checks correctness of ChainId of each token in each network
// Could be avoided for speed of work, but helps to find out difficult to catch bugs
/**
 * @param {RPool[]}pools 
 * @param {RToken | NetworkInfo[]}baseTokenOrNetworks 
 */ function checkChainId(pools, baseTokenOrNetworks) {
    if (baseTokenOrNetworks instanceof Array) {
        baseTokenOrNetworks.forEach((n)=>{
            if (n.chainId !== n.baseToken.chainId) {
                throw new Error("Chain '".concat(n.chainId, "' has baseToken with '").concat(n.baseToken.chainId, "' that are not the same"));
            }
        });
    }
    const chainIds = baseTokenOrNetworks instanceof Array ? baseTokenOrNetworks.map((n)=>n.chainId) : [
        baseTokenOrNetworks.chainId
    ];
    const chainIdSet = new Set(chainIds);
    const checkToken = (t)=>{
        if (!chainIdSet.has(t.chainId)) {
            throw new Error("Token ".concat(t.name, "/").concat(t.address, " chainId='").concat(t.chainId, "' is not in list of possible chains: [").concat(chainIds.join(", "), "]"));
        }
    };
    pools.forEach((p)=>{
        checkToken(p.token0);
        checkToken(p.token1);
    });
}

;// CONCATENATED MODULE: ./src/classes/TinesToRouteProcessor2.ts

var TokenType;
(function(TokenType) {
    TokenType["NATIVE"] = "NATIVE";
    TokenType["ERC20"] = "ERC20";
})(TokenType || (TokenType = {}));
/**
 * @param {RToken}token 
 * @return {TokenType}
 */ function getTokenType(token) {
    if (token.address == "") return TokenType.NATIVE;
    return TokenType.ERC20;
}
/**
 * 
 */ class TinesToRouteProcessor2 {
    /**
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @param {PermitData[]}permits
   * @return {string}
   */ getRouteProcessorCode(route, toAddress) {
        let permits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        // 0. Check for no route
        if (route.status == entities/* RouteStatus.NoWay */.yB.NoWay || route.legs.length == 0) return "";
        // this.presendedLegs = new Set()
        this.calcTokenOutputLegs(route);
        let res = "0x";
        res += this.processPermits(permits);
        const processedTokens = new Set();
        route.legs.forEach((l, i)=>{
            const token = l.tokenFrom;
            if (processedTokens.has(token.tokenId)) return;
            processedTokens.add(token.tokenId);
            if (i > 0) {
                if (token.address === "") throw new Error("unexpected native inside the route: " + token.symbol);
                if (this.isOnePoolOptimization(token, route)) res += this.processOnePoolCode(token, route, toAddress);
                else if (getTokenType(token) == TokenType.ERC20) res += this.processERC20Code(true, token, route, toAddress);
            // else res += this.processBentoCode(token, route, toAddress)
            } else {
                if (token.address == "") res += this.processNativeCode(token, route, toAddress);
                else res += this.processERC20Code(false, token, route, toAddress);
            }
        });
        return res;
    }
    /**
   * @param {PermitData[]}permits
   * @return {string}
   */ processPermits(permits) {
        const hex = new entities/* HEXer */.Fk();
        permits.forEach((p)=>{
            hex.uint8(5) // applyPermit commandCode
            .uint(p.value).uint(p.deadline).uint8(p.v).bytes32(p.r).bytes32(p.s);
        });
        return hex.toString();
    }
    /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */ processNativeCode(token, route, toAddress) {
        const outputLegs = this.tokenOutputLegs.get(token.tokenId);
        if (!outputLegs || outputLegs.length !== 1) {
            throw new Error("Not 1 output pool for native token: " + (outputLegs === null || outputLegs === void 0 ? void 0 : outputLegs.length));
        }
        const hex = new entities/* HEXer */.Fk().uint8(3) // processNative commandCode
        .uint8(outputLegs.length);
        outputLegs.forEach((l)=>{
            hex.share16(l.swapPortion).hexData(this.swapCode(l, route, toAddress));
        });
        return hex.toString();
    }
    /**
   * @param {boolean}fromMe
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */ processERC20Code(fromMe, token, route, toAddress) {
        const outputLegs = this.tokenOutputLegs.get(token.tokenId);
        if (!outputLegs || outputLegs.length == 0) {
            throw new Error("No output legs for token " + token.symbol);
        }
        const hex = new entities/* HEXer */.Fk().uint8(fromMe ? 1 : 2) // processMyERC20 : processUserERC20 commandCode
        .address(token.address).uint8(outputLegs.length);
        outputLegs.forEach((l)=>{
            hex.share16(l.swapPortion).hexData(this.swapCode(l, route, toAddress));
        });
        return hex.toString();
    }
    /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */ processOnePoolCode(token, route, toAddress) {
        const outputLegs = this.tokenOutputLegs.get(token.tokenId);
        if (!outputLegs || outputLegs.length != 1) {
            throw new Error("1 output leg expected " + (outputLegs === null || outputLegs === void 0 ? void 0 : outputLegs.length));
        }
        const hex = new entities/* HEXer */.Fk().uint8(4) // processOnePool commandCode
        .address(token.address).hexData(this.swapCode(outputLegs[0], route, toAddress));
        return hex.toString();
    }
    /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */ processBentoCode(token, route, toAddress) {
        const outputLegs = this.tokenOutputLegs.get(token.tokenId);
        if (!outputLegs || outputLegs.length == 0) {
            throw new Error("No output legs for token " + (outputLegs === null || outputLegs === void 0 ? void 0 : outputLegs.length));
        }
        const hex = new entities/* HEXer */.Fk().uint8(5) // processInsideBento commandCode
        .address(token.address).uint8(outputLegs.length);
        outputLegs.forEach((l)=>{
            hex.share16(l.swapPortion).hexData(this.swapCode(l, route, toAddress));
        });
        return hex.toString();
    }
    /**
   * @param {RouteLeg}leg
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */ swapCode(leg, route, toAddress) {
        const pc = this.getPoolCode(leg);
        const to = this.getPoolOutputAddress(leg, route, toAddress);
        return pc.getSwapCodeForRouteProcessor2(leg, route, to) // , this.presendedLegs.has(leg))
        ;
    }
    /**
   * @param {RouteLeg}l
   * @param {MultiRoute}route
   * @param {string}toAddress
   * @return {string}
   */ getPoolOutputAddress(l, route, toAddress) {
        let outAddress;
        const outputDistribution = this.tokenOutputLegs.get(l.tokenTo.tokenId) || [];
        if (outputDistribution.length == 0) {
            outAddress = toAddress;
        } else if (outputDistribution.length == 1) {
            outAddress = this.getPoolCode(outputDistribution[0]).getStartPoint(l, route);
            if (outAddress == entities/* PoolCode.RouteProcessorAddress */.TG.RouteProcessorAddress) outAddress = this.routeProcessorAddress;
        // else this.presendedLegs.add(outputDistribution[0])
        } else {
            outAddress = this.routeProcessorAddress;
        }
        return outAddress;
    }
    /**
   * @param {RToken}token
   * @param {MultiRoute}route
   * @return {boolean}
   */ isOnePoolOptimization(token, route) {
        const outputDistribution = this.tokenOutputLegs.get(token.tokenId) || [];
        if (outputDistribution.length != 1) return false;
        const startPoint = this.getPoolCode(outputDistribution[0]).getStartPoint(outputDistribution[0], route);
        return startPoint == outputDistribution[0].poolAddress;
    }
    /**
   * @param {RouteLeg} l
   * @return {PoolCode}
   */ getPoolCode(l) {
        const pc = this.pools.get(l.poolAddress);
        if (pc === undefined) {
            throw new Error("unknown pool: ".concat(l.poolAddress));
        }
        return pc;
    }
    /**
   * @param {MultiRoute}route
   */ calcTokenOutputLegs(route) {
        const res = new Map();
        route.legs.forEach((l)=>{
            var ref;
            const tokenId = (ref = l.tokenFrom.tokenId) === null || ref === void 0 ? void 0 : ref.toString();
            if (tokenId === undefined) {
                console.assert(0, "Unseted tokenId");
            } else {
                const legsOutput = res.get(tokenId) || [];
                legsOutput.push(l);
                res.set(tokenId, legsOutput);
            }
        });
        this.tokenOutputLegs = res;
    }
    // presendedLegs: Set<RouteLeg> = new Set()
    /**
   *
   * @param {string}routeProcessorAddress
   * @param {ChainId}chainId
   * @param {Map<string, PoolCode>}pools
   */ constructor(routeProcessorAddress, chainId, pools){
        this.tokenOutputLegs = new Map();
        this.routeProcessorAddress = routeProcessorAddress;
        this.chainId = chainId;
        this.pools = pools;
    }
}
/**
 * @param {MultiRoute}route 
 * @param {string}routeProcessorAddress 
 * @param {string}toAddress 
 * @param {Map<string, PoolCode>}pools 
 * @param {PermitData[]}permits 
 * @return {string}
 */ function getRouteProcessor2Code(route, routeProcessorAddress, toAddress, pools) {
    let permits = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
    const rpc = new TinesToRouteProcessor2(routeProcessorAddress, route.fromToken.chainId, pools);
    return rpc.getRouteProcessorCode(route, toAddress, permits);
}

;// CONCATENATED MODULE: ./src/classes/Router.ts






/**
 *
 */ class Router {
    /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {ChainId}chainId
   * @param {Type}fromToken
   * @param {BigNumber}amountIn
   * @param {Type}toToken
   * @param {number}gasPrice
   * @return {MultiRoute}
   */ static findSushiRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice) {
        return Router.findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice, [
            entities/* LiquidityProviders.NativeWrap */.Dm.NativeWrap,
            entities/* LiquidityProviders.SushiSwapV2 */.Dm.SushiSwapV2,
            entities/* LiquidityProviders.SushiSwapV3 */.Dm.SushiSwapV3
        ]);
    }
    /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {ChainId}chainId
   * @param {Type}fromToken
   * @param {BigNumber}amountIn
   * @param {Type}toToken
   * @param {number}gasPrice
   * @param {number} maxPriceImpact
   * @return {MultiRoute}
   */ static findSpecialRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice) {
        let maxPriceImpact = arguments.length > 6 && arguments[6] !== void 0 // 10%
         ? arguments[6] : 10;
        // Find preferrable route
        const preferrableRoute = Router.findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice, [
            entities/* LiquidityProviders.NativeWrap */.Dm.NativeWrap,
            entities/* LiquidityProviders.MistSwapV2 */.Dm.MistSwapV2,
            entities/* LiquidityProviders.SushiSwapV3 */.Dm.SushiSwapV3,
            entities/* LiquidityProviders.EmberSwapV2 */.Dm.EmberSwapV2,
            entities/* LiquidityProviders.UniswapV3 */.Dm.UniswapV3
        ]);
        // If the route is successful and the price impact is less than maxPriceImpact, then return the route
        if (preferrableRoute.status === entities/* RouteStatus.Success */.yB.Success && preferrableRoute.priceImpact !== undefined && preferrableRoute.priceImpact < maxPriceImpact / 100) {
            return preferrableRoute;
        }
        // Otherwise, find the route using all possible liquidity providers
        return Router.findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice);
    }
    /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {ChainId}chainId
   * @param {Type}fromToken
   * @param {BigNumber}amountIn
   * @param {Type}toToken
   * @param {number}gasPrice
   * @param {LiquidityProviders[]} providers
   * @param {PoolFilter} poolFilter
   * @return {MultiRoute}
   */ static findBestRoute(poolCodesMap, chainId, fromToken, amountIn, toToken, gasPrice, providers, poolFilter) {
        const networks = [
            {
                chainId: chainId,
                baseToken: constants/* WNATIVE */.FX[chainId],
                gasPrice: gasPrice
            }
        ];
        let poolCodes = Array.from(poolCodesMap.values());
        if (providers) {
            poolCodes = poolCodes.filter((pc)=>[
                    ...providers,
                    entities/* LiquidityProviders.NativeWrap */.Dm.NativeWrap
                ].includes(pc.liquidityProvider));
        }
        let pools = Array.from(poolCodes).map((pc)=>pc.pool);
        if (poolFilter) pools = pools.filter(poolFilter);
        const route = findMultiRouteExactIn(fromToken, toToken, amountIn, pools, networks, gasPrice);
        var ref, ref1;
        return {
            ...route,
            legs: route.legs.map((l)=>{
                var ref2, ref3;
                return {
                    ...l,
                    poolName: (ref = (ref2 = poolCodesMap.get(l.poolAddress)) === null || ref2 === void 0 ? void 0 : ref2.poolName) !== null && ref !== void 0 ? ref : "Unknown Pool",
                    exchangeUri: (ref1 = (ref3 = poolCodesMap.get(l.poolAddress)) === null || ref3 === void 0 ? void 0 : ref3.exchangeUri) !== null && ref1 !== void 0 ? ref1 : "/images/utils/unknown.png"
                };
            })
        };
    }
    /**
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {MultiRoute}route
   * @param {Type}fromToken
   * @param {Type}toToken
   * @param {string}to
   * @param {string}RPAddr
   * @param {PermitData[]} permits
   * @param {number} maxPriceImpact
   * @return {RPParams}
   */ static routeProcessor2Params(poolCodesMap, route, fromToken, toToken, to, RPAddr) {
        let permits = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : [], maxPriceImpact = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0.005;
        const tokenIn = !fromToken.isNative ? fromToken.wrapped.address : "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
        const tokenOut = !toToken.isNative ? toToken.wrapped.address : "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
        const amountOutMin = BigInt(route.amountOutBN.mul((0,functions/* getBigNumber */.Xq)((1 - maxPriceImpact) * 1000000)).div(1000000).toString());
        return [
            tokenIn,
            BigInt(route.amountInBN.toString()),
            tokenOut,
            amountOutMin,
            to,
            getRouteProcessor2Code(route, RPAddr, to, poolCodesMap, permits)
        ];
    }
    /** Human-readable route printing
   * @param {Map<string, PoolCode>}poolCodesMap
   * @param {MultiRoute}route
   * @param {Type}fromToken
   * @param {Type}toToken
   * @param {string}shiftPrimary
   * @param {string}shiftSub
   * @return {string}
   */ static routeToHumanString(poolCodesMap, route, fromToken, toToken) {
        let shiftPrimary = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", shiftSub = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "    ";
        let res = "";
        res += shiftPrimary + "Route Status: " + route.status + "\n";
        res += shiftPrimary + "Input: ".concat(route.amountIn / Math.pow(10, fromToken.decimals), " ").concat(fromToken.symbol, "\n");
        route.legs.forEach((l, i)=>{
            var ref;
            res += shiftSub + "".concat(i + 1, ". ").concat(l.tokenFrom.symbol, " ").concat(Math.round(l.absolutePortion * 100), "%") + " -> [".concat((ref = poolCodesMap.get(l.poolAddress)) === null || ref === void 0 ? void 0 : ref.poolName, "] -> ").concat(l.tokenTo.symbol, "\n");
        // console.log(l.poolAddress, l.assumedAmountIn, l.assumedAmountOut)
        });
        const output = parseInt(route.amountOutBN.toString()) / Math.pow(10, toToken.decimals);
        res += shiftPrimary + "Output: ".concat(output, " ").concat(route.toToken.symbol);
        return res;
    }
}
/**
 * @param {Type}token
 * @param {BigNumber}amount
 * @return {string}
 */ function tokenQuantityString(token, amount) {
    const denominator = BigNumber.from(10).pow(token.decimals);
    const integer = amount.div(denominator);
    const fractional = amount.sub(integer.mul(denominator));
    if (fractional.isZero()) return "".concat(integer, " ").concat(token.symbol);
    const paddedFractional = fractional.toString().padStart(token.decimals, "0");
    return "".concat(integer, ".").concat(paddedFractional, " ").concat(token.symbol);
}

// EXTERNAL MODULE: ./node_modules/lodash.flatmap/index.js
var lodash_flatmap = __webpack_require__(78661);
var lodash_flatmap_default = /*#__PURE__*/__webpack_require__.n(lodash_flatmap);
;// CONCATENATED MODULE: ./src/functions/getCurrencyCombinations.ts


/**
 * @param {number} chainId
 * @param {Type} currencyA
 * @param {Type} currencyB
 * @param {'auto' | 'custom'} pathType
 * @param {Token[]} custom
 * @return {Type}
 */ function getCurrencyCombinations(chainId, currencyA, currencyB, pathType, custom) {
    var ref, ref1;
    const [tokenA, tokenB] = chainId ? [
        currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped,
        currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped
    ] : [
        undefined,
        undefined
    ];
    const common = chainId in constants/* BASES_TO_CHECK_TRADES_AGAINST */.lM && pathType === "auto" ? constants/* BASES_TO_CHECK_TRADES_AGAINST */.lM[chainId] : [];
    var ref2;
    const additionalA = tokenA && pathType === "auto" ? (ref2 = (ref = constants/* ADDITIONAL_BASES */.ck[chainId]) === null || ref === void 0 ? void 0 : ref[tokenA.address]) !== null && ref2 !== void 0 ? ref2 : [] : [];
    var ref3;
    const additionalB = tokenB && pathType === "auto" ? (ref3 = (ref1 = constants/* ADDITIONAL_BASES */.ck[chainId]) === null || ref1 === void 0 ? void 0 : ref1[tokenB.address]) !== null && ref3 !== void 0 ? ref3 : [] : [];
    const _custom = pathType === "custom" && custom ? custom : [];
    const bases = [
        ...common,
        ...additionalA,
        ...additionalB,
        ..._custom
    ];
    const basePairs = lodash_flatmap_default()(bases, (base)=>bases.map((otherBase)=>[
                base,
                otherBase
            ]));
    if (!tokenA || !tokenB) {
        return [];
    }
    return [
        // the direct pair
        [
            tokenA,
            tokenB
        ],
        // token A against all bases
        ...bases.map((base)=>[
                tokenA,
                base
            ]),
        // token B against all bases
        ...bases.map((base)=>[
                tokenB,
                base
            ]),
        // each base against all bases
        ...basePairs
    ].filter((tokens)=>Boolean(tokens[0] && tokens[1])).filter((param)=>{
        let [t0, t1] = param;
        return t0.address !== t1.address;
    }).filter((param)=>{
        let [tokenA, tokenB] = param;
        if (!chainId) return true;
        const customBases = constants/* CUSTOM_BASES */.IP[chainId];
        const customBasesA = customBases === null || customBases === void 0 ? void 0 : customBases[tokenA.address];
        const customBasesB = customBases === null || customBases === void 0 ? void 0 : customBases[tokenB.address];
        if (!customBasesA && !customBasesB) return true;
        if (customBasesA && !customBasesA.find((base)=>tokenB.equals(base))) return false;
        if (customBasesB && !customBasesB.find((base)=>tokenA.equals(base))) return false;
        return true;
    });
}

;// CONCATENATED MODULE: ./src/hooks/useCurrencyCombinations.ts


/**
 * @param {number}chainId
 * @param {Type}currencyA
 * @param {Type}currencyB
 * @param {'auto'|'custom'} pathType
 * @param {Token[]} custom
 * @return {[Token, Token][]}
 */ function useCurrencyCombinations(chainId, currencyA, currencyB, pathType, custom) {
    return (0,react.useMemo)(()=>chainId ? getCurrencyCombinations(chainId, currencyA, currencyB, pathType, custom) : [], [
        chainId,
        currencyA,
        currencyB,
        custom,
        pathType
    ]);
}

// EXTERNAL MODULE: ./node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(19485);
// EXTERNAL MODULE: ./node_modules/@ethersproject/solidity/lib.esm/index.js + 3 modules
var solidity_lib_esm = __webpack_require__(88218);
;// CONCATENATED MODULE: ./src/classes/pools/ConstantProductPool.ts

/**
 *
 */ class ConstantProductPoolCode extends entities/* PoolCode */.TG {
    /**
   * @param {RouteLeg}leg
   * @param {MultiRoute}_route
   * @param {string}to
   * @return {string}
   */ getSwapCodeForRouteProcessor2(leg, _route, to) {
        const code = new entities/* HEXer */.Fk().uint8(0) // uniV2 pool
        .address(this.pool.address).bool(leg.tokenFrom.address == this.pool.token0.address).address(to)// .bool(presended)
        .toString();
        return code;
    }
    /**
   * @param {ConstantProductRPool}pool
   * @param {LiquidityProviders}liquidityProvider
   * @param {string}providerName
   * @param {string} exchangeUri
   */ constructor(pool, liquidityProvider, providerName, exchangeUri){
        super(pool, liquidityProvider, "".concat(providerName, " ").concat(((pool === null || pool === void 0 ? void 0 : pool.fee) || 0) * 100, "%"), exchangeUri);
    }
}

;// CONCATENATED MODULE: ./src/classes/pools/NativeWrapBridge.ts

const exchangeUri = "https://raw.githubusercontent.com/emberswap/assets/master/blockchains/smartbch/assets/0x6BAbf5277849265b6738e75AEC43AEfdde0Ce88D/logo.png";
/**
 *
 */ class NativeWrapBridgePoolCode extends entities/* PoolCode */.TG {
    /**
   * @return {string}
   */ getStartPoint() {
        return entities/* PoolCode.RouteProcessorAddress */.TG.RouteProcessorAddress;
    }
    /**
   * @param {RouteLeg}leg
   * @param {MultiRoute}_route
   * @param {string}to
   * @return {string}
   */ getSwapCodeForRouteProcessor2(leg, _route, to) {
        if (leg.tokenFrom.tokenId == this.pool.token0.tokenId) {
            // wrap - deposit
            const code = new entities/* HEXer */.Fk().uint8(2) // wrapNative pool type
            .uint8(1) // wrap action
            .address(to) // where to transfer native coin after unwrapping
            .address(this.pool.address) // wrap token
            .toString();
            return code;
        } else {
            // unwrap - withdraw
            const code1 = new entities/* HEXer */.Fk().uint8(2) // wrapNative pool type
            .uint8(0) // unwrap action
            .address(to) // where to transfer native coin after unwrapping
            // .address(this.pool.address) - don't need because processToken knows the token
            .toString();
            return code1;
        }
    }
    /**
   * @param {BridgeUnlimited}pool
   * @param {LiquidityProviders}liquidityProvider
   */ constructor(pool, liquidityProvider){
        super(pool, liquidityProvider, "EmberSwap", exchangeUri);
    }
}

;// CONCATENATED MODULE: ./src/constants/abis/emberPair.ts
const emberPair = [
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "spender",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "Approval",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "sender",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount0",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount1",
                "type": "uint256"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            }
        ],
        "name": "Burn",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "sender",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount0",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount1",
                "type": "uint256"
            }
        ],
        "name": "Mint",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "sender",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount0In",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount1In",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount0Out",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount1Out",
                "type": "uint256"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            }
        ],
        "name": "Swap",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint112",
                "name": "reserve0",
                "type": "uint112"
            },
            {
                "indexed": false,
                "internalType": "uint112",
                "name": "reserve1",
                "type": "uint112"
            }
        ],
        "name": "Sync",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "DOMAIN_SEPARATOR",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "",
                "type": "bytes32"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "MINIMUM_LIQUIDITY",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "PERMIT_TYPEHASH",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "",
                "type": "bytes32"
            }
        ],
        "payable": false,
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "spender",
                "type": "address"
            }
        ],
        "name": "allowance",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "spender",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            }
        ],
        "name": "burn",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "amount0",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "amount1",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "decimals",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "payable": false,
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "factory",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "getReserves",
        "outputs": [
            {
                "internalType": "uint112",
                "name": "reserve0",
                "type": "uint112"
            },
            {
                "internalType": "uint112",
                "name": "reserve1",
                "type": "uint112"
            },
            {
                "internalType": "uint32",
                "name": "blockTimestampLast",
                "type": "uint32"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "initialize",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "kLast",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            }
        ],
        "name": "mint",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "liquidity",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "payable": false,
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "nonces",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "spender",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "deadline",
                "type": "uint256"
            },
            {
                "internalType": "uint8",
                "name": "v",
                "type": "uint8"
            },
            {
                "internalType": "bytes32",
                "name": "r",
                "type": "bytes32"
            },
            {
                "internalType": "bytes32",
                "name": "s",
                "type": "bytes32"
            }
        ],
        "name": "permit",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "price0CumulativeLast",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "price1CumulativeLast",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            }
        ],
        "name": "skim",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "uint256",
                "name": "amount0Out",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "amount1Out",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "swap",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "symbol",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "payable": false,
        "stateMutability": "pure",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [],
        "name": "sync",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "token0",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "token1",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "transfer",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "transferFrom",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
];

;// CONCATENATED MODULE: ./src/hooks/usePairs.ts










/**
 * Computes a pair address
 * @param {string}factoryAddress The Uniswap V3 factory address
 * @param {Token}tokenA The first token of the pair, irrespective of sort order
 * @param {Token}tokenB The second token of the pair, irrespective of sort order
 * @param {string}initCodeHashManualOverride Override the init code hash used to compute the pool address if necessary
 * @return {string} The pair address
 */ const computePairAddress = (param)=>{
    let { tokenA , tokenB , factoryAddress , initCodeHashManualOverride  } = param;
    const [token0, token1] = tokenA.sortsBefore(tokenB) ? [
        tokenA,
        tokenB
    ] : [
        tokenB,
        tokenA
    ] // does safety checks
    ;
    return (0,lib_esm/* getCreate2Address */.hB)(factoryAddress !== null && factoryAddress !== void 0 ? factoryAddress : constants/* FACTORY_ADDRESS */.F1[token0.chainId], (0,solidity_lib_esm/* keccak256 */.wn)([
        "bytes"
    ], [
        (0,solidity_lib_esm/* pack */.P2)([
            "address",
            "address"
        ], [
            token0.address,
            token1.address
        ])
    ]), initCodeHashManualOverride !== null && initCodeHashManualOverride !== void 0 ? initCodeHashManualOverride : constants/* INIT_CODE_HASH */.bc[token0.chainId]);
};
var PairState;
(function(PairState) {
    PairState[PairState["LOADING"] = 0] = "LOADING";
    PairState[PairState["NOT_EXISTS"] = 1] = "NOT_EXISTS";
    PairState[PairState["EXISTS"] = 2] = "EXISTS";
    PairState[PairState["INVALID"] = 3] = "INVALID";
})(PairState || (PairState = {}));
/**
 * @param {number | undefined}chainId
 * @param {[Currency, Currency][]}currencies
 * @param {UniswapV2BaseProvider[]} liquidityProviders
 * @return {[Token[], Token[], Record<string | number, _contracts>[]]}
 */ function getPairs(chainId, currencies, liquidityProviders) {
    const filtered = currencies.filter((currencies)=>{
        const [currencyA, currencyB] = currencies;
        return Boolean(currencyA && currencyB && currencyA.chainId === currencyB.chainId && !currencyA.wrapped.equals(currencyB.wrapped) && constants/* FACTORY_ADDRESS */.F1[currencyA.chainId]);
    });
    const [tokensA, tokensB] = filtered.reduce((acc, param)=>{
        let [currencyA, currencyB] = param;
        acc[0].push(currencyA.wrapped);
        acc[1].push(currencyB.wrapped);
        return acc;
    }, [
        [],
        []
    ]);
    const contracts = new Map();
    for(let i = 0; i < liquidityProviders.length; i++){
        contracts.set(liquidityProviders[i].factory, filtered.map((param)=>{
            let [currencyA, currencyB] = param;
            return {
                chainId,
                address: computePairAddress({
                    tokenA: currencyA.wrapped,
                    tokenB: currencyB.wrapped,
                    factoryAddress: liquidityProviders[i].factory,
                    initCodeHashManualOverride: liquidityProviders[i].initCodeHash
                }),
                abi: emberPair,
                functionName: "getReserves"
            };
        }));
    }
    return [
        tokensA,
        tokensB,
        contracts
    ];
}
/**
 * @param {number | undefined}chainId
 * @param {[Currency, Currency][]}currencies
 * @param {UniswapV2BaseProvider[]}   liquidityProviders
 * @param {Omit<NonNullable<UseContractReadsConfig>, 'contracts'>}config
 * @return {UsePairsReturn}
 */ function usePairs(chainId, currencies, liquidityProviders, config) {
    const [tokensA, tokensB, contracts] = (0,react.useMemo)(()=>getPairs(chainId, currencies, liquidityProviders), [
        chainId,
        currencies,
        liquidityProviders
    ]);
    const _contracts = (0,react.useMemo)(()=>Array.from(contracts.values()).flat(), [
        contracts
    ]);
    const { data , isLoading , isError  } = (0,dist/* useContractReads */.Dm)({
        contracts: _contracts,
        enabled: (config === null || config === void 0 ? void 0 : config.enabled) !== undefined ? config.enabled && _contracts.length > 0 : _contracts.length > 0,
        watch: !(typeof (config === null || config === void 0 ? void 0 : config.enabled) !== undefined && !(config === null || config === void 0 ? void 0 : config.enabled))
    });
    return (0,react.useMemo)(()=>{
        const tMap = new Map();
        const native = entities/* Native.onChain */._r.onChain(chainId ? chainId : 10000);
        const nativeRToken = {
            address: "",
            name: native.name,
            symbol: native.symbol,
            chainId: chainId,
            decimals: 18
        };
        const bridge = new entities/* BridgeUnlimited */.Yl(constants/* WNATIVE_ADDRESS */.df[chainId ? chainId : 10000], nativeRToken, constants/* WNATIVE */.FX[chainId ? chainId : 10000], 0, 50000);
        tMap.set(bridge.address, new NativeWrapBridgePoolCode(bridge, entities/* LiquidityProviders.NativeWrap */.Dm.NativeWrap));
        let z = 0;
        if (_contracts.length === 0 || !chainId) return {
            isLoading,
            isError,
            data: undefined
        };
        if (!data) return {
            isLoading,
            isError,
            data: undefined
        };
        let index = 0;
        data.map((result, i)=>{
            var ref, ref1;
            if (index >= tokensA.length) {
                z++;
                index = 0;
            }
            const tokenA = tokensA[index];
            const tokenB = tokensB[index];
            index++;
            if (!tokenA || !tokenB || tokenA.equals(tokenB)) return undefined;
            if (!result) return undefined;
            const reserve0 = result === null || result === void 0 ? void 0 : (ref = result.result) === null || ref === void 0 ? void 0 : ref[0];
            const reserve1 = result === null || result === void 0 ? void 0 : (ref1 = result.result) === null || ref1 === void 0 ? void 0 : ref1[1];
            const [token0, token1] = tokenA.sortsBefore(tokenB) ? [
                tokenA,
                tokenB
            ] : [
                tokenB,
                tokenA
            ];
            const rPool = new entities/* ConstantProductRPool */.zx(_contracts[i].address, token0, token1, liquidityProviders[z].fee, reserve0 ? bignumber/* BigNumber.from */.O$.from(reserve0) : bignumber/* BigNumber.from */.O$.from(0), reserve1 ? bignumber/* BigNumber.from */.O$.from(reserve1) : bignumber/* BigNumber.from */.O$.from(0));
            const pc = new ConstantProductPoolCode(rPool, liquidityProviders[z].getType(), liquidityProviders[z].getPoolProviderName(), liquidityProviders[z].getPoolProviderURI());
            tMap.set(_contracts[i].address, pc);
            return tMap;
        });
        return {
            isLoading,
            isError,
            data: tMap
        };
    }, [
        _contracts,
        chainId,
        data,
        isError,
        isLoading,
        liquidityProviders,
        tokensA,
        tokensB
    ]);
} // interface UsePairReturn {
 //   isLoading: boolean
 //   isError: boolean
 //   data: [PairState, Pair | null]
 // }
 /**
 * @param {number}chainId
 * @param {Exchange[]} exchanges
 * @param {Currency}tokenA
 * @param {Currency}tokenB
 * @param {Omit<UseContractReadsConfig, 'contracts'>}config
 * @return {UsePairReturn}
 */  // export function usePair(
 //   chainId: number,
 //   exchanges: Exchange[],
 //   tokenA?: Currency,
 //   tokenB?: Currency,
 //   config?: Omit<UseContractReadsConfig, 'contracts'>
 // ): UsePairReturn {
 //   const inputs: [[Currency | undefined, Currency | undefined]] = useMemo(
 //     () => [[tokenA, tokenB]],
 //     [tokenA, tokenB]
 //   )
 //   const { data, isLoading, isError } = usePairs(chainId, inputs, exchanges, config)
 // 
 //   return useMemo(
 //     () => ({
 //       isLoading,
 //       isError,
 //       data: data?.[0],
 //     }),
 //     [data, isError, isLoading]
 //   )
 // }

;// CONCATENATED MODULE: ./src/hooks/useTrade.ts













const AMM_ENABLED_NETWORKS = [
    enums/* ChainId.SMARTBCH */.a_.SMARTBCH,
    enums/* ChainId.SMARTBCH_TESTNET */.a_.SMARTBCH_TESTNET,
    enums/* ChainId.BSC */.a_.BSC,
    enums/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET
];
/**
 * @param {number | undefined} chainId
 * @param {TradeType.EXACT_INPUT | TradeType.EXACT_OUTPUT} tradeType whether we request an exact output amount or we provide an exact input amount
 * @param {Amount<Currency>} amountSpecified the exact amount to swap in/out
 * @param {Currency} mainCurrency the desired input/payment currency
 * @param {Currency} otherCurrency the desired output/payment currency
 * @param {Record<number, Record<string, TokenAsObject>>} userPath the desired path through Aggregator.
 * @param {Token[]} _tokenMap
 * @param {'auto'|'custom'} pathType whether pathing should be automated or using custom mid tokens.
 * @return {UseTradeOutput} Returns trade for a desired swap.
 */ function useTrade(chainId, tradeType, amountSpecified, mainCurrency, otherCurrency) {
    const { data: feeData  } = (0,dist/* useFeeData */.LK)({
        chainId
    });
    const [customTokensMap] = (0,user_hooks/* useCustomTokens */.Xd)(chainId);
    const tokenMap = useTokens(chainId);
    const _tokenMap = (0,react.useMemo)(()=>Object.values({
            ...tokenMap,
            ...customTokensMap
        }), [
        tokenMap,
        customTokensMap
    ]);
    const [{ userPath , userPathType , userExpertMode  }] = (0,user_hooks/* useSettings */.rV)(chainId);
    const [currencyIn, currencyOut] = (0,react.useMemo)(()=>tradeType === enums/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? [
            mainCurrency,
            otherCurrency
        ] : [
            otherCurrency,
            mainCurrency
        ], [
        tradeType,
        mainCurrency,
        otherCurrency
    ]);
    const _midAddresses = (0,react.useMemo)(()=>{
        const path = userExpertMode && (userPath === null || userPath === void 0 ? void 0 : userPath[chainId]) ? Object.values(userPath[chainId]).map((token)=>token.address).filter((address)=>{
            return address != (otherCurrency === null || otherCurrency === void 0 ? void 0 : otherCurrency.wrapped.address);
        }).sort((a, b)=>{
            if (a === entities/* Native.onChain */._r.onChain(chainId).wrapped.address) {
                return 1 // a should be placed after b
                ;
            }
            if (b === entities/* Native.onChain */._r.onChain(chainId).wrapped.address) {
                return -1 // b should be placed after a
                ;
            }
            return a.localeCompare(b) // sort in alphabetical order
            ;
        }) : [
            ""
        ];
        return _tokenMap === null || _tokenMap === void 0 ? void 0 : _tokenMap.filter((t)=>{
            return path === null || path === void 0 ? void 0 : path.some((a)=>a.toLowerCase() == t.wrapped.address.toLowerCase());
        });
    }, [
        _tokenMap,
        chainId,
        otherCurrency === null || otherCurrency === void 0 ? void 0 : otherCurrency.wrapped.address,
        userExpertMode,
        userPath
    ]);
    // Generate currency combinations of input and output token based on configured bases
    const currencyCombinations = useCurrencyCombinations(chainId, currencyIn, currencyOut, userExpertMode ? userPathType : "auto", _midAddresses);
    const providers = [
        new EmberSwapV2Provider(chainId),
        new MistSwapV2Provider(chainId)
    ];
    // Legacy SushiSwap pairs
    const { data: pairs  } = usePairs(chainId, currencyCombinations, providers, {
        enabled: Boolean(chainId && AMM_ENABLED_NETWORKS.includes(chainId))
    });
    return (0,react.useMemo)(()=>{
        if (feeData && feeData.gasPrice && currencyIn && currencyOut && currencyIn.wrapped.chainId === currencyOut.wrapped.chainId && currencyIn.wrapped.chainId === chainId && currencyOut.wrapped.chainId === chainId && currencyIn.wrapped.address !== currencyOut.wrapped.address && chainId && amountSpecified && amountSpecified.greaterThan(0) && otherCurrency && pairs && pairs.size > 0) {
            if (chainId in constants/* FACTORY_ADDRESS */.F1) {
                var ref;
                const bestRoute = Router.findBestRoute(pairs, chainId, currencyIn, bignumber/* BigNumber.from */.O$.from(amountSpecified.quotient.toString()), currencyOut, (ref = Number(feeData.gasPrice)) !== null && ref !== void 0 ? ref : 30e9);
                return {
                    trade: entities/* Trade.exactIn */.ho.exactIn(bestRoute, amountSpecified, currencyOut, enums/* Version.V1 */.Gf.V1),
                    route: bestRoute,
                    pairs: pairs
                };
            }
        }
        return {
            trade: undefined,
            route: undefined,
            pairs: undefined
        };
    }, [
        feeData,
        currencyIn,
        currencyOut,
        chainId,
        amountSpecified,
        otherCurrency,
        pairs
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useRouters.ts





/**
 * @param {number | undefined}chainId
 * @return {Contract | null}
 */ function useRouters(chainId) {
    const walletClient = useProviderOrSigner();
    return (0,react.useMemo)(()=>{
        if (chainId && walletClient && AMM_ENABLED_NETWORKS.includes(chainId)) {
            return (0,chunk_LAFZBYO7/* getContract */.uN)({
                ...getRouterProcessorContractConfig(chainId),
                walletClient: walletClient ? walletClient : undefined
            });
        } else return undefined;
    }, [
        chainId,
        walletClient
    ]);
}

// EXTERNAL MODULE: ./src/constants/abis/multicall2.ts
var multicall2 = __webpack_require__(5378);
;// CONCATENATED MODULE: ./src/hooks/useMulticall3Contract.ts




const getMulticall3ContractConfig = (chainId)=>({
        address: chainId ? constants/* MULTICALL2_ADDRESS */.Ph[chainId] : constants_address/* zeroAddress */.D,
        abi: multicall2/* multicall2Abi */.a
    });
/**
 * @param {ChainId}chainId 
 * @return {Contract | Null}
 */ function useMulticall3Contract(chainId) {
    return getContract({
        ...getMulticall3ContractConfig(chainId)
    });
}

;// CONCATENATED MODULE: ./src/hooks/useCurrentBlockTimestamp.ts


// TODO: Readd direct export, not sure why it's not working
const useCurrentBlockTimestamp = function(chainId) {
    let enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const { data  } = (0,dist/* useContractRead */["do"])({
        ...getMulticall3ContractConfig(chainId),
        functionName: "getCurrentBlockTimestamp",
        enabled,
        watch: true,
        keepPreviousData: true
    });
    return {
        data
    };
};

;// CONCATENATED MODULE: ./src/hooks/useTransactionDeadline.ts




const useTransactionDeadline = function(chainId) {
    let enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const { data: blockTimestamp  } = useCurrentBlockTimestamp(chainId, enabled);
    const [{ userDeadline: ttl , userDeadlineType  }] = (0,user_hooks/* useSettings */.rV)();
    return (0,react.useMemo)(()=>{
        if (blockTimestamp && ttl) {
            if (userDeadlineType === "custom") return blockTimestamp + BigInt(ttl);
            return blockTimestamp + BigInt(src_constants/* DEFAULT_DEADLINE_FROM_NOW */.P);
        }
        return undefined;
    }, [
        blockTimestamp,
        ttl,
        userDeadlineType
    ]);
};

;// CONCATENATED MODULE: ./src/components/TradeProvider.tsx



const Context = /*#__PURE__*/ (0,react.createContext)(undefined);
const TradeProvider = (param)=>{
    let { chainId , tradeType , amountSpecified , mainCurrency , otherCurrency , children  } = param;
    // const _mainCurrency = useMemo(
    //   () => (chainId && chainId === ChainId.CELO ? mainCurrency?.wrapped : mainCurrency),
    //   [chainId, mainCurrency]
    // )
    // const _otherCurrency = useMemo(
    //   () => (chainId && chainId === ChainId.CELO ? otherCurrency?.wrapped : otherCurrency),
    //   [chainId, otherCurrency]
    // )
    // const _amountSpecified = useMemo(
    //   () =>
    //     chainId === ChainId.CELO && amountSpecified
    //       ? Amount.fromRawAmount(amountSpecified.currency.wrapped, amountSpecified.quotient)
    //       : amountSpecified,
    //   [chainId, amountSpecified]
    // )
    const { trade , route , pairs  } = useTrade(chainId, tradeType, amountSpecified, mainCurrency, otherCurrency);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: (0,react.useMemo)(()=>({
                /* mainCurrency, otherCurrency,*/ trade,
                route,
                pairs,
                isError: false,
                isLoading: false
            }), [
            trade,
            route,
            pairs
        ]),
        children: children
    });
};
const TradeProvider_useTrade = ()=>{
    const context = (0,react.useContext)(Context);
    if (!context) {
        throw new Error("Hook can only be used inside Pool Position Staked Context");
    }
    return context;
};

;// CONCATENATED MODULE: ./src/components/TradeExecuteProvider.tsx














const TradeExecuteProvider = (param)=>{
    let { chainId , signature , onSuccess , approved , children , recipient  } = param;
    const { address: account  } = (0,dist/* useAccount */.mA)();
    const { trade , pairs  } = TradeProvider_useTrade();
    const publicClient = (0,dist/* usePublicClient */.t_)({
        chainId
    });
    const [, { createNotification  }] = (0,user_hooks/* useNotifications */.zn)(account);
    const deadline = useTransactionDeadline(chainId, approved);
    // const inputCurrencyRebase = useBentoBoxTotal(chainId, trade?.inputAmount.currency)
    // const outputCurrencyRebase = useBentoBoxTotal(chainId, trade?.outputAmount.currency)
    const routeProcessor = useRouters(chainId);
    const [{ userSlippageTolerance , slippageToleranceType  }] = (0,user_hooks/* useSettings */.rV)();
    const allowedSlippage = (0,react.useMemo)(()=>Number(userSlippageTolerance) && slippageToleranceType === "custom" ? +Number(userSlippageTolerance) / 100 : +Number(src_constants/* INITIAL_ALLOWED_SLIPPAGE */.g) / 100, [
        slippageToleranceType,
        userSlippageTolerance
    ]);
    const prepare = (0,react.useCallback)(async (setRequest)=>{
        console.log("Prepare function called wtih setRequest", setRequest);
        // console.log({
        //   trade,
        //   account,
        //   chainId,
        //   deadline,
        //   approved,
        //   routeProcessor,
        //   isV1: trade?.isV1(),
        //   isV2: trade?.isV2(),
        //   isComplex: trade?.isComplex(),
        //   isSingle: trade?.isSingle(),
        //   isNotFound: trade?.isNotFound(),
        // })
        if (!trade || !account || !chainId || !deadline || !approved || !pairs) return;
        try {
            let call = null;
            let value = "0x0";
            if (trade) {
                if (!routeProcessor || !deadline) return;
                const writeArgs = entities/* Router.routeProcessor2Params */.F0.routeProcessor2Params(pairs, trade.route, trade.inputAmount.currency, trade.outputAmount.currency, recipient !== null && recipient !== void 0 ? recipient : account, constants/* ROUTER_PROCESSOR_ADDRESS */.Hp[chainId], [], allowedSlippage);
                // console.log(writeArgs)
                // const test = getRouteProcessorCode(trade.route, account, [],pairs)
                // console.log(test)
                // let writeArgs: UseTradeReturnWriteArgs = args
                // console.log(methodName)
                // console.log(args?.[1]?.[0])
                // console.log(trade.inputAmount.toExact())
                // console.log(args)
                if (trade.inputAmount.currency.isNative) {
                    value = trade.inputAmount.toHex();
                }
                call = {
                    address: routeProcessor.address,
                    calldata: (0,encodeFunctionData/* encodeFunctionData */.R)({
                        abi: routeProcessor.abi,
                        functionName: "processRoute",
                        args: writeArgs
                    }),
                    value
                };
            } // else if (tridentRouter && trade.isV2()) {
            //    if (!tridentRouter || !inputCurrencyRebase || !outputCurrencyRebase) return
            //    const actions = [approveMasterContractAction({ router: tridentRouter, signature })]
            //    if (trade.isSinglePool()) {
            //      actions.push(
            //        tridentRouter.interface.encodeFunctionData('exactInputSingleWithNativeToken', [
            //          {
            //            tokenIn: trade.inputAmount.currency.isNative
            //              ? zeroAddress
            //              : trade.inputAmount.currency.wrapped.address,
            //            amountIn: BigNumber.from(trade.inputAmount.quotient.toString()),
            //            amountOutMinimum: BigNumber.from(
            //              trade.minimumAmountOut(allowedSlippage).toShare(outputCurrencyRebase).quotient.toString()
            //            ),
            //            pool: trade.route.legs[0].poolAddress,
            //            data: defaultAbiCoder.encode(
            //              ['address', 'address', 'bool'],
            //              [
            //                trade.route.legs[0].tokenFrom.address,
            //                trade.outputAmount.currency.isNative ? tridentRouter.address : account,
            //                true,
            //              ]
            //            ),
            //          },
            //        ])
            //      )
            //    } else if (trade.isSingle()) {
            //      actions.push(
            //        tridentRouter.interface.encodeFunctionData('exactInputWithNativeToken', [
            //          {
            //            tokenIn: trade.inputAmount.currency.isNative
            //              ? zeroAddress
            //              : trade.inputAmount.currency.wrapped.address,
            //            amountIn: BigNumber.from(trade.inputAmount.quotient.toString()),
            //            amountOutMinimum: BigNumber.from(
            //              trade.minimumAmountOut(allowedSlippage).toShare(outputCurrencyRebase).quotient.toString()
            //            ),
            //            path: trade.route.legs.map((leg, i) => {
            //              const isLastLeg = i === trade.route.legs.length - 1
            //              return {
            //                pool: leg.poolAddress,
            //                data: defaultAbiCoder.encode(
            //                  ['address', 'address', 'bool'],
            //                  [
            //                    leg.tokenFrom.address,
            //                    isLastLeg
            //                      ? trade.outputAmount.currency.isNative
            //                        ? tridentRouter.address
            //                        : account
            //                      : trade.route.legs[i + 1].poolAddress,
            //                    isLastLeg,
            //                  ]
            //                ),
            //              }
            //            }),
            //          },
            //        ])
            //      )
            //    } else if (trade.isComplex()) {
            //      // complex trade
            //      const initialPathCount = trade.route.legs.filter(
            //        (leg) => leg.tokenFrom.address === trade.inputAmount.currency.wrapped.address
            //      ).length
            //      const [initialPath, percentagePath, output] = trade.route.legs.reduce<
            //        [
            //          {
            //            tokenIn: string
            //            pool: string
            //            native: boolean
            //            amount: BigNumberish
            //            data: string
            //          }[],
            //          {
            //            tokenIn: string
            //            pool: string
            //            balancePercentage: BigNumberish
            //            data: string
            //          }[],
            //          {
            //            token: string
            //            to: string
            //            unwrapBento: boolean
            //            minAmount: BigNumberish
            //          }[]
            //        ]
            //      >(
            //        ([initialPath, percentagePath, output], leg, i) => {
            //          const isInitialPath = leg.tokenFrom.address === trade.inputAmount.currency.wrapped.address
            //          if (isInitialPath) {
            //            return [
            //              [
            //                ...initialPath,
            //                {
            //                  tokenIn: trade.inputAmount.currency.isNative ? zeroAddress : leg.tokenFrom.address,
            //                  pool: leg.poolAddress,
            //                  amount:
            //                    initialPathCount > 1 && i === initialPathCount - 1
            //                      ? BigNumber.from(trade.inputAmount.quotient.toString()).sub(
            //                          initialPath.reduce(
            //                            (previousValue, currentValue) => previousValue.add(currentValue.amount),
            //                            Zero
            //                          )
            //                        )
            //                      : BigNumber.from(trade.inputAmount.quotient.toString())
            //                          .mul(Math.round(leg.absolutePortion * 1e6))
            //                          .div(1e6),
            //                  native: true,
            //                  data: defaultAbiCoder.encode(
            //                    ['address', 'address', 'bool'],
            //                    [
            //                      leg.tokenFrom.address,
            //                      getTridentRouterContractConfig(trade.inputAmount.currency.chainId).address,
            //                      false,
            //                    ]
            //                  ),
            //                },
            //              ],
            //              percentagePath,
            //              output,
            //            ]
            //          } else {
            //            return [
            //              initialPath,
            //              [
            //                ...percentagePath,
            //                {
            //                  tokenIn: leg.tokenFrom.address,
            //                  pool: leg.poolAddress,
            //                  balancePercentage: getBigNumber(leg.swapPortion * 10 ** 8),
            //                  data: defaultAbiCoder.encode(
            //                    ['address', 'address', 'bool'],
            //                    [
            //                      leg.tokenFrom.address,
            //                      getTridentRouterContractConfig(trade.inputAmount.currency.chainId).address,
            //                      false,
            //                    ]
            //                  ),
            //                },
            //              ],
            //              output,
            //            ]
            //          }
            //        },
            //        [
            //          [],
            //          [],
            //          [
            //            {
            //              token: trade.outputAmount.currency.wrapped.address,
            //              to: trade.outputAmount.currency.isNative ? tridentRouter.address : account,
            //              unwrapBento: true,
            //              minAmount: trade
            //                ?.minimumAmountOut(allowedSlippage)
            //                ?.toShare(outputCurrencyRebase)
            //                .quotient.toString(),
            //            },
            //          ],
            //        ]
            //      )
            //      actions.push(
            //        tridentRouter.interface.encodeFunctionData('complexPath', [{ initialPath, percentagePath, output }])
            //      )
            //    }
            //    if (trade.inputAmount.currency.isNative) {
            //      value = trade.inputAmount.toHex()
            //    }
            //    if (trade.outputAmount.currency.isNative) {
            //      // unwrap
            //      actions.push(
            //        unwrapWETHAction({
            //          router: tridentRouter,
            //          recipient: account,
            //        })
            //      )
            //    }
            //    call = {
            //      address: tridentRouter.address,
            //      calldata: batchAction({
            //        contract: tridentRouter,
            //        actions,
            //      }),
            //      value,
            //    }
            //  }
            if (!call) {
                console.log("No call...");
            }
            if (call) {
                if (!(0,isAddress/* isAddress */.U)(call.address)) new Error("call address has to be an address");
                if (call.address === constants_address/* zeroAddress */.D) new Error("call address cannot be zero");
                const tx = !value || (0,src_functions/* isZero */.Fr)(value) ? {
                    account: account,
                    to: call.address,
                    data: call.calldata
                } : {
                    account: account,
                    to: call.address,
                    data: call.calldata,
                    value: BigInt(value)
                };
                console.log({
                    call,
                    tx
                });
                const estimatedCall = await publicClient.estimateGas(tx).then((gasEstimate)=>{
                    return {
                        call,
                        gasEstimate
                    };
                }).catch((gasError)=>{
                    console.debug("Gas estimate failed, trying eth_call to extract error", call);
                    return publicClient.call(tx).then((result)=>{
                        console.debug("Unexpected successful call after failed estimate gas", call, gasError, result);
                        return {
                            call,
                            error: new Error("Unexpected issue with estimating the gas. Please try again.")
                        };
                    }).catch((callError)=>{
                        console.debug("Call threw error", call, callError);
                        return {
                            call,
                            error: new Error(callError)
                        };
                    });
                });
                console.log("About to actually setRequest with...", {
                    ...tx,
                    ..."gasEstimate" in estimatedCall ? {
                        gas: calculateGasMargin(estimatedCall.gasEstimate)
                    } : {}
                });
                setRequest({
                    from: tx.account,
                    ...tx,
                    ..."gasEstimate" in estimatedCall ? {
                        gas: estimatedCall.gasEstimate
                    } : {}
                });
            }
        } catch (e) {
            if (e instanceof rpc/* UserRejectedRequestError */.ab) return;
            console.error(e);
        }
    }, [
        account,
        allowedSlippage,
        approved,
        chainId,
        deadline,
        pairs,
        publicClient,
        routeProcessor,
        trade,
        recipient
    ]);
    const onSettled = (0,react.useCallback)((data)=>{
        if (!trade || !chainId || !data) return;
        const ts = new Date().getTime();
        // data: SendTransactionResult | undefined, error: Error | null
        createNotification({
            type: "swap",
            chainId,
            txHash: data.hash,
            promise: (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                hash: data.hash,
                chainId: chainId
            }),
            summary: {
                pending: "Swapping ".concat(trade.inputAmount.toSignificant(6), " ").concat(trade.inputAmount.currency.symbol, " for ").concat(trade.outputAmount.toSignificant(6), " ").concat(trade.outputAmount.currency.symbol),
                completed: "Successfully swapped ".concat(trade.inputAmount.toSignificant(6), " ").concat(trade.inputAmount.currency.symbol, " for ").concat(trade.outputAmount.toSignificant(6), " ").concat(trade.outputAmount.currency.symbol),
                failed: "Something went wrong when trying to swap ".concat(trade.inputAmount.currency.symbol, " for ").concat(trade.outputAmount.currency.symbol)
            },
            timestamp: ts,
            groupTimestamp: ts
        });
    }, [
        chainId,
        createNotification,
        trade
    ]);
    const { sendTransaction , isLoading: isWritePending  } = useSendTransaction({
        chainId,
        onSettled,
        prepare,
        enabled: trade && (trade.route.status === entities/* RouteStatus.Success */.yB.Success || trade.route.status === entities/* RouteStatus.Partial */.yB.Partial) && approved,
        onSuccess
    });
    console.log({
        sendTransaction,
        enabled: trade && (trade.route.status === entities/* RouteStatus.Success */.yB.Success || trade.route.status === entities/* RouteStatus.Partial */.yB.Partial) && approved
    });
    return children({
        execute: sendTransaction,
        isWritePending
    });
};

// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/constants/numbers.mjs
var numbers = __webpack_require__(84363);
// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/entities/Price.mjs
var Price = __webpack_require__(91008);
;// CONCATENATED MODULE: ./src/hooks/useTokenAmountDollarValues.ts



const useTokenAmountDollarValues = (param)=>{
    let { chainId , amounts  } = param;
    const { data: prices  } = usePrices({
        chainId
    });
    return (0,react.useMemo)(()=>{
        return amounts.map((amount)=>{
            if (!(amount === null || amount === void 0 ? void 0 : amount.greaterThan(constants/* ZERO */.xE)) || !(prices === null || prices === void 0 ? void 0 : prices[amount.currency.wrapped.address])) return 0;
            const price = Number(Number(amount.toExact()) * Number(prices[amount.currency.wrapped.address].toFixed(10)));
            if (isNaN(price) || price < 0.000001) {
                return 0;
            }
            return price;
        });
    }, [
        amounts,
        prices
    ]);
};

// EXTERNAL MODULE: ./src/hooks/useENSName.ts
var useENSName = __webpack_require__(8136);
;// CONCATENATED MODULE: ./src/components/Layout/Account/AddressToEnsResolver.tsx




const AddressToEnsResolver = (param)=>{
    let { children , onSuccess , chainId =enums/* ChainId.SMARTBCH */.a_.SMARTBCH , ...props } = param;
    const result = (0,useENSName/* default */.Z)(props.address);
    // Custom onSuccess callback to send success data with resolved result
    (0,react.useEffect)(()=>{
        if (result.ENSName && onSuccess) onSuccess(result.ENSName);
    }, [
        onSuccess,
        result.ENSName
    ]);
    if (typeof children === "function") {
        return children(result);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Rate.tsx




const Rate = (param)=>{
    let { children , price  } = param;
    var ref;
    const [invert, setInvert] = (0,react.useState)(false);
    const { data: prices  } = usePrices({
        chainId: invert ? price === null || price === void 0 ? void 0 : price.quoteCurrency.chainId : price === null || price === void 0 ? void 0 : price.baseCurrency.chainId
    });
    const usdPrice = price ? prices === null || prices === void 0 ? void 0 : (ref = prices[invert ? price.quoteCurrency.wrapped.address : price.baseCurrency.wrapped.address]) === null || ref === void 0 ? void 0 : ref.toFixed(2) : undefined;
    const content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: invert ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "1 ",
                price === null || price === void 0 ? void 0 : price.invert().baseCurrency.symbol,
                " = ",
                price === null || price === void 0 ? void 0 : price.invert().toSignificant(6),
                " ",
                price === null || price === void 0 ? void 0 : price.invert().quoteCurrency.symbol
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "1 ",
                price === null || price === void 0 ? void 0 : price.baseCurrency.symbol,
                " = ",
                price === null || price === void 0 ? void 0 : price.toSignificant(6),
                " ",
                price === null || price === void 0 ? void 0 : price.quoteCurrency.symbol
            ]
        })
    });
    const toggleInvert = (0,react.useCallback)(()=>{
        setInvert((prevState)=>!prevState);
    }, []);
    if (typeof children === "function") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children({
                invert,
                toggleInvert,
                content,
                usdPrice
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,src_functions/* classNames */.AK)("text-slate-300 hover:text-slate-200 flex justify-between border-t border-opacity-40 border-slate-700"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (0,src_functions/* classNames */.AK)("cursor-pointer h-[36px] flex items-center gap-1 text-xs"),
                children: "Rate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (0,src_functions/* classNames */.AK)("cursor-pointer h-[36px] flex items-center text-xs"),
                children: price ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center h-full gap-1 font-medium",
                    onClick: toggleInvert,
                    children: [
                        content,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-slate-500",
                            children: [
                                "($",
                                usdPrice,
                                ")"
                            ]
                        })
                    ]
                }) : "Enter an amount"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SwapReviewModal/SwapReviewModalBase.tsx












const SwapReviewModalBase = (param)=>{
    let { chainId , children , input0 , input1 , open , setOpen , recipient  } = param;
    const [value0, value1] = useTokenAmountDollarValues({
        chainId,
        amounts: [
            input0,
            input1
        ]
    });
    const price = (0,react.useMemo)(()=>{
        if (!input0 || !input1) return undefined;
        if (!input1.greaterThan(numbers/* ZERO */.xE)) return undefined;
        return new Price/* Price */.t({
            baseAmount: input0,
            quoteAmount: input1
        });
    }, [
        input0,
        input1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog */.V, {
        open: open,
        onClose: ()=>setOpen(false),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.V.Content, {
            className: "max-w-sm !pb-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog.Header */.V.Header, {
                    border: false,
                    title: "Confirm Swap",
                    onClose: ()=>setOpen(false)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "!my-0 grid grid-cols-12 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col col-span-12 gap-1 p-2 border sm:p-4 rounded-2xl bg-slate-700/40 border-slate-200/5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between w-full gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: "font-medium truncate text-slate-50",
                                                children: [
                                                    input0 === null || input0 === void 0 ? void 0 : input0.toSignificant(6),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-end gap-2 text-right",
                                                children: [
                                                    input0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-5 h-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                                            currency: input0.currency,
                                                            width: 20,
                                                            height: 20,
                                                            disableLink: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-medium text-right text-slate-50",
                                                        children: input0 === null || input0 === void 0 ? void 0 : input0.currency.symbol
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium text-slate-500",
                                    children: value0 ? "$".concat(value0.toFixed(2)) : "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center col-span-12 -mt-2.5 -mb-2.5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-0.5 bg-slate-700 border-2 border-slate-800 ring-1 ring-slate-200/5 z-10 rounded-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
                                    width: 18,
                                    height: 18,
                                    className: "text-slate-200"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col col-span-12 gap-1 p-2 border sm:p-4 rounded-2xl bg-slate-700/40 border-slate-200/5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center gap-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between w-full gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-medium truncate text-slate-50 ",
                                                children: input1 === null || input1 === void 0 ? void 0 : input1.toSignificant(6)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-end gap-2 text-right",
                                                children: [
                                                    input1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-5 h-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                                            currency: input1.currency,
                                                            width: 20,
                                                            height: 20
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-medium text-right text-slate-50 ",
                                                        children: input1 === null || input1 === void 0 ? void 0 : input1.currency.symbol
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium text-slate-500",
                                    children: value1 ? "$".concat(value1.toFixed(2)) : ""
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center p-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rate, {
                        price: price,
                        children: (param)=>/*#__PURE__*/ {
                            let { toggleInvert , content , usdPrice  } = param;
                            return (0,jsx_runtime.jsxs)("button", {
                                onClick: ()=>toggleInvert(),
                                className: "flex items-center gap-1 text-sm font-semibold text-slate-100",
                                children: [
                                    content,
                                    " ",
                                    usdPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-normal text-slate-300",
                                        children: [
                                            "($",
                                            usdPrice,
                                            ")"
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                }),
                recipient && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    className: "!py-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List.Control, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List.KeyValue, {
                            title: "Recipient",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressToEnsResolver, {
                                address: recipient,
                                children: (param)=>{
                                    let { loading , ENSName  } = param;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: "#",
                                        className: "flex items-center gap-2 cursor-pointer text-blue",
                                        rel: "noreferrer",
                                        children: loading || !ENSName ? (0,src_functions/* shortenAddress */.Xn)(recipient) : ENSName
                                    });
                                }
                            })
                        })
                    })
                }),
                children
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SwapReviewModal/SwapReviewModal.tsx


// import { useNotifications } from '../../lib/state/storage'





const SwapReviewModalLegacy = (param)=>{
    let { chainId , children , onSuccess , recipient  } = param;
    const { trade  } = TradeProvider_useTrade();
    const [open, setOpen] = (0,react.useState)(false);
    const [signature, setSignature] = (0,react.useState)();
    const [input0, input1] = (0,react.useMemo)(()=>{
        return [
            trade === null || trade === void 0 ? void 0 : trade.inputAmount,
            trade === null || trade === void 0 ? void 0 : trade.outputAmount
        ];
    }, [
        trade === null || trade === void 0 ? void 0 : trade.inputAmount,
        trade === null || trade === void 0 ? void 0 : trade.outputAmount
    ]);
    const onSwapSuccess = (0,react.useCallback)(()=>{
        setSignature(undefined);
        setOpen(false);
        onSuccess();
    }, [
        onSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children({
                setOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapReviewModalBase, {
                recipient: recipient,
                chainId: chainId,
                input0: input0,
                input1: input1,
                open: open,
                setOpen: setOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeExecuteProvider, {
                    /* trade={trade} mainCurrency={mainCurrency} otherCurrency={otherCurrency}*/ chainId: chainId,
                    recipient: recipient,
                    approved: true,
                    signature: signature,
                    onSuccess: onSwapSuccess,
                    children: (param)=>{
                        let { isWritePending , execute  } = param;
                        console.log("sendTransaction function to exec", {
                            sendTrasaction: execute
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "md",
                            "testdata-id": "swap-review-confirm-button",
                            disabled: isWritePending,
                            fullWidth: true,
                            onClick: ()=>{
                                return execute === null || execute === void 0 ? void 0 : execute();
                            },
                            variant: "filled",
                            color: "red",
                            children: isWritePending ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "Confirm Swap",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {})
                                ]
                            }) : "Swap"
                        });
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SwapReviewModal/WrapReviewModal.tsx








const WrapReviewModal = (param)=>{
    let { id , input0 , input1 , wrapType , chainId , children  } = param;
    const { address  } = (0,dist/* useAccount */.mA)();
    const [, { createNotification  }] = (0,user_hooks/* useNotifications */.zn)(address);
    const [open, setOpen] = (0,react.useState)(false);
    const { sendTransaction , isLoading: isWritePending  } = useWrapCallback({
        chainId,
        wrapType,
        onSuccess: (data)=>{
            if (data) {
                setOpen(false);
                createNotification(data);
            }
        },
        amount: input0
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children({
                isWritePending,
                setOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapReviewModalBase, {
                chainId: chainId,
                input0: input0,
                input1: input1,
                open: open,
                setOpen: setOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "md",
                    "testdata-id": "".concat(id, "-confirm-button"),
                    disabled: isWritePending,
                    fullWidth: true,
                    onClick: ()=>{
                        return sendTransaction === null || sendTransaction === void 0 ? void 0 : sendTransaction();
                    },
                    children: isWritePending ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Confirm ",
                            wrapType === WrapType.Wrap ? "Wrap" : "Unwrap",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {})
                        ]
                    }) : wrapType === WrapType.Wrap ? "Wrap" : "Unwrap"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SwapReviewModal/index.ts




;// CONCATENATED MODULE: ./src/functions/trade/warningSeverity.ts


const BIPS_BASE = dist_utils/* JSBI.BigInt */.QA.BigInt(10000);
// used for warning states
const ALLOWED_PRICE_IMPACT_LOW = new entities/* Percent */.gG(dist_utils/* JSBI.BigInt */.QA.BigInt(100), BIPS_BASE) // 1%
;
const ALLOWED_PRICE_IMPACT_MEDIUM = new entities/* Percent */.gG(dist_utils/* JSBI.BigInt */.QA.BigInt(300), BIPS_BASE) // 3%
;
const ALLOWED_PRICE_IMPACT_HIGH = new entities/* Percent */.gG(dist_utils/* JSBI.BigInt */.QA.BigInt(500), BIPS_BASE) // 5%
;
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN = new entities/* Percent */.gG(dist_utils/* JSBI.BigInt */.QA.BigInt(1000), BIPS_BASE) // 10%
;
// for non expert mode disable swaps above this
const BLOCKED_PRICE_IMPACT_NON_EXPERT = new entities/* Percent */.gG(dist_utils/* JSBI.BigInt */.QA.BigInt(1500), BIPS_BASE) // 15%
;
const IMPACT_TIERS = [
    BLOCKED_PRICE_IMPACT_NON_EXPERT,
    ALLOWED_PRICE_IMPACT_HIGH,
    ALLOWED_PRICE_IMPACT_MEDIUM,
    ALLOWED_PRICE_IMPACT_LOW
];
/**
 * @param {Percent | undefined}priceImpact 
 * @return {WarningSeverity}
 */ function warningSeverity(priceImpact) {
    if (!priceImpact) return 4;
    let impact = IMPACT_TIERS.length;
    for (const impactLevel of IMPACT_TIERS){
        if (impactLevel.lessThan(priceImpact)) return impact;
        impact--;
    }
    return 0;
}

;// CONCATENATED MODULE: ./src/components/SwapButton/SwapButton.tsx









const SButton = (param)=>{
    let { recipient , userExpertMode , recipientActive , userSlippageTolerance , slippageToleranceType , setOpen  } = param;
    var ref;
    const { isLoading: isLoadingTrade , trade , route  } = TradeProvider_useTrade();
    const swapSlippage = (0,react.useMemo)(()=>{
        if (userSlippageTolerance && slippageToleranceType !== "auto") {
            return new entities/* Percent */.gG(Number(userSlippageTolerance) * 100, 10000);
        } else return new entities/* Percent */.gG(100, 10000) // 1%
        ;
    }, [
        slippageToleranceType,
        userSlippageTolerance
    ]);
    const priceImpactSeverity = (0,react.useMemo)(()=>{
        return warningSeverity(trade === null || trade === void 0 ? void 0 : trade.priceImpact);
    }, [
        trade
    ]);
    const priceImpactTooHigh = priceImpactSeverity > 3 && !userExpertMode;
    const onClick = (0,react.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checker.Custom, {
        showGuardIfTrue: !route,
        guard: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            color: "red",
            variant: "outlined",
            fullWidth: true,
            disabled: true,
            size: "md",
            children: "No trade found"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            "testdata-id": "swap-button",
            fullWidth: true,
            onClick: onClick,
            disabled: recipientActive && userExpertMode && !recipient || priceImpactTooHigh || ((ref = trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(swapSlippage)) === null || ref === void 0 ? void 0 : ref.equalTo(constants/* ZERO */.xE)) || Boolean(!trade && priceImpactSeverity > 2 && !userExpertMode),
            size: "md",
            color: priceImpactTooHigh || priceImpactSeverity > 2 ? "red" : "gradient",
            variant: "outlined",
            ...Boolean(!trade && priceImpactSeverity > 2 && !userExpertMode) && {
                title: "Enable expert mode to swap with high price impact"
            },
            children: isLoadingTrade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Dots */.a.Dots, {
                children: "Finding Best Price"
            }) : priceImpactTooHigh ? "High Price Impact" : trade && priceImpactSeverity > 2 ? "Swap Anyway" : "Swap"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SwapButton/index.tsx








const SwapButton = (param)=>{
    let { recipient , onSuccess , recipientActive , chainId , parsedInput0 , parsedInput1 , amounts , isWrap , wrap  } = param;
    const [{ userExpertMode , slippageToleranceType , userSlippageTolerance  }, {}] = (0,user_hooks/* useSettings */.rV)(chainId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid gap-3 p-3 pt-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checker.Connected, {
            fullWidth: true,
            size: "md",
            color: "gray",
            variant: "filled",
            rounded: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checker.Network, {
                fullWidth: true,
                size: "md",
                chainId: chainId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checker.Amounts, {
                    variant: "outlined",
                    color: "green",
                    fullWidth: true,
                    size: "md",
                    amounts: amounts,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checker.ApproveERC20, {
                        onSuccess: onSuccess,
                        id: "approve-erc20",
                        amount: parsedInput0,
                        contract: constants/* ROUTER_PROCESSOR_ADDRESS */.Hp[chainId],
                        children: isWrap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapReviewModal, {
                            id: "swap-wrap-review-modal",
                            chainId: chainId,
                            input0: parsedInput0,
                            input1: parsedInput1,
                            wrapType: wrap ? WrapType.Wrap : WrapType.Unwrap,
                            children: (param)=>{
                                let { isWritePending , setOpen  } = param;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "testdata-id": "open-wrap-review-modal-button",
                                    disabled: isWritePending,
                                    fullWidth: true,
                                    color: "gray",
                                    variant: "filled",
                                    size: "lg",
                                    onClick: ()=>setOpen(true),
                                    children: wrap ? "Wrap" : "Unwrap"
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapReviewModalLegacy, {
                            recipient: recipient,
                            chainId: chainId,
                            onSuccess: onSuccess,
                            children: (param)=>{
                                let { setOpen  } = param;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SButton, {
                                    recipient: recipient,
                                    userExpertMode: userExpertMode,
                                    recipientActive: recipientActive,
                                    userSlippageTolerance: userSlippageTolerance,
                                    slippageToleranceType: slippageToleranceType,
                                    setOpen: setOpen
                                });
                            }
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Chip/index.tsx



const SIZE = {
    default: "h-[24px]",
    sm: "h-5 !text-[10px]",
    lg: "h-12 text-[14px]"
};
const FILLED = {
    default: "bg-gray-700 text-white",
    white: "bg-high-emphesis text-slate-700",
    purple: "bg-purple-500 bg-opacity-20 text-purple-200",
    yellow: "bg-yellow-500 bg-opacity-20 text-yellow-200",
    blue: "bg-blue-500 bg-opacity-20 text-blue-200",
    green: "bg-green-500 bg-opacity-20 text-green-200",
    pink: "bg-pink-500 bg-opacity-20 text-pink-200",
    red: "bg-red-500 bg-opacity-20 text-red-200",
    gray: "bg-white bg-opacity-10 text-slate-300"
};
const VARIANT = {
    filled: FILLED
};
const Chip = (param)=>{
    let { label , color ="default" , variant ="filled" , size ="default" , className ="" , onClick , icon =undefined , opaque , endIcon =/*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {
        width: 12,
        height: 12,
        strokeWidth: 5
    }) , id =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: (0,src_functions/* classNames */.AK)(VARIANT[variant][color], SIZE[size], opaque ? "!bg-opacity-100 !text-slate-900 font-bold" : "", onClick ? "pr-1" : "pr-3", "whitespace-nowrap inline-flex rounded-2xl py-0.5 pl-3 font-medium text-xs leading-5 gap-2 items-center justify-center", className),
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-hidden": "true",
                className: "rounded",
                onClick: onClick,
                children: icon
            }),
            label,
            onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-hidden": "true",
                className: "rounded bg-[rgba(255,255,255,0.12)] hover:bg-[rgba(255,255,255,0.24)] cursor-pointer p-0.5",
                onClick: onClick,
                children: endIcon
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Route.tsx











const tokenFromRToken = (token)=>{
    if (token.address === "" || !token.address) return entities/* Native.onChain */._r.onChain(Number(token.chainId));
    return new entities/* Token */.WU({
        address: token.address,
        symbol: token.symbol,
        chainId: Number(token.chainId),
        decimals: 18
    });
};
// Can render a tines multi route
const Route = (param)=>{
    let { open , setOpen , trade , chainId  } = param;
    var ref, ref1;
    const onClose = (0,react.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const tokenMap = useTokens(chainId);
    const [customTokensMap] = (0,user_hooks/* useCustomTokens */.Xd)(chainId);
    const tokens = (0,react.useMemo)(()=>Object.values({
            ...tokenMap,
            ...customTokensMap
        }), [
        tokenMap,
        customTokensMap
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog */.V, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.V.Content, {
            className: "max-h-[460px] !pb-[20px] overflow-y-auto scroll rounded-xl bg-black/[0.24] p-2 border border-slate-200/10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog.Header */.V.Header, {
                    border: false,
                    title: "Optimized Route",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-4",
                    children: trade === null || trade === void 0 ? void 0 : (ref = trade.route) === null || ref === void 0 ? void 0 : (ref1 = ref.legs) === null || ref1 === void 0 ? void 0 : ref1.map((directPath, i)=>{
                        if (directPath.poolType == "Wrap") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                        }
                        const t0 = tokens.filter((t)=>t.address.toLowerCase() === directPath.tokenFrom.address.toLowerCase());
                        const t1 = tokens.filter((t)=>t.address.toLowerCase() === directPath.tokenTo.address.toLowerCase());
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComplexRoutePath, {
                            trade: trade,
                            poolAddress: directPath.poolAddress,
                            fromToken: (t0 === null || t0 === void 0 ? void 0 : t0[0]) ? t0[0] : tokenFromRToken(directPath.tokenFrom),
                            toToken: (t1 === null || t1 === void 0 ? void 0 : t1[0]) ? t1[0] : tokenFromRToken(directPath.tokenTo),
                            poolType: directPath.poolType,
                            poolFee: directPath.poolFee,
                            portion: directPath.absolutePortion,
                            title: "".concat(directPath.poolName),
                            exchangeUri: directPath.exchangeUri,
                            chainId: chainId
                        }, i);
                    })
                })
            ]
        })
    });
};
const ComplexRoutePath = (param)=>{
    let { trade , poolAddress , fromToken , toToken , poolType , poolFee , portion , title , exchangeUri , chainId  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const ref6 = (0,react.useRef)(null);
    const [width, setWidth] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (ref6.current) {
            setWidth((ref6.current.offsetWidth - 28) * Number(portion));
        }
    }, [
        portion
    ]);
    const fromTokenSymbol = fromToken.name === constants/* WNATIVE */.FX[chainId].name && ((ref = fromToken.name) === null || ref === void 0 ? void 0 : ref.startsWith("Wrapped")) && ((ref1 = fromToken.symbol) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase().startsWith("W")) ? (ref2 = fromToken.symbol) === null || ref2 === void 0 ? void 0 : ref2.slice(1) : fromToken.symbol;
    const toTokenSymbol = toToken.name === constants/* WNATIVE */.FX[chainId].name && ((ref3 = toToken.name) === null || ref3 === void 0 ? void 0 : ref3.startsWith("Wrapped")) && ((ref4 = toToken.symbol) === null || ref4 === void 0 ? void 0 : ref4.toUpperCase().startsWith("W")) ? (ref5 = toToken.symbol) === null || ref5 === void 0 ? void 0 : ref5.slice(1) : toToken.symbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative grid grid-cols-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 z-0 flex items-center pointer-events-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    viewBox: "850 0 300 200",
                    width: "100%",
                    height: "35",
                    className: "text-slate-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                        x1: "0",
                        x2: "3000",
                        y1: "100",
                        y2: "100",
                        stroke: "currentColor",
                        strokeWidth: "20",
                        strokeLinecap: "round",
                        strokeDasharray: "1, 45"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-[10] col-span-5 flex justify-start items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: ref6,
                    className: "relative flex items-center justify-between gap-2 p-2 overflow-hidden border-2 rounded-full border-slate-900 bg-slate-900",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-0 rounded-full pointer-events-none bg-slate-800",
                            style: {
                                width: "calc(28px + ".concat(width, "px)")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-[10] flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                    disableLink: true,
                                    currency: fromToken,
                                    width: 16,
                                    height: 16
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs font-semibold text-slate-200",
                                    children: fromTokenSymbol
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "z-[10] text-slate-400 font-semibold text-xs gap-1",
                            children: [
                                Number(portion * 100).toFixed(2),
                                "%"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-[10] cursor-pointer col-span-1 flex justify-center items-center font-semibold text-xs gap-1 bg-slate-800 text-slate-200 border border-slate-200/10 rounded-full h-[36px] px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                    className: "mt-1 pointer-events-none",
                    button: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: title,
                        width: 20,
                        height: 20,
                        src: exchangeUri
                    }, title),
                    panel: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "flex gap-1.5 items-end text-slate-400 font-semibold text-xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                    color: "gray",
                                    size: "sm",
                                    label: poolType
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                    color: "gray",
                                    size: "sm",
                                    label: "Fee ".concat(poolFee * 100, "%")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                    color: "gray",
                                    size: "sm",
                                    label: title.split(" ")[0]
                                })
                            ]
                        })
                    })
                }, title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-[10] col-span-4 flex justify-end items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-0.5 rounded-full bg-slate-900",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-2 bg-slate-700 h-[36px] rounded-full flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                disableLink: true,
                                currency: toToken,
                                width: 16,
                                height: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs font-semibold text-slate-200",
                                children: toTokenSymbol
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SwapStatsDisclosure/index.tsx













const SwapStatsDisclosure = (param)=>{
    let { chainId  } = param;
    var ref, ref1, ref2;
    const { trade  } = TradeProvider_useTrade();
    const [showRoute, setShowRoute] = (0,react.useState)(false);
    const [{ userSlippageTolerance , slippageToleranceType  }] = (0,user_hooks/* useSettings */.rV)();
    const swapSlippage = (0,react.useMemo)(()=>{
        if (userSlippageTolerance && slippageToleranceType !== "auto") {
            return new entities/* Percent */.gG(Number(userSlippageTolerance) * 100, 10000);
        } else return new entities/* Percent */.gG(Number(src_constants/* INITIAL_ALLOWED_SLIPPAGE */.g) * 100, 10000) // 0.5%
        ;
    }, [
        slippageToleranceType,
        userSlippageTolerance
    ]);
    const priceImpactSeverity = (0,react.useMemo)(()=>{
        return warningSeverity(trade === null || trade === void 0 ? void 0 : trade.priceImpact);
    }, [
        trade === null || trade === void 0 ? void 0 : trade.priceImpact
    ]);
    const stats = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm text-slate-700",
                children: "Price Impact"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (0,src_functions/* classNames */.AK)(priceImpactSeverity === 2 ? "text-yellow-500" : priceImpactSeverity > 2 ? "text-red-600" : "text-slate-600", "text-right truncate text-sm font-medium"),
                children: [
                    trade === null || trade === void 0 ? void 0 : (ref = trade.priceImpact) === null || ref === void 0 ? void 0 : ref.multiply(-1).toFixed(2),
                    "%"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-2 border-t border-slate-200/5 w-full py-0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm text-slate-700",
                children: "Min. Received"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-sm font-medium text-right truncate text-slate-600",
                children: [
                    (ref1 = trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(swapSlippage)) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6),
                    " ",
                    (ref2 = trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(swapSlippage)) === null || ref2 === void 0 ? void 0 : ref2.currency.symbol
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm text-slate-700",
                children: "Optimized Route"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                onClick: ()=>{
                    (trade === null || trade === void 0 ? void 0 : trade.route.status) !== entities/* RouteStatus.NoWay */.yB.NoWay && setShowRoute((prev)=>!prev);
                },
                className: (0,src_functions/* classNames */.AK)((trade === null || trade === void 0 ? void 0 : trade.route.status) == entities/* RouteStatus.NoWay */.yB.NoWay ? "cursor-not-allowed" : "cursor-pointer", " text-sm font-medium text-right text-slate-800 hover:text-black"),
                children: showRoute ? "Hide" : "Show"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Route, {
                chainId: chainId,
                trade: trade,
                open: showRoute,
                setOpen: setShowRoute
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
            show: !!trade,
            unmount: false,
            className: "p-3 !pb-1 transition-[max-height] overflow-hidden",
            enter: "duration-300 ease-in-out",
            enterFrom: "transform max-h-0",
            enterTo: "transform max-h-[380px]",
            leave: "transition-[max-height] duration-250 ease-in-out",
            leaveFrom: "transform max-h-[380px]",
            leaveTo: "transform max-h-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                children: (param)=>{
                    let { open  } = param;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center bg-white bg-opacity-[0.04] hover:bg-opacity-[0.08] rounded-2xl px-4 mb-4 py-2.5 gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rate, {
                                        price: trade === null || trade === void 0 ? void 0 : trade.executionPrice,
                                        children: (param)=>/*#__PURE__*/ {
                                            let { content , usdPrice , toggleInvert  } = param;
                                            return (0,jsx_runtime.jsxs)("div", {
                                                className: "text-sm text-slate-600 hover:text-slate-500 cursor-pointer flex items-center gap-1 font-semibold tracking-tight h-[36px] truncate",
                                                onClick: toggleInvert,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                        panel: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "grid grid-cols-2 gap-1",
                                                            children: stats
                                                        }),
                                                        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* InformationCircleIcon */.AV, {
                                                            width: 16,
                                                            height: 16
                                                        })
                                                    }),
                                                    " ",
                                                    content,
                                                    " ",
                                                    usdPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "font-medium text-slate-500",
                                                        children: [
                                                            "($",
                                                            usdPrice,
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Button */.p.Button, {
                                        className: "flex items-center justify-end flex-grow cursor-pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
                                            width: 24,
                                            height: 24,
                                            className: (0,src_functions/* classNames */.AK)(open ? "!rotate-180" : "", "rotate-0 transition-[transform] duration-300 ease-in-out delay-200")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                show: open,
                                unmount: false,
                                className: "transition-[max-height] overflow-hidden",
                                enter: "duration-300 ease-in-out",
                                enterFrom: "transform max-h-0",
                                enterTo: "transform max-h-[380px]",
                                leave: "transition-[max-height] duration-250 ease-in-out",
                                leaveFrom: "transform max-h-[380px]",
                                leaveTo: "transform max-h-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                    as: "div",
                                    className: "grid grid-cols-2 gap-1 px-4 py-2 mb-4 border border-slate-200/5 rounded-2xl",
                                    children: stats
                                })
                            })
                        ]
                    });
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Web3Input/Currency.tsx




// import { usePrice } from '@sushiswap/react-query'











const CurrencyInput = (param)=>{
    let { id , disabled , value , onChange , currency , onSelect , chainId , disableMaxButton =false , usdPctChange , className , includeNative =true , loading , currencyLoading , hidePinnedTokens =false , hideSearch =false  } = param;
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const { address  } = (0,dist/* useAccount */.mA)();
    const inputRef = (0,react.useRef)(null);
    const [tokenSelectorOpen, setTokenSelectorOpen] = (0,react.useState)(false);
    const focusInput = (0,react.useCallback)(()=>{
        var ref;
        if (disabled) return;
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        disabled
    ]);
    const handleClose = (0,react.useCallback)(()=>{
        setTokenSelectorOpen(false);
    }, []);
    const isLoading = loading || currencyLoading;
    return (0,react.useMemo)(()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: className,
            onClick: focusInput,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex items-center gap-1",
                    children: [
                        loading && isMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-1 justify-center flex-grow h-[44px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Box, {
                                className: "w-[120px] h-[22px] bg-white/[0.06] rounded-full"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input.Numeric, {
                            "testdata-id": "".concat(id, "-input"),
                            ref: inputRef,
                            variant: "unstyled",
                            disabled: disabled,
                            onUserInput: onChange,
                            className: (0,src_functions/* classNames */.AK)(DEFAULT_INPUT_UNSTYLED, "!text-3xl py-1 text-slate-600 hover:text-slate-700"),
                            value: value,
                            readOnly: disabled
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            ...onSelect && {
                                onClick: (e)=>{
                                    setTokenSelectorOpen(true);
                                    e.stopPropagation();
                                }
                            },
                            "data-testid": "".concat(id, "-button"),
                            className: (0,src_functions/* classNames */.AK)(onSelect ? "shadow-md hover:ring-2" : "cursor-default text-2xl", (currency || loading) && onSelect ? "bg-white bg-opacity-[0.12]" : "", currency || loading ? "ring-slate-500" : "bg-blue ring-blue-700", "h-[36px] text-slate-700 hover:text-slate-600 border border-slate-600/40 transition-all flex flex-row items-center gap-1 text-xl font-semibold rounded-full px-2 py-1"),
                            children: [
                                loading && !currency ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Circle, {
                                            radius: 20,
                                            className: "bg-white/[0.06]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Box, {
                                            className: "w-[60px] h-[20px] bg-white/[0.06]"
                                        })
                                    ]
                                }) : currency ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-5 h-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency/* Currency.Icon */.F.Icon, {
                                                disableLink: true,
                                                currency: currency,
                                                width: 20,
                                                height: 20,
                                                priority: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-0.5 -mr-0.5 select-none",
                                            children: currency.symbol
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-0.5 -mr-0.5 pl-1",
                                    children: "Select"
                                }),
                                onSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-5 h-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
                                        width: 20,
                                        height: 20
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row justify-between h-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePanel, {
                            value: value,
                            currency: currency,
                            usdPctChange: usdPctChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BalancePanel, {
                                id: id,
                                loading: loading,
                                chainId: chainId,
                                account: address,
                                onChange: onChange,
                                currency: currency,
                                disableMaxButton: disableMaxButton
                            })
                        })
                    ]
                }),
                onSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelector, {
                    title: "Select Token",
                    onClose: handleClose,
                    open: tokenSelectorOpen,
                    chainId: chainId,
                    currency: currency,
                    onSelect: onSelect,
                    includeNative: includeNative,
                    hidePinnedTokens: hidePinnedTokens,
                    hideSearch: hideSearch,
                    isLoading: isLoading
                })
            ]
        }), [
        address,
        chainId,
        className,
        currency,
        disableMaxButton,
        disabled,
        focusInput,
        handleClose,
        hidePinnedTokens,
        hideSearch,
        id,
        includeNative,
        isLoading,
        isMounted,
        loading,
        onChange,
        onSelect,
        tokenSelectorOpen,
        usdPctChange,
        value
    ]);
};
const MIN_NATIVE_CURRENCY_FOR_GAS = dist_utils/* JSBI.exponentiate */.QA.exponentiate(dist_utils/* JSBI.BigInt */.QA.BigInt(10), dist_utils/* JSBI.BigInt */.QA.BigInt(14)) // .0001 BCH
;
const BalancePanel = /*#__PURE__*/ (0,react.memo)(function BalancePanel(param) {
    let { id , chainId , account , onChange , currency , disableMaxButton , loading  } = param;
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const { data: balance , isLoading  } = useBalance({
        chainId,
        currency,
        account,
        enabled: Boolean(currency)
    });
    const onClick = (0,react.useCallback)(()=>{
        if (onChange && (balance === null || balance === void 0 ? void 0 : balance.greaterThan(0))) {
            if (balance.currency.isNative && balance.greaterThan(MIN_NATIVE_CURRENCY_FOR_GAS)) {
                const hundred = entities/* Amount.fromRawAmount */.$d.fromRawAmount(entities/* Native.onChain */._r.onChain(balance.currency.chainId), MIN_NATIVE_CURRENCY_FOR_GAS);
                onChange(balance.subtract(hundred).toFixed());
            } else {
                onChange((balance === null || balance === void 0 ? void 0 : balance.greaterThan(0)) ? balance.toFixed() : "");
            }
        }
    }, [
        balance,
        onChange
    ]);
    if ((isLoading || loading) && isMounted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-[24px] w-[60px] flex items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Text, {
                fontSize: "lg",
                className: "bg-white/[0.06] h-[12px] w-full"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        id: "".concat(id, "-balance-button"),
        "data-testid": "".concat(id, "-balance-button"),
        type: "button",
        onClick: onClick,
        className: "py-1 text-xs text-slate-400 hover:text-slate-300",
        disabled: disableMaxButton,
        children: isMounted && balance && (balance === null || balance === void 0 ? void 0 : balance.greaterThan(0)) ? "Balance: ".concat(balance === null || balance === void 0 ? void 0 : balance.toSignificant(12)) : ""
    });
});
const PricePanel = (param)=>{
    let { currency , value , usdPctChange  } = param;
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    const { data: tokenPrices  } = usePrices({
        chainId: currency === null || currency === void 0 ? void 0 : currency.chainId
    });
    const price = currency ? tokenPrices === null || tokenPrices === void 0 ? void 0 : tokenPrices[currency.wrapped.address] : undefined;
    const parsedValue = (0,react.useMemo)(()=>(0,functions/* tryParseAmount */.eo)(value, currency), [
        currency,
        value
    ]);
    if (!tokenPrices && isMounted) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[24px] w-[60px] flex items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton.Box, {
            className: "bg-white/[0.06] h-[12px] w-full"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "py-1 text-xs font-medium select-none text-slate-400",
        children: [
            parsedValue && price && isMounted ? "$".concat(parsedValue.multiply(price.asFraction).toFixed(2)) : "$0.00",
            usdPctChange && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (0,src_functions/* classNames */.AK)(usdPctChange === 0 ? "" : usdPctChange > 0 ? "text-green-500" : usdPctChange < -5 ? "text-red-500" : usdPctChange < -3 ? "text-yellow-500" : "text-slate-500"),
                children: [
                    " ",
                    "".concat(usdPctChange === 0 ? "" : usdPctChange > 0 ? "(+" : "(").concat(usdPctChange === 0 ? "0.00" : usdPctChange === null || usdPctChange === void 0 ? void 0 : usdPctChange.toFixed(2), "%)")
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Web3Input/index.ts

const Web3Input = {
    Currency: CurrencyInput
};

;// CONCATENATED MODULE: ./src/components/Web3Input/CurrencyInput.tsx







const CurrencyInput_CurrencyInput = (param)=>{
    let { id , className ="" , value: _value , onChange , onSelect , currency , chainId , inputType , tradeType , disabled , loading =false , isWrap =false  } = param;
    var ref;
    const { trade  } = TradeProvider_useTrade();
    const { data: prices  } = usePrices({
        chainId
    });
    // If output field and (un)wrapping, set to _value
    let value = inputType === tradeType ? _value : trade ? trade === null || trade === void 0 ? void 0 : (ref = trade.outputAmount) === null || ref === void 0 ? void 0 : ref.toExact() : "";
    value = inputType === enums/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && isWrap ? _value : value;
    // Usd pct change
    const srcTokenPrice = _value && (trade === null || trade === void 0 ? void 0 : trade.inputAmount.currency) ? prices === null || prices === void 0 ? void 0 : prices[trade.inputAmount.currency.wrapped.address] : undefined;
    const dstTokenPrice = _value && (trade === null || trade === void 0 ? void 0 : trade.outputAmount.currency) ? prices === null || prices === void 0 ? void 0 : prices[trade.outputAmount.currency.wrapped.address] : undefined;
    const usdPctChange = (0,react.useMemo)(()=>{
        const inputUSD = _value && (trade === null || trade === void 0 ? void 0 : trade.inputAmount) && srcTokenPrice ? trade.inputAmount.multiply(srcTokenPrice.asFraction) : undefined;
        const outputUSD = _value && (trade === null || trade === void 0 ? void 0 : trade.outputAmount) && dstTokenPrice ? trade.outputAmount.multiply(dstTokenPrice.asFraction) : undefined;
        return inputUSD && outputUSD && (inputUSD === null || inputUSD === void 0 ? void 0 : inputUSD.greaterThan(constants/* ZERO */.xE)) ? (Number(outputUSD === null || outputUSD === void 0 ? void 0 : outputUSD.toExact()) - Number(inputUSD === null || inputUSD === void 0 ? void 0 : inputUSD.toExact())) / Number(inputUSD === null || inputUSD === void 0 ? void 0 : inputUSD.toExact()) * 100 : undefined;
    }, [
        _value,
        dstTokenPrice,
        srcTokenPrice,
        trade
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Web3Input.Currency, {
        id: id,
        className: className,
        value: value,
        onChange: onChange,
        currency: currency,
        onSelect: onSelect,
        chainId: chainId,
        loading: loading,
        disabled: disabled,
        usdPctChange: inputType === enums/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? usdPctChange : undefined
    });
};

// EXTERNAL MODULE: ./src/components/Widget/index.ts + 4 modules
var Widget = __webpack_require__(24425);
;// CONCATENATED MODULE: ./src/pages/swap/index.tsx



























const getDefaultToken1 = (chainId)=>{
    if (chainId in constants/* USDC */.gn) {
        return constants/* USDC */.gn[chainId];
    } else return;
};
/**
 * Swap Page of the Application
 * @param {InferGetServerSidePropsType}initialState
 * @return {JSX.Element}
 */ function Swap() {
    const isMounted = (0,hooks/* useIsMounted */.tm)();
    // eslint-disable-next-line no-unused-vars
    const [chainId, { updateChainId  }] = (0,application_hooks/* useSessionChainId */.or)();
    const tokenMap = useTokens(chainId);
    const [customTokensMap] = (0,user_hooks/* useCustomTokens */.Xd)(chainId);
    const previousChain = (0,hooks/* usePrevious */.D9)(chainId);
    const router = (0,next_router.useRouter)();
    const [recipientActive, setRecipientActive] = (0,react.useState)(false);
    const [{ userExpertMode  }] = (0,user_hooks/* useSettings */.rV)(chainId);
    const [active, , , { chartActive , toLiquidity  }] = (0,chart_hooks/* useActivateChart */.B)();
    // const deadBalance = useBalance({
    //   address: '0x000000000000000000000000000000000000dEaD' as Address,
    //   token: '0x217057A8B0bDEb160829c19243A2E03bfe95555a' as Address,
    //   chainId,
    //   enabled: true,
    //   watch: true,
    // })
    const inputToken = (0,react.useMemo)(()=>{
        if (!chainId || !isMounted || Object.keys(tokenMap).length === 0) return;
        const inputCurrency = router.query["inputCurrency"];
        if (inputCurrency && inputCurrency in tokenMap) return tokenMap[inputCurrency];
        if (inputCurrency && inputCurrency.toLowerCase() in customTokensMap) return customTokensMap[inputCurrency.toLowerCase()];
        if (inputCurrency && inputCurrency.toLowerCase() === entities/* Native.onChain */._r.onChain(chainId).symbol.toLowerCase()) return entities/* Native.onChain */._r.onChain(chainId);
        return entities/* Native.onChain */._r.onChain(chainId);
    }, [
        chainId,
        customTokensMap,
        isMounted,
        router.query,
        tokenMap
    ]);
    const outputToken = (0,react.useMemo)(()=>{
        if (!chainId || !isMounted || Object.keys(tokenMap).length === 0) return;
        const outputCurrency = router.query["outputCurrency"];
        if (outputCurrency && outputCurrency in tokenMap) return tokenMap[outputCurrency];
        if (outputCurrency && outputCurrency.toLowerCase() in customTokensMap) return customTokensMap[outputCurrency.toLowerCase()];
        if (outputCurrency && outputCurrency.toLowerCase() === entities/* Native.onChain */._r.onChain(chainId).symbol.toLowerCase()) return entities/* Native.onChain */._r.onChain(chainId);
        if (tokenMap && constants/* EMBER_ADDRESS */.zv[chainId] && Object.values(tokenMap).filter((t)=>t.address === constants/* EMBER_ADDRESS */.zv[chainId])) return Object.values(tokenMap).filter((t)=>t.address === constants/* EMBER_ADDRESS */.zv[chainId]).at(0);
        return getDefaultToken1(chainId);
    }, [
        chainId,
        customTokensMap,
        isMounted,
        router.query,
        tokenMap
    ]);
    const [[token0, token1], setTokens] = (0,react.useState)([
        inputToken,
        outputToken
    ]);
    const [input0, setInput0] = (0,react.useState)(!isNaN(Number(router.query["input0"])) ? router.query["input0"] : "");
    const [input1, setInput1] = (0,react.useState)("");
    const [tradeType, setTradeType] = (0,react.useState)(enums/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT);
    const wrap = Boolean(token0 && token1 && token0.isNative && token1.equals(entities/* Native.onChain */._r.onChain(token1.chainId).wrapped));
    const unwrap = Boolean(token0 && token1 && token1.isNative && token0.equals(entities/* Native.onChain */._r.onChain(token0.chainId).wrapped));
    const isWrap = wrap || unwrap;
    const [parsedInput0, parsedInput1] = (0,react.useMemo)(()=>{
        return [
            (0,functions/* tryParseAmount */.eo)(input0, token0),
            (0,functions/* tryParseAmount */.eo)(isWrap ? input0 : input1, token1)
        ];
    }, [
        input0,
        input1,
        isWrap,
        token0,
        token1
    ]);
    const amounts = (0,react.useMemo)(()=>[
            parsedInput0
        ], [
        parsedInput0
    ]);
    const checkIfImportedTokens = (0,react.useMemo)(()=>{
        const tokens = [];
        const inputCurrency = router.query["inputCurrency"];
        const outputCurrency = router.query["outputCurrency"];
        const rChainId = !isNaN(Number(router.query["chainId"])) ? Number(router.query["chainId"]) : chainId;
        if (inputCurrency && (0,isAddress/* isAddress */.U)(inputCurrency)) tokens.push({
            address: inputCurrency,
            chainId: rChainId
        });
        if (outputCurrency && (0,isAddress/* isAddress */.U)(outputCurrency)) tokens.push({
            address: outputCurrency,
            chainId: rChainId
        });
        return tokens;
    }, [
        chainId,
        router.query
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (previousChain && chainId !== previousChain && chainId !== Number(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.chainId)) {
            // Clear up the query string if user changes network
            // whilst there is a chainId parameter in the query...
            delete router.query["chainId"];
            delete router.query["inputCurrency"];
            delete router.query["outputCurrency"];
            delete router.query["input0"];
            void router.replace({
                pathname: router.pathname,
                query: router.query
            }, undefined);
        }
        // Always do navigations after the first render
        // localhost:1337/swap?chainId=10001&inputCurrency=0x217057A8B0bDEb160829c19243A2E03bfe95555a&outputCurrency=BCHT&input0=12212
        // router.replace(`/swap?chainid=${chainId}&inputCurrency={}`, undefined, { shallow: true })
        if ((0,functions/* isChainSupported */.MR)(Number(router.query["chainId"])) && Number(router.query["chainId"]) !== chainId) {
            updateChainId(Number(router.query["chainId"]));
        }
    }, [
        router,
        chainId,
        previousChain,
        updateChainId
    ]);
    (0,react.useEffect)(()=>{
        setTokens([
            inputToken,
            outputToken
        ]);
        setInput0(!isNaN(Number(router.query["input0"])) ? router.query["input0"] : "");
        setInput1("");
    }, [
        inputToken,
        outputToken,
        router.query
    ]);
    const onInput0 = (0,react.useCallback)((val)=>{
        setTradeType(enums/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT);
        setInput0(val);
    }, []);
    const onInput1 = (0,react.useCallback)((val)=>{
        setTradeType(enums/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT);
        setInput1(val);
    }, []);
    const _setToken0 = (0,react.useCallback)((currency)=>{
        setTokens((param)=>{
            let [prevSrc, prevDst] = param;
            return prevDst && currency.equals(prevDst) ? [
                prevDst,
                prevSrc
            ] : [
                currency,
                prevDst
            ];
        });
    }, []);
    const _setToken1 = (0,react.useCallback)((currency)=>{
        setTokens((param)=>{
            let [prevSrc, prevDst] = param;
            return prevSrc && currency.equals(prevSrc) ? [
                prevDst,
                prevSrc
            ] : [
                prevSrc,
                currency
            ];
        });
    }, []);
    const onSuccess = (0,react.useCallback)(()=>{
        setInput0("");
        setInput1("");
    }, []);
    const switchCurrencies = (0,react.useCallback)(()=>{
        // setInput1(TradeType.EXACT_INPUT && parsedInput0 ? parsedInput0?.toExact() : '')
        setTokens((param)=>{
            let [prevSrc, prevDst] = param;
            return [
                prevDst,
                prevSrc
            ];
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TokenListImportChecker, {
        chainId: chainId,
        tokens: checkIfImportedTokens,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Swap | EmberSwap"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "EmberSwap"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradeProvider, {
                chainId: chainId,
                tradeType: tradeType,
                amountSpecified: tradeType === enums/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? parsedInput0 : parsedInput1,
                mainCurrency: token0,
                otherCurrency: token1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-screen p-4 max-w-screen",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-wrap flex-shrink-0 w-full max-w-full gap-4 p-4 m-auto z-2 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Chart, {
                                    token: token1,
                                    chainId: chainId
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* Widget */.$, {
                                    className: "h-full flex-[1_1_300px] flex-shrink-0 min-w-[300px] !w-auto backdrop-blur-[1px] bg-swapwidget shadow shadow-shadowcolor",
                                    id: "swap",
                                    maxWidth: 500,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Widget/* Widget.Content */.$.Content, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "p-3 mx-0.5 grid grid-cols-2 items-center pb-4 font-medium mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "http://localhost:1337/swap",
                                                                className: (0,src_functions/* classNames */.AK)(router.pathname.includes("swap") ? "text-slate-800" : "text-slate-600", "decoration-transparent text-sm font-semibold hover:text-slate-500 cursor-pointer"),
                                                                passHref: true,
                                                                children: "Swap"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                onClick: ()=>{
                                                                    toLiquidity(true);
                                                                },
                                                                href: "http://localhost:1337/liquidity",
                                                                className: (0,src_functions/* classNames */.AK)(router.pathname.includes("liquidity") ? "text-slate-800" : "text-slate-600", "decoration-transparent text-sm font-semibold hover:text-slate-500 cursor-pointer"),
                                                                passHref: true,
                                                                children: "Liquidity"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-end ml-3 -mt-1.5",
                                                        children: [
                                                            !active && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                onClick: ()=>chartActive(true),
                                                                className: "gap-x-1 px-2 text-slate-400 hover:text-slate-600 flex cursor-pointer text-xxs items-center p-0 mx-auto! flex-[0_0_auto] flex-wrap select-none border-2 border-transparent flex-shrink-0",
                                                                children: [
                                                                    "Activate Charts",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* MaximizeIcon */.bJ, {
                                                                        width: 24,
                                                                        height: 24,
                                                                        className: "z-20 flex"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsOverlay, {
                                                                userExpertMode: userExpertMode,
                                                                chainId: chainId
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInput_CurrencyInput, {
                                                id: "swap-input-currency0",
                                                className: "p-3",
                                                value: input0,
                                                onChange: onInput0,
                                                currency: token0,
                                                onSelect: _setToken0,
                                                chainId: chainId,
                                                inputType: enums/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT,
                                                tradeType: tradeType,
                                                loading: !token0
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,src_functions/* classNames */.AK)("grid items-center mx-auto grid-cols-1", userExpertMode && !isWrap ? "h-[30px]" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,src_functions/* classNames */.AK)("justify-center relative flex items-center transition  z-10", userExpertMode && !isWrap ? "-mt-[24px] -mb-[72px]" : "-mt-[12px] -mb-[12px]"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            onClick: switchCurrencies,
                                                            className: "group bg-slate-400/50 p-0.5 border-2 border-slate-300/50 transition-all rounded-full hover:ring-2 hover:ring-slate-500 cursor-pointer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "transition-all rotate-0 group-hover:rotate-180 group-hover:delay-200",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronDownIcon */.v4, {
                                                                    width: 16,
                                                                    height: 16
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    userExpertMode && !isWrap && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: ()=>setRecipientActive(!recipientActive),
                                                        className: "flex w-auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "cursor-pointer z-[40] hover:text-slate-300 py-1 text-xs font-medium select-none text-slate-400 -mt-[24px] mb-[4px] ml-[14px] text-start",
                                                            children: !recipientActive ? "+ Add Recipient (Optional)" : "- Remove Recipient"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative border border-slate-600/20 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInput_CurrencyInput, {
                                                        id: "swap-output-currency1",
                                                        // disabled={true}
                                                        className: "p-3",
                                                        value: isWrap ? input0 : input1,
                                                        onChange: onInput1,
                                                        currency: token1,
                                                        onSelect: _setToken1,
                                                        chainId: chainId,
                                                        inputType: enums/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT,
                                                        tradeType: tradeType,
                                                        loading: !token1,
                                                        isWrap: isWrap
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInput, {
                                                        isWrap: isWrap,
                                                        chainId: chainId,
                                                        userExpertMode: userExpertMode,
                                                        recipientActive: recipientActive,
                                                        children: (_recipient)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapStatsDisclosure, {
                                                                        chainId: chainId
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapButton, {
                                                                        recipient: _recipient,
                                                                        onSuccess: onSuccess,
                                                                        recipientActive: recipientActive,
                                                                        chainId: chainId,
                                                                        parsedInput0: parsedInput0,
                                                                        parsedInput1: parsedInput1,
                                                                        amounts: amounts,
                                                                        isWrap: isWrap,
                                                                        wrap: wrap
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastContainer */.Ix, {
                        className: "mt-[30px]"
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [792,556,354,774,888,179], function() { return __webpack_exec__(88055); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);